(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 5687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* unused harmony exports getMagnitude, repeat, setInternalSlot, setMultiInternalSlots, getInternalSlot, getMultiInternalSlots, isLiteralPart, defineProperty, UNICODE_EXTENSION_SEQUENCE_REGEX */
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === 'function') {
        return s.repeat(times);
    }
    var arr = new Array(times);
    for (var i = 0; i < arr.length; i++) {
        arr[i] = s;
    }
    return arr.join('');
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) {
        map.set(pl, Object.create(null));
    }
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        fields[_i - 2] = arguments[_i];
    }
    var slots = map.get(pl);
    if (!slots) {
        throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    }
    return fields.reduce(function (all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === 'literal';
}
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value,
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}


/***/ }),

/***/ 5957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ strategies; },
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};


/***/ }),

/***/ 6096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wD": function() { return /* reexport */ TYPE; },
  "VG": function() { return /* reexport */ isArgumentElement; },
  "rp": function() { return /* reexport */ isDateElement; },
  "Ii": function() { return /* reexport */ isDateTimeSkeleton; },
  "O4": function() { return /* reexport */ isLiteralElement; },
  "uf": function() { return /* reexport */ isNumberElement; },
  "Wh": function() { return /* reexport */ isNumberSkeleton; },
  "Jo": function() { return /* reexport */ isPluralElement; },
  "yx": function() { return /* reexport */ isPoundElement; },
  "Wi": function() { return /* reexport */ isSelectElement; },
  "HI": function() { return /* reexport */ isTagElement; },
  "pe": function() { return /* reexport */ isTimeElement; },
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: SKELETON_TYPE, createLiteralElement, createNumberElement

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/number.js


function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData["001"];
    return hourCycles[0];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a;






var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0,tslib_es6/* __assign */.pi)({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());

/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js




function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = (0,tslib_es6/* __assign */.pi)({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}



/***/ }),

/***/ 8222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ MissingTranslationError; },
/* harmony export */   "OV": function() { return /* binding */ InvalidConfigError; },
/* harmony export */   "Qe": function() { return /* binding */ IntlFormatError; },
/* harmony export */   "Rw": function() { return /* binding */ IntlError; },
/* harmony export */   "X9": function() { return /* binding */ MessageFormatError; },
/* harmony export */   "bc": function() { return /* binding */ IntlErrorCode; },
/* harmony export */   "gb": function() { return /* binding */ MissingDataError; },
/* harmony export */   "wI": function() { return /* binding */ UnsupportedFormatterError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(655);

var IntlErrorCode;
(function (IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception
            ? exception instanceof Error
                ? exception
                : new Error(String(exception))
            : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') {
            // @ts-ignore just so we don't need to declare dep on @types/node
            Error.captureStackTrace(_this, IntlError);
        }
        return _this;
    }
    return IntlError;
}(Error));

var UnsupportedFormatterError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError));

var InvalidConfigError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError));

var MissingDataError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError));

var IntlFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}(IntlError));

var MessageFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError));

var MissingTranslationError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError));



/***/ }),

/***/ 2644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L6": function() { return /* binding */ filterProps; },
/* harmony export */   "Sn": function() { return /* binding */ createIntlCache; },
/* harmony export */   "TB": function() { return /* binding */ getNamedFormat; },
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "ax": function() { return /* binding */ createFormatters; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);
/* harmony import */ var intl_messageformat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6284);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5957);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8222);




function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return allowlist.reduce(function (filtered, name) {
        if (name in props) {
            filtered[name] = props[name];
        }
        else if (name in defaults) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}
var defaultErrorHandler = function (error) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var defaultWarnHandler = function (warning) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler,
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getNumberFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getPluralRules = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (message, locales, overrideFormats, opts) {
            return new intl_messageformat__WEBPACK_IMPORTED_MODULE_2__/* .IntlMessageFormat */ .C(message, locales, overrideFormats, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                } }, (opts || {})));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getRelativeTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getDisplayNames: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) {
        format = formatType[name];
    }
    if (format) {
        return format;
    }
    onError(new _error__WEBPACK_IMPORTED_MODULE_3__/* .UnsupportedFormatterError */ .wI("No ".concat(type, " format named: ").concat(name)));
}


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(9864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 6284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IntlMessageFormat; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6096);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5957);
/* harmony import */ var _formatters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1092);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getDateTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== _formatters__WEBPACK_IMPORTED_MODULE_3__/* .PART_TYPE.literal */ .du.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return (0,_formatters__WEBPACK_IMPORTED_MODULE_3__/* .formatToParts */ .FK)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () { return ({
            locale: _this.resolvedLocale.toString(),
        }); };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .parse */ .Qc;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());



/***/ }),

/***/ 1050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ InvalidValueError; },
/* harmony export */   "HR": function() { return /* binding */ MissingValueError; },
/* harmony export */   "YR": function() { return /* binding */ InvalidValueTypeError; },
/* harmony export */   "jK": function() { return /* binding */ ErrorCode; },
/* harmony export */   "u_": function() { return /* binding */ FormatError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(655);

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));



/***/ }),

/***/ 1092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ formatToParts; },
/* harmony export */   "Gt": function() { return /* binding */ isFormatXMLElementFn; },
/* harmony export */   "du": function() { return /* binding */ PART_TYPE; }
/* harmony export */ });
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6096);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1050);


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPoundElement */ .yx)(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .MissingValueError */ .HR(varName, originalMessage);
        }
        var value = values[varName];
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isArgumentElement */ .VG)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateElement */ .rp)(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTimeElement */ .pe)(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberElement */ .uf)(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberSkeleton */ .Wh)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTagElement */ .HI)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueTypeError */ .YR(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isSelectElement */ .Wi)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPluralElement */ .Jo)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .FormatError */ .u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", _error__WEBPACK_IMPORTED_MODULE_1__/* .ErrorCode.MISSING_INTL_API */ .jK.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}


/***/ }),

/***/ 425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ l; },
/* harmony export */   "f": function() { return /* binding */ h; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
const c=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({setTheme:e=>{},themes:[]}),l=()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(c),d=["light","dark"],u="(prefers-color-scheme: dark)",h=({forcedTheme:t,disableTransitionOnChange:a=!1,enableSystem:m=!0,enableColorScheme:i=!0,storageKey:l="theme",themes:h=["light","dark"],defaultTheme:$=(m?"system":"light"),attribute:p="data-theme",value:T,children:w})=>{const[S,b]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>f(l,$)),[E,k]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>f(l)),x=T?Object.values(T):h,L=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{const n=g(e);k(n),"system"!==S||t||C(n,!1)},[S,t]),I=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(L);I.current=L;const C=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e,t=!0,n=!0)=>{let r=(null==T?void 0:T[e])||e;const o=a&&n?v():null;if(t)try{localStorage.setItem(l,e)}catch(e){}if("system"===e&&m){const e=g();r=(null==T?void 0:T[e])||e}if(n){const e=document.documentElement;"class"===p?(e.classList.remove(...x),e.classList.add(r)):e.setAttribute(p,r),null==o||o()}},[]);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const e=function(){return I.current(...[].slice.call(arguments))},t=window.matchMedia(u);return t.addListener(e),e(t),()=>t.removeListener(e)},[]);const M=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{t?C(e,!0,!1):C(e),b(e)},[t]);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const e=e=>{e.key===l&&M(e.newValue||$)};return window.addEventListener("storage",e),()=>window.removeEventListener("storage",e)},[M]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!i)return;let e=t&&d.includes(t)?t:S&&d.includes(S)?S:"system"===S&&E||null;document.documentElement.style.setProperty("color-scheme",e)},[i,S,E,t]),react__WEBPACK_IMPORTED_MODULE_0__.createElement(c.Provider,{value:{theme:S,setTheme:M,forcedTheme:t,resolvedTheme:"system"===S?E:S,themes:m?[...h,"system"]:h,systemTheme:m?E:void 0}},react__WEBPACK_IMPORTED_MODULE_0__.createElement(y,{forcedTheme:t,storageKey:l,attribute:p,value:T,enableSystem:m,defaultTheme:$,attrs:x}),w)},y=(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(({forcedTheme:t,storageKey:n,attribute:r,enableSystem:o,defaultTheme:s,value:a,attrs:m})=>{const c="class"===r?`var d=document.documentElement.classList;d.remove(${m.map(e=>`'${e}'`).join(",")});`:"var d=document.documentElement;",l=(e,t)=>{e=(null==a?void 0:a[e])||e;const n=t?e:`'${e}'`;return"class"===r?`d.add(${n})`:`d.setAttribute('${r}', ${n})`},d="system"===s;return react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_head__WEBPACK_IMPORTED_MODULE_1___default()),null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("script",t?{key:"next-themes-script",dangerouslySetInnerHTML:{__html:`!function(){${c}${l(t)}}()`}}:o?{key:"next-themes-script",dangerouslySetInnerHTML:{__html:`!function(){try {${c}var e=localStorage.getItem('${n}');${d?"":l(s)+";"}if("system"===e||(!e&&${d})){var t="${u}",m=window.matchMedia(t);m.media!==t||m.matches?${l("dark")}:${l("light")}}else if(e) ${a?`var x=${JSON.stringify(a)};`:""}${l(a?"x[e]":"e",!0)}}catch(e){}}()`}}:{key:"next-themes-script",dangerouslySetInnerHTML:{__html:`!function(){try{${c}var e=localStorage.getItem("${n}");if(e){${a?`var x=${JSON.stringify(a)};`:""}${l(a?"x[e]":"e",!0)}}else{${l(s)};}}catch(t){}}();`}}))},(e,t)=>e.forcedTheme===t.forcedTheme),f=(e,t)=>{if("undefined"==typeof window)return;let n;try{n=localStorage.getItem(e)||void 0}catch(e){}return n||t},v=()=>{const e=document.createElement("style");return e.appendChild(document.createTextNode("*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")),document.head.appendChild(e),()=>{window.getComputedStyle(document.body),setTimeout(()=>{document.head.removeChild(e)},1)}},g=e=>(e||(e=window.matchMedia(u)),e.matches?"dark":"light");


/***/ }),

/***/ 8000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(7294));

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 9470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 2717:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(7294));

var _sideEffect = _interop_require_default(__webpack_require__(1585));

var _ampContext = __webpack_require__(8000);

var _headManagerContext = __webpack_require__(5850);

var _ampMode = __webpack_require__(9470);

var _utils = __webpack_require__(9475);

'client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 1585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(7294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref["delete"](props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 7870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./styles/globals.scss
var globals = __webpack_require__(4831);
// EXTERNAL MODULE: ./node_modules/nextjs-progressbar/dist/index.js
var dist = __webpack_require__(3457);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./content/compiled-locales/en.json
var en_namespaceObject = JSON.parse('{"components.ContributeForm.company.subTitle":[{"type":0,"value":"WANT TO BECOME A PARTNER?"}],"components.ContributeForm.company.title":[{"type":0,"value":"I am a "},{"children":[{"type":0,"value":"company"}],"type":8,"value":"b"}],"components.ContributeForm.developer.subTitle":[{"type":0,"value":"HOW CAN I CONTRIBUTE?"}],"components.ContributeForm.developer.title":[{"type":0,"value":"I am a "},{"children":[{"type":0,"value":"developer"}],"type":8,"value":"b"}],"components.ContributeForm.text":[{"type":0,"value":"Ergo operates on an open model where "},{"children":[{"type":0,"value":"anyone is welcome to contribute."}],"type":8,"value":"b"}],"components.ContributeForm.title":[{"type":0,"value":"Contribute"}],"components.DApps.seeAllProjects":[{"type":0,"value":"SEE ALL PROJECTS"}],"components.Sigmanauts.button":[{"type":0,"value":"READ MORE & APPLY"}],"components.Sigmanauts.button.buttonContribute":[{"type":0,"value":"CONTRIBUTING GUIDELINES"}],"components.Sigmanauts.button.discord":[{"type":0,"value":"JOIN US ON DISCORD"}],"components.Sigmanauts.button.grantsAndBounties":[{"type":0,"value":"GRANTS & BOUNTIES"}],"components.Sigmanauts.button.writeAndReviewCode":[{"type":0,"value":"DIVE INTO ERGO"}],"components.Sigmanauts.formInput.button":[{"type":0,"value":"SEND"}],"components.Sigmanauts.formInput.email":[{"type":0,"value":"E-Mail"}],"components.Sigmanauts.formInput.name":[{"type":0,"value":"Name / Company"}],"components.Sigmanauts.formInput.text":[{"type":0,"value":"Write us your suggestions and ideas, let’s talk!"}],"components.Sigmanauts.subTitle":[{"type":0,"value":"Training programme"}],"components.Sigmanauts.text":[{"type":0,"value":"Apply for the Sigmanaut Training Programme to help shape and grow Ergo. "},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":" Let\'s create grassroots finance."}],"components.Sigmanauts.title":[{"type":0,"value":"Sigmanauts"}],"components.Spotlight.button":[{"type":0,"value":"SEE ALL POSTS"}],"components.Spotlight.title":[{"type":0,"value":"Spotlight"}],"components.autolykos.button":[{"type":0,"value":"MINE ERG"}],"components.autolykos.header":[{"type":0,"value":"AUTOLYKOS"}],"components.autolykos.text":[{"children":[{"type":0,"value":"Autolykos"}],"type":8,"value":"b"},{"type":0,"value":" is the underlying memory-hard ASIC-resistant Proof of Work algorithm oriented towards GPUs."}],"components.autolykos.title":[{"type":0,"value":"The Future of Proof of Work"}],"components.communityHero.subtitle":[{"type":0,"value":"GRASSROOTS FINANCE"}],"components.communityHero.title":[{"type":0,"value":"Community"}],"components.communitySection.communityHero.linkText":[{"type":0,"value":"Contributing"}],"components.communitySection.communityHero.text1":[{"type":0,"value":"Ergo is a decentralised grassroots platform powered by its community."}],"components.communitySection.communityHero.text2":[{"type":0,"value":"Join us on socials to get involved, check out the"}],"components.communitySection.communityHero.text3":[{"type":0,"value":"page for more information"}],"components.dApps.heading":[{"type":0,"value":"DApps"}],"components.discoverErgo.text.1":[{"type":0,"value":"Ergo is a next-generation Proof of Work smart-contract platform that enables new models of financial interaction, underpinned by a safe and rich scripting language built with flexible and powerful Zero-Knowledge proofs (Σ-protocols)."}],"components.discoverHero.button1":[{"type":0,"value":"READ THE DOCS"}],"components.discoverHero.button2":[{"type":0,"value":"LEARN WITH DECO"}],"components.discoverHero.button3":[{"type":0,"value":"READ THE MANIFESTO"}],"components.discoverHero.button4":[{"type":0,"value":"CHECK THE BLOG"}],"components.discoverHero.button5":[{"type":0,"value":"GET SETUP"}],"components.discoverHero.button6":[{"type":0,"value":"VISIT ERGONAUT.SPACE"}],"components.discoverHero.title":[{"type":0,"value":"Discover Ergo"}],"components.documents.description":[{"type":0,"value":"Ergo takes a research-based approach and uses stable well-tested solutions to provide a robust platform for developers to build on for years to come. Most of Ergo solutions are formalized in papers presented at peer-reviewed conferences and have been widely discussed in the community."}],"components.documents.heading":[{"type":0,"value":"Documents"}],"components.ecosystemHero.title":[{"type":0,"value":"Ecosystem"}],"components.ergoExplorer.button1":[{"type":0,"value":"EXPLORER"}],"components.ergoExplorer.button2":[{"type":0,"value":"ERGO.WATCH"}],"components.ergoRaffle.description":[{"type":0,"value":"ErgoRaffle is a crowdfunding service built on Ergo Platform that enables anyone to raise money for a project. This project can range from a direct donation to a charity, an academic or business plan, or anything you can convince people to part with their hard-earned ERG for! As an added bonus, after finishing the Raffle, a lottery takes place, and one lucky participant wins a set percent of the Raffle as a \\"raffle reward\\"."}],"components.ergoRaffle.heading":[{"type":0,"value":"Ergo Raffle"}],"components.ergofoundation.list1":[{"type":0,"value":"Promoting "},{"children":[{"type":0,"value":"non-breaking development "}],"type":8,"value":"b"},{"type":0,"value":" of Ergo Platform protocol;"}],"components.ergofoundation.list2":[{"type":0,"value":"Publicizing the widespread adoption and use of Ergo Platform and its "},{"children":[{"type":0,"value":" native token "}],"type":8,"value":"b"},{"type":0,"value":" (ERG);"}],"components.ergofoundation.list3":[{"type":0,"value":"Developing the "},{"children":[{"type":0,"value":"ecosystem "}],"type":8,"value":"b"},{"type":0,"value":" around the Ergo Platform;"}],"components.ergofoundation.list4":[{"type":0,"value":"Spread the use of Ergo Platform and blockchain technology for "},{"children":[{"type":0,"value":" social good "}],"type":8,"value":"b"},{"type":0,"value":";"}],"components.ergofoundation.list5":[{"type":0,"value":"Uphold "},{"children":[{"type":0,"value":"truly decentralized infrastructure"}],"type":8,"value":"b"},{"type":0,"value":", and;"}],"components.ergofoundation.list6":[{"type":0,"value":"Supporting "},{"children":[{"type":0,"value":"privacy "}],"type":8,"value":"b"},{"type":0,"value":" as a basic human right."}],"components.ergofoundation.title":[{"type":0,"value":"The "},{"children":[{"type":0,"value":"Ergo Foundation"}],"type":8,"value":"b"},{"type":0,"value":" is a community-driven entity focused on"}],"components.exchanges.available":[{"type":0,"value":"Available across popular exchanges and decentralized exchanges."}],"components.exchanges.disclaimer":[{"type":0,"value":"Disclaimer: Exchanges provide highly varying degrees of safety, security, privacy, and control over your funds and information. We highly recommend being custodial of your own funds and using one of the wallet options provided above."}],"components.exchanges.heading":[{"type":0,"value":"BUY, SELL AND TRADE ERGO"}],"components.exchanges.subheading":[{"type":0,"value":"Exchanges"}],"components.explore.description":[{"type":0,"value":"The Ergo Explorer is your interface with the blockchain. Watch every transaction made in real-time. Or, view community curated metrics on ergo.watch."}],"components.explore.heading":[{"type":0,"value":"Explore"}],"components.explore.subheading":[{"type":0,"value":"DIVE INTO THE ERGO SEA OF TRANSACTIONS"}],"components.faq.anyQuestions":[{"type":0,"value":"ANY QUESTIONS?"}],"components.faq.description":[{"type":0,"value":"We’ve compiled some of the most frequently asked questions."}],"components.faq.heading":[{"type":0,"value":"FAQ"}],"components.faq.text.2":[{"type":0,"value":"CAN\'T FIND WHAT "},{"type":1,"value":"breakingLine"},{"type":0,"value":" YOU’RE LOOKING FOR?"}],"components.favorites.button1":[{"type":0,"value":"EXPLORE ERGO RAFFLE"}],"components.getErg.BuyIt.text":[{"type":0,"value":"Available across popular centralized and decentralized exchanges."}],"components.getErg.BuyIt.title":[{"type":0,"value":"Exchanges"}],"components.getErg.MineIt.text":[{"type":0,"value":"Autolykos, an ASIC resistant & fairly mined Proof-of-Work algorithm friendly to common GPUs."}],"components.getErg.MineIt.title":[{"type":0,"value":"Mine it"}],"components.getErg.StoreIt.text":[{"type":0,"value":"Simple and secure non-custodial wallets to keep your ERG safe."}],"components.getErg.StoreIt.title":[{"type":0,"value":"Wallets"}],"components.getErg.UseIt.text":[{"type":0,"value":"Put your ERG to use today in our growing ecosystem"}],"components.getErg.UseIt.title":[{"type":0,"value":"Ecosystem"}],"components.getErg.description":[{"type":0,"value":"There is a rich ecosystem budding on top of Ergo. Whether you are a developer, miner, or investor - we’ve got you covered."}],"components.getErg.title":[{"type":0,"value":"Get ERG"}],"components.grantsAndBounties.button1":[{"type":0,"value":"CONTRIBUTING"}],"components.grantsAndBounties.button2":[{"type":0,"value":"START A RAFFLE"}],"components.grantsAndBounties.button3":[{"type":0,"value":"GET IN TOUCH"}],"components.grantsAndBounties.description":[{"type":0,"value":"In general, anything educative for the community is subject to some bounty even if not specifically listed. We are looking to fund grants for projects that focus on building key ecosystem infrastructure. However, the quickest way to get some funding is to start a Raffle."}],"components.grantsAndBounties.heading":[{"type":0,"value":"Grants & Bounties"}],"components.hallOfFame.description1":[{"type":0,"value":"Ergo was founded with a team who have solid backgrounds in core development with cryptocurrencies and blockchain frameworks including NXT, Scorex, Cardano and Waves. Below are brief biographies for some of the core ERGO team as well as some of the many other developers and community members involved, some of whom are anonymous."}],"components.hallOfFame.description2":[{"type":0,"value":"Ergo is grassroots, and most core team members (and even foundation members) started out as community members. There is a brief description as well as information to read more about the Ergo Foundation at the bottom of this page."}],"components.hallOfFame.tab1":[{"type":0,"value":"CORE"}],"components.hallOfFame.tab2":[{"type":0,"value":"COMMUNITY"}],"components.hallOfFame.tab3":[{"type":0,"value":"FOUNDATION"}],"components.hallOfFame.title":[{"type":0,"value":"Hall Of Fame"}],"components.highlights.title":[{"type":0,"value":"HIGHLIGHTS"}],"components.homeHero.button":[{"type":0,"value":"DIVE IN"}],"components.homeHero.pitchDeckButton":[{"type":0,"value":"PITCH DECK"}],"components.homeHero.text":[{"type":0,"value":"Ergo is a next-generation smart contract platform that ensures the economic freedom of ordinary people through secure, accessible, and decentralized financial tools."}],"components.homeHero.title":[{"type":0,"value":"Powering the Future of Finance"}],"components.homeInfo.blockReward":[{"type":0,"value":"BLOCK REWARD"}],"components.homeInfo.circulatingSupply":[{"type":0,"value":"CIRCULATING SUPPLY"}],"components.homeInfo.hashRate":[{"type":0,"value":"HASH RATE"}],"components.homeInfo.transactionPerDay":[{"type":0,"value":"TRANSACTIONS PER DAY"}],"components.learn.description":[{"type":0,"value":"Start from the basics. What is Ergo? What can you do on Ergo?"}],"components.learn.heading":[{"type":0,"value":"Learn"}],"components.mining.button1":[{"type":0,"value":"DOCUMENTATION"}],"components.mining.button2":[{"type":0,"value":"MINING POOL STATS"}],"components.mining.button3":[{"type":0,"value":"DISCORD"}],"components.mining.button4":[{"type":0,"value":"SUBREDDIT"}],"components.mining.button5":[{"type":0,"value":"MINING BLOG POSTS"}],"components.mining.button6":[{"type":0,"value":"EMISSION & TOKENOMICS"}],"components.mining.calculator.currentBlockReward":[{"type":0,"value":"Current block reward"}],"components.mining.calculator.currentPrice":[{"type":0,"value":"Current price"}],"components.mining.calculator.description":[{"type":0,"value":"Autolykos is the underlying memory-hard ASIC-resistant Proof of Work (PoW) algorithm oriented towards GPUs."}],"components.mining.calculator.hash":[{"type":0,"value":"Your hashrate"}],"components.mining.calculator.networkHashrate":[{"type":0,"value":"Network hashrate"}],"components.mining.calculator.rev":[{"type":0,"value":"Daily revenue"}],"components.mining.calculator.title":[{"type":0,"value":"Mining Calculator"}],"components.mining.minersTitle":[{"type":0,"value":"Miners"}],"components.mining.miningPoolsTitle":[{"type":0,"value":"Mining Pools"}],"components.mining.text.1":[{"type":0,"value":"Ergo mining is based on Autolykos, a fairly launched efficient ASIC-resistant Proof of Work algorithm. Miners can adjust parameters with on-chain voting, with larger changes implemented by a supermajority via a soft-fork. As well as participate in any of the exciting developments such as voting tokens, subpooling, and log-space mining. Ergo focuses on simplicity in the core, with advanced features built on the application layer to create resilient, contractual money."}],"components.mining.text.2":[{"type":0,"value":"Welcome to the future of Proof of Work."}],"components.mining.text.3":[{"type":0,"value":"To get started, check out the community-built Mining Handbook, Documentation or join the mining discussion spaces."}],"components.mining.title":[{"type":0,"value":"Mining"}],"components.news.blog":[{"type":0,"value":"Blog"}],"components.news.latest":[{"type":0,"value":"latest news"}],"components.news.title":[{"type":0,"value":"News"}],"components.ourFavorites.heading":[{"type":0,"value":"OUR FAVORITES"}],"components.ourmission.description":[{"type":0,"value":"Ergo Foundation is committed to organic and non-breaking development of Ergo Platform protocol."}],"components.ourmission.emissionAndTokenomics":[{"type":0,"value":"EMISSION AND TOKENOMICS"}],"components.ourmission.ergofoundation":[{"type":0,"value":"THE ERGO FOUNDATION"}],"components.ourmission.reachus.twitter":[{"type":0,"value":"REACH US ON TWITTER"}],"components.ourmission.subdescription":[{"type":0,"value":"The Ergo Foundation is committed to make efforts to maximize the number of valuable ecosystem developments done in an open-source way with the least permissive license possible."}],"components.ourmission.title":[{"type":0,"value":"Our Mission"}],"components.partners.title":[{"type":0,"value":"Partners"}],"components.roadmap.coinmarketcal":[{"type":0,"value":"VIEW MORE ON COINMARKETCAL"}],"components.roadmap.description":[{"type":0,"value":"Please note that Ergo is a platform. Many of the projects listed below have no formal connection with the Ergo Foundation or each other."}],"components.roadmap.section1.title":[{"type":0,"value":"SO FAR"}],"components.roadmap.section2.title":[{"type":0,"value":"ECOSYSTEM"}],"components.roadmap.section3.title":[{"type":0,"value":"SOON"}],"components.roadmap.section4.title":[{"type":0,"value":"UP NEXT"}],"components.roadmap.title":[{"type":0,"value":"Roadmap"}],"components.software.description":[{"type":0,"value":"The Ergo Node is your entry-point to development on Ergo and lets you communicate with the blockchain."}],"components.software.heading":[{"type":0,"value":"Software"}],"components.uniqueErgo.card1.button":[{"type":0,"value":"EXPLORE"}],"components.uniqueErgo.card1.text":[{"type":0,"value":"Ergo draws on ten years of blockchain development, complementing tried and tested principles with the best peer-reviewed academic research into cryptography, consensus models and digital currencies. We start with solid blockchain basics and implement new and powerful cryptography natively."}],"components.uniqueErgo.card1.title":[{"type":0,"value":"RESEARCH-LED AND REAL-WORLD FOCUSED"}],"components.uniqueErgo.card2.button":[{"type":0,"value":"EXPLORE"}],"components.uniqueErgo.card2.text":[{"type":0,"value":"Ergo provides superior support for real-world financial agreements. Ergo can support versatile dApps that run predictably, with known costs, and don’t have any of the dangers of unrestricted functionality. Ergo’s smart contracts allow us to execute wide-ranging tasks and can be Turing complete, but we always know in advance how much the code will cost and whether it will run successfully."}],"components.uniqueErgo.card2.title":[{"type":0,"value":"POWERFUL AND SAFE"}],"components.uniqueErgo.card3.button":[{"type":0,"value":"EXPLORE"}],"components.uniqueErgo.card3.text":[{"type":0,"value":"Sigma Protocols (Σ-Protocols) are the foundation of Ergo’s smart contracts. They allow for a class of efficient zero-knowledge protocols that enable us to implement sophisticated tasks that would otherwise be impossible, risky, or expensive. Welcome to self-sovereign application-level privacy: trustless scripts that can be used to access mixers or other functionality without any third parties required."}],"components.uniqueErgo.card3.title":[{"type":0,"value":"INTELLIGENT AND STRAIGHTFORWARD"}],"components.uniqueErgo.card4.button":[{"type":0,"value":"EXPLORE"}],"components.uniqueErgo.card4.text":[{"type":0,"value":"Ordinary users who do not run a full node should enjoy the same security benefits as miners. Non-Interactive Proofs of Proof-of-Work (NIPOPOWS) allow us to make and verify transactions with complete confidence without needing the storage, bandwidth and time required to download the full blockchain. As little as 1 MB of data is necessary, meaning you can use any device."}],"components.uniqueErgo.card4.title":[{"type":0,"value":"SECURE AND ACCESSIBLE"}],"components.uniqueErgo.title":[{"type":0,"value":"WHAT MAKES ERGO UNIQUE"}],"components.usingErg.description":[{"type":0,"value":"There is a rich ecosystem budding on top of Ergo. Whether you are a developer, miner, or investor, we have you covered."}],"components.usingErg.subtitle":[{"type":0,"value":"UNSTOPPABLE DEFI"}],"components.usingErg.title":[{"type":0,"value":"GET ERG"}],"components.wallets.ErgoPay":[{"type":0,"value":"ErgoPay"}],"components.wallets.chooseYours":[{"type":0,"value":"CHOOSE YOURS"}],"components.wallets.coldStorageHeader":[{"type":0,"value":"Cold Storage"}],"components.wallets.dAppConnectorHeader":[{"type":0,"value":"dApp Connector"}],"components.wallets.featureHeader":[{"type":0,"value":"Feature"}],"components.wallets.setupGuides":[{"type":0,"value":"SETUP GUIDES"}],"components.wallets.walletDescription1":[{"type":0,"value":"Digital wallets can help keep your digital currency safe, private and in your control."}],"components.wallets.walletDescription2":[{"type":0,"value":"Note that wallets are supported by third parties, we only provide the information below as a courtesy, in order to simplify the overall digital currency experience for you."}],"components.wallets.walletsHeader":[{"type":0,"value":"Wallets"}],"components.wallets.walletsTitle":[{"type":0,"value":"Wallets"}],"components.wiki.description":[{"type":0,"value":"ergonaut.space is our community-run wiki! Jam-packed with tons of great information on the underlying technical details of the Ergo blockchain in easy to understand language for non-technical people. Theres also plenty of guides, tutorials, and user-submitted content. Create an account to start contributing!"}],"components.wiki.description.short":[{"type":0,"value":"ergonaut.space is the community wiki of the Ergo blockchain, a guide translating how to use and the underlying technical details of the Ergo blockchain in easy to understand language for non-technical people."}],"components.wiki.heading":[{"type":0,"value":"Wiki"}],"footer.blog.title":[{"type":0,"value":"BLOG"}],"footer.community.1":[{"type":0,"value":"Join our channels"}],"footer.community.2":[{"type":0,"value":"Sigmanauts"}],"footer.community.3":[{"type":0,"value":"Contribute to Ergo"}],"footer.community.4":[{"type":0,"value":"Hall of Fame"}],"footer.community.5":[{"type":0,"value":"Ergo Foundation"}],"footer.community.title":[{"type":0,"value":"COMMUNITY"}],"footer.discover.1":[{"type":0,"value":"Software Releases"}],"footer.discover.2":[{"type":0,"value":"Grants & Bounties"}],"footer.discover.3":[{"type":0,"value":"FAQ"}],"footer.discover.4":[{"type":0,"value":"Explore"}],"footer.discover.5":[{"type":0,"value":"Documents"}],"footer.discover.title":[{"type":0,"value":"DISCOVER"}],"footer.ecosystem.1":[{"type":0,"value":"DApps"}],"footer.ecosystem.2":[{"type":0,"value":"Roadmap"}],"footer.ecosystem.3":[{"type":0,"value":"Wiki"}],"footer.ecosystem.4":[{"type":0,"value":"Ergo Raffle"}],"footer.ecosystem.5":[{"type":0,"value":"Videocasts"}],"footer.ecosystem.title":[{"type":0,"value":"ECOSYSTEM"}],"footer.favorites.title":[{"type":0,"value":"OUR FAVORITES"}],"footer.getErg.1":[{"type":0,"value":"Mining"}],"footer.getErg.2":[{"type":0,"value":"Mining Calculator"}],"footer.getErg.3":[{"type":0,"value":"Wallets"}],"footer.getErg.4":[{"type":0,"value":"Exchanges"}],"footer.getErg.title":[{"type":0,"value":"GET ERG"}],"footer.legal":[{"type":0,"value":"Legal"}],"footer.news.title":[{"type":0,"value":"NEWS"}],"footer.privacyPolicy":[{"type":0,"value":"Privacy Policy"}],"footer.realLifeErgo.title":[{"type":0,"value":"Real Life Ergo"}],"footer.weGotIt":[{"type":0,"value":"We got it!"}],"navigation.discover":[{"type":0,"value":"DISCOVER"}],"navigation.ecosystem":[{"type":0,"value":"ECOSYSTEM"}],"navigation.ergoCommunity":[{"type":0,"value":"ERGO COMMUNITY"}],"navigation.getErg":[{"type":0,"value":"GET ERG"}],"navigation.moreContent":[{"type":0,"value":"More content?"}],"pages.404.hero":[{"type":0,"value":"404. Page Not Found."}],"pages.404.title":[{"type":0,"value":"Not Found"}],"pages.blog.title":[{"type":0,"value":"Blog"}],"pages.community.title":[{"type":0,"value":"Community"}],"pages.discover.title":[{"type":0,"value":"Discover"}],"pages.ecosystem.title":[{"type":0,"value":"Ecosystem"}],"pages.get-erg.title":[{"type":0,"value":"GetErg"}],"pages.home.title":[{"type":0,"value":"Home"}],"pages.legal.title":[{"type":0,"value":"Legal"}],"pages.mobile-wallets":[{"type":0,"value":"Mobile Wallets"}],"pages.news.title":[{"type":0,"value":"News"}],"pages.privacyPolicy.title":[{"type":0,"value":"Privacy Policy"}]}');
;// CONCATENATED MODULE: ./content/compiled-locales/de.json
var de_namespaceObject = JSON.parse('{"components.ContributeForm.company.subTitle":[{"type":0,"value":"JETZT PARTNER WERDEN:"}],"components.ContributeForm.company.title":[{"type":0,"value":"Ich bin ein "},{"children":[{"type":0,"value":"Unternehmen"}],"type":8,"value":"b"}],"components.ContributeForm.developer.subTitle":[{"type":0,"value":"JETZT BEITRAG LEISTEN:"}],"components.ContributeForm.developer.title":[{"type":0,"value":"Ich bin "},{"children":[{"type":0,"value":"Entwickler*in"}],"type":8,"value":"b"}],"components.ContributeForm.text":[{"type":0,"value":"Ergo verfolgt "},{"children":[{"type":0,"value":"einen offenen Ansatz"}],"type":8,"value":"b"},{"type":0,"value":", bei dem "},{"children":[{"type":0,"value":"jeder"}],"type":8,"value":"b"},{"type":0,"value":" willkommen ist, "},{"children":[{"type":0,"value":"einen Beitrag zu leisten."}],"type":8,"value":"b"}],"components.ContributeForm.title":[{"type":0,"value":"Mitmachen"}],"components.DApps.seeAllProjects":[{"type":0,"value":"NOCH MEHR PROJEKTE"}],"components.Sigmanauts.button":[{"type":0,"value":"MEHR ERFAHREN & BEWERBEN"}],"components.Sigmanauts.button.buttonContribute":[{"type":0,"value":"RICHTLINIEN FÜR DIE MITARBEIT"}],"components.Sigmanauts.button.discord":[{"type":0,"value":"TRETE UNSEREM DISCORD BEI"}],"components.Sigmanauts.button.grantsAndBounties":[{"type":0,"value":"FÖRDERUNGEN & PRÄMIEN"}],"components.Sigmanauts.button.writeAndReviewCode":[{"type":0,"value":"TAUCHE IN ERGO EIN"}],"components.Sigmanauts.formInput.button":[{"type":0,"value":"ABSENDEN"}],"components.Sigmanauts.formInput.email":[{"type":0,"value":"E-Mail"}],"components.Sigmanauts.formInput.name":[{"type":0,"value":"Name / Unternehmen"}],"components.Sigmanauts.formInput.text":[{"type":0,"value":"Schreibe uns deine Ideen und lass uns drüber reden!"}],"components.Sigmanauts.subTitle":[{"type":0,"value":"Ausbildungsprogramm"}],"components.Sigmanauts.text":[{"type":0,"value":"Bewirb dich für das Sigmanauten-Ausbildungsprogramm, um Ergos Wachstum mitzugestalten. "},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":" Lass uns ein basisdemokratisches Grassroots-Finanzsystem erschaffen."}],"components.Sigmanauts.title":[{"type":0,"value":"Sigmanauten"}],"components.Spotlight.button":[{"type":0,"value":"ZU ALLEN BEITRÄGEN"}],"components.Spotlight.title":[{"type":0,"value":"Spotlight"}],"components.autolykos.button":[{"type":0,"value":"MINE JETZT ERG"}],"components.autolykos.header":[{"type":0,"value":"AUTOLYKOS"}],"components.autolykos.text":[{"children":[{"type":0,"value":"Autolykos"}],"type":8,"value":"b"},{"type":0,"value":" ist Ergos auf GPUs ausgerichteter speicherharter, ASIC-resistenter Proof-of-Work-Algorithmus."}],"components.autolykos.title":[{"type":0,"value":"Die Zukunft von Proof of Work"}],"components.communityHero.Discord.text":[{"type":0,"value":"Treffen Sie uns auf Discord!"}],"components.communityHero.Discord.title":[{"type":0,"value":"Discord"}],"components.communityHero.Discourse.text":[{"type":0,"value":"Beteiligen Sie sich an der Diskussion im Ergo-Forum."}],"components.communityHero.Discourse.title":[{"type":0,"value":"Forum"}],"components.communityHero.Github.text":[{"type":0,"value":"Reden ist billig, hier ist der Code. 100% Open-Source."}],"components.communityHero.Github.title":[{"type":0,"value":"Github"}],"components.communityHero.Reddit.text":[{"type":0,"value":"Abonnieren Sie unsere Subreddits."}],"components.communityHero.Reddit.title":[{"type":0,"value":"Reddit"}],"components.communityHero.Telegram.text":[{"type":0,"value":"Kommen Sie auf Telegramm mit uns plaudern."}],"components.communityHero.Telegram.title":[{"type":0,"value":"Telegramm"}],"components.communityHero.Twitter.text":[{"type":0,"value":"Folgen Sie uns auf Twitter."}],"components.communityHero.Twitter.title":[{"type":0,"value":"Twitter"}],"components.communityHero.Wiki.text":[{"type":0,"value":"Ihr Community-Wiki. Tragen Sie in jeder Sprache bei!"}],"components.communityHero.Wiki.title":[{"type":0,"value":"Wiki"}],"components.communityHero.Youtube.text":[{"type":0,"value":"Abonnieren Sie für wöchentliche AMAs, ErgoPulse und mehr!"}],"components.communityHero.Youtube.title":[{"type":0,"value":"Youtube"}],"components.communityHero.subtitle":[{"type":0,"value":"GRASSROOTS FINANZEN AUS DER BASIS"}],"components.communityHero.title":[{"type":0,"value":"Ökosystem"}],"components.communitySection.communityHero.linkText":[{"type":0,"value":"Mitwirkenden"}],"components.communitySection.communityHero.text1":[{"type":0,"value":"Ergo ist eine dezentralisierte Basisplattform, die von ihrer Gemeinschaft angetrieben wird."}],"components.communitySection.communityHero.text2":[{"type":0,"value":"Treffen Sie uns auf sozialen Medien, um sich zu engagieren. Schauen Sie sich die"}],"components.communitySection.communityHero.text3":[{"type":0,"value":"Seite für weitere Informationen an."}],"components.dApps.heading":[{"type":0,"value":"DApps"}],"components.discoverErgo.text.1":[{"type":0,"value":"Ergo ist eine Next-Gen Proof-of-Work-Plattform mit Smart Contracts, die neue Modelle finanzieller Interaktion ermöglicht, basierend auf einer sicheren und vielseitigen Skriptsprache mit flexiblen und leistungsstarken Zero-Knowledge-Proofs (Σ-Protokolle)."}],"components.discoverHero.button1":[{"type":0,"value":"LIES DIE DOCS"}],"components.discoverHero.button2":[{"type":0,"value":"LERNE MIT DECO"}],"components.discoverHero.button3":[{"type":0,"value":"LIES DAS MANIFEST"}],"components.discoverHero.button4":[{"type":0,"value":"SCHAU INS BLOG"}],"components.discoverHero.button5":[{"type":0,"value":"RICHTE DICH EIN"}],"components.discoverHero.button6":[{"type":0,"value":"BESUCH ERGONAUT.SPACE"}],"components.documents.description":[{"type":0,"value":"Ergo verfolgt einen forschungsbasierten Ansatz und verwendet stabile, gut getestete Lösungen, um eine robuste Plattform für Entwickler zu bieten, auf der sie jahrelang aufbauen können. Die meisten Ergo-Lösungen sind in Papieren formalisiert, die auf Peer-Reviewed-Konferenzen vorgestellt wurden und in der Community ausgiebig diskutiert wurden."}],"components.documents.heading":[{"type":0,"value":"Dokumente"}],"components.ecosystemHero.title":[{"type":0,"value":"Ökosystem"}],"components.ergoExplorer.button1":[{"type":0,"value":"EXPLORER"}],"components.ergoExplorer.button2":[{"type":0,"value":"ERGO.WATCH"}],"components.ergoRaffle.description":[{"type":0,"value":"ErgoRaffle ist ein auf der Ergo-Plattform aufgebautes Crowdfunding-Service, das es jedem ermöglicht, Geld für ein Projekt zu sammeln. Dieses Projekt kann von einer direkten Spende an eine Wohltätigkeitsorganisation, einen akademischen oder Geschäftsplan oder alles Mögliche reichen, für das Sie die Menschen überzeugen können, ihre hart verdienten ERG aufzugeben! Als zusätzlichen Bonus findet nach Abschluss der Verlosung eine Lotterie statt, und ein glücklicher Teilnehmer gewinnt einen festen Prozentsatz der Verlosung als \\"Verlosungsprämie\\"."}],"components.ergoRaffle.heading":[{"type":0,"value":"Ergo Raffle"}],"components.ergofoundation.list1":[{"type":0,"value":"Förderung der "},{"children":[{"type":0,"value":"störungsfreien "}],"type":8,"value":"b"},{"type":0,"value":" Entwicklung des Ergo-Plattform-Protokolls"}],"components.ergofoundation.list2":[{"type":0,"value":"Öffentlichkeitsarbeit für die breite Akzeptanz und Nutzung der Ergo-Plattform und ihres "},{"children":[{"type":0,"value":"nativen Tokens "}],"type":8,"value":"b"},{"type":0,"value":" (ERG)"}],"components.ergofoundation.list3":[{"type":0,"value":"Entwicklung des "},{"children":[{"type":0,"value":"Ökosystems "}],"type":8,"value":"b"},{"type":0,"value":" rund um die Ergo-Plattform"}],"components.ergofoundation.list4":[{"type":0,"value":"Verbreitung der Nutzung der Ergo-Plattform und der Blockchain-Technologie für positive "},{"children":[{"type":0,"value":"soziale Zwecke "}],"type":8,"value":"b"}],"components.ergofoundation.list5":[{"type":0,"value":"Aufrechterhaltung einer "},{"children":[{"type":0,"value":"wirklich dezentralen Infrastruktur "}],"type":8,"value":"b"},{"type":0,"value":", und"}],"components.ergofoundation.list6":[{"type":0,"value":"Unterstützung der "},{"children":[{"type":0,"value":"Privatsphäre "}],"type":8,"value":"b"},{"type":0,"value":" als grundlegendes Menschenrecht."}],"components.ergofoundation.title":[{"type":0,"value":"Die "},{"children":[{"type":0,"value":"Ergo-Foundation "}],"type":8,"value":"b"},{"type":0,"value":" verfolgt mit Antrieb der Community folgende Ziele"}],"components.exchanges.available":[{"type":0,"value":"Erhältlich auf beliebten Börsen und dezentralen Börsen."}],"components.exchanges.disclaimer":[{"type":0,"value":"Haftungsausschluss: Börsen bieten sehr unterschiedliche Grade an Sicherheit, Datenschutz und Kontrolle über Ihre Gelder und Informationen. Wir empfehlen dringend, dass Sie Ihre eigenen Mittel aufbewahren und eine der oben genannten Brieftaschenoptionen verwenden."}],"components.exchanges.heading":[{"type":0,"value":"ERGO KAUFEN, VERKAUFEN UND HANDELN"}],"components.exchanges.subheading":[{"type":0,"value":"Börsen"}],"components.explore.description":[{"type":0,"value":"Der Ergo Explorer ist Ihre Schnittstelle zur Blockchain. Beobachten Sie jede Transaktion in Echtzeit. Oder sehen Sie sich von der Community kuratierte Metriken auf ergo.watch an."}],"components.explore.heading":[{"type":0,"value":"Erforschen"}],"components.explore.subheading":[{"type":0,"value":"TAUCHEN SIE IN DAS ERGO-TRANSAKTIONSMEER EIN"}],"components.faq.anyQuestions":[{"type":0,"value":"FRAGEN?"}],"components.faq.description":[{"type":0,"value":"Wir haben einige der am häufigsten gestellten Fragen zusammengestellt."}],"components.faq.heading":[{"type":0,"value":"Häufig gestellte Fragen"}],"components.faq.text.2":[{"type":0,"value":"DU FINDEST NICHT, "},{"type":1,"value":"breakingLine"},{"type":0,"value":" WONACH DU SUCHST?"}],"components.favorites.button1":[{"type":0,"value":"ERKUNDE ERGO RAFFLE"}],"components.getErg.BuyIt.text":[{"type":0,"value":"Erhältlich auf beliebten zentralisierten und dezentralisierten Börsen."}],"components.getErg.BuyIt.title":[{"type":0,"value":"Börsen"}],"components.getErg.MineIt.text":[{"type":0,"value":"Autolykos, ein ASIC-resistenter und fairer Proof-of-Work-Algorithmus, der für gängige GPUs geeignet ist."}],"components.getErg.MineIt.title":[{"type":0,"value":"Abbau"}],"components.getErg.StoreIt.text":[{"type":0,"value":"Einfache und sichere nicht-kustodiale Brieftaschen, um Ihre ERG sicher aufzubewahren."}],"components.getErg.StoreIt.title":[{"type":0,"value":"Brieftaschen"}],"components.getErg.UseIt.title":[{"type":0,"value":"Setzen Sie Ihr ERG heute in unserem wachsenden Ökosystem ein."}],"components.getErg.description":[{"type":0,"value":"Es entsteht ein reiches Ökosystem auf der Basis von Ergo. Egal, ob Sie ein Entwickler, ein Bergmann oder ein Investor sind - wir haben Sie abgedeckt."}],"components.getErg.heroTitle":[{"type":0,"value":"UNAUFHALTBARES DEFI"}],"components.getErg.title":[{"type":0,"value":"ERG erhalten"}],"components.grantsAndBounties.button1":[{"type":0,"value":"PRÄMIEN"}],"components.grantsAndBounties.button2":[{"type":0,"value":"STARTE EIN RAFFLE"}],"components.grantsAndBounties.button3":[{"type":0,"value":"KONTAKTIERE UNS"}],"components.grantsAndBounties.description":[{"type":0,"value":"Im Allgemeinen unterliegt alles, was für die Gemeinschaft lehrreich ist, einer Prämie, auch wenn es nicht ausdrücklich aufgeführt ist. Wir suchen nach Zuschüssen für Projekte, die sich auf den Aufbau wichtiger Infrastrukturen im Ökosystem konzentrieren. Der schnellste Weg, um eine Finanzierung zu erhalten, besteht jedoch darin, eine Verlosung zu starten."}],"components.grantsAndBounties.heading":[{"type":0,"value":"Zuschüsse und Prämien"}],"components.hallOfFame.description1":[{"type":0,"value":"Ergo wurde von einem Team gegründet, das über einen umfassenden Hintergrund in der Core-Entwicklung mit Kryptowährungen und Blockchain-Frameworks wie NXT, Scorex, Cardano und Waves verfügt. Im Folgenden findest Du kurze Biografien einiger Mitglieder des Ergo-Core-Teams sowie einiger der vielen anderen beteiligten Entwickler*innen und Community-Mitglieder, von denen einige anonym an der Entwicklung teilnehmen."}],"components.hallOfFame.description2":[{"type":0,"value":"Ergo ist basisorientiert, und die meisten Mitglieder des Core-Teams (und sogar der Foundation) haben als Mitglieder der Community begonnen. Eine kurze Beschreibung sowie weitere Angaben zur Ergo Foundation findest Du weiter unten."}],"components.hallOfFame.tab1":[{"type":0,"value":"CORE"}],"components.hallOfFame.tab2":[{"type":0,"value":"COMMUNITY"}],"components.hallOfFame.tab3":[{"type":0,"value":"FOUNDATION"}],"components.hallOfFame.title":[{"type":0,"value":"Hall Of Fame"}],"components.highlights.slide.1.quote":[{"type":0,"value":"95,57% "},{"type":1,"value":"breakingLine"},{"type":0,"value":"Öffentliche Zuteilung"}],"components.highlights.slide.1.text":[{"type":0,"value":"Als Ergo 2019 gestartet wurde, gab es kein Initial Coin Offering, kein Pre-Mine und keine Vorab-Zuteilung von Token an Teammitglieder oder Risikokapitalgeber. Ein wirklich fairer Start mit 4,43% der Mittel für die Entwicklung des Ökosystems. Unübertroffen in jeder anderen Smart-Contract-Plattform."}],"components.highlights.slide.1.title":[{"type":0,"value":"Ein Fairer Start"}],"components.highlights.slide.2.quote":[{"type":0,"value":"TRUE P2P"}],"components.highlights.slide.2.text":[{"type":0,"value":"Ermöglicht mehr innovative, gezielte Umsetzungen, die herkömmliche Banken nicht erreichen können. Ergo bietet leistungsstarke Tools mit Smart-Contract-basierten Mikrokredit-Einrichtungen und Local Exchange Trading Systems (LETS)."}],"components.highlights.slide.2.title":[{"type":0,"value":"Alternative Ökonomie"}],"components.highlights.slide.3.quote":[{"type":0,"value":"Σ-Protokolle"}],"components.highlights.slide.3.text":[{"type":0,"value":"Datenschutz muss eine Option bleiben, um die Autonomie zu schützen. Privatsphäre bedeutet die Fähigkeit, Barrieren zu schaffen und Grenzen zu errichten, um einen Raum für das Individuum zu schaffen. Es liegt an jedem Einzelnen, welche Grenzen und Barrieren er wählt. Dies ermöglicht neue Modelle der finanziellen Interaktion, unterstützt durch eine sichere und reichhaltige Skriptsprache, ErgoScript, und flexible und leistungsstarke Zero-Knowledge-Beweise."}],"components.highlights.slide.3.title":[{"type":0,"value":"Optionale Privatsphäre"}],"components.highlights.title":[{"type":0,"value":"HIGHLIGHTS"}],"components.homeHero.button":[{"type":0,"value":"TAUCHE EIN"}],"components.homeHero.text":[{"type":0,"value":"Ergo ist eine Next-Gen Proof-of-Work-Plattform mit Smart Contracts, die durch sichere, zugängliche und dezentralisierte Finanztools die wirtschaftliche Freiheit einfacher Menschen gewährleistet."}],"components.homeHero.title":[{"type":0,"value":"Energie für die Zukunft der Finanzen"}],"components.homeInfo.blockReward":[{"type":0,"value":"BLOCKBELOHNUNG"}],"components.homeInfo.circulatingSupply":[{"type":0,"value":"ERG IM UMLAUF"}],"components.homeInfo.hashRate":[{"type":0,"value":"HASHRATE"}],"components.homeInfo.transactionPerDay":[{"type":0,"value":"TRANSAKTIONEN PRO TAG"}],"components.learn.description":[{"type":0,"value":"Beginnen Sie mit den Grundlagen. Was ist Ergo? Was können Sie auf Ergo tun?"}],"components.learn.heading":[{"type":0,"value":"Lernen"}],"components.mining.button1":[{"type":0,"value":"Dokumentation"}],"components.mining.button2":[{"type":0,"value":"Mining-Pool-Statistiken"}],"components.mining.button3":[{"type":0,"value":"Discord"}],"components.mining.button4":[{"type":0,"value":"Subreddit"}],"components.mining.button5":[{"type":0,"value":"Mining-Blog-Posts"}],"components.mining.calculator.currentBlockReward":[{"type":0,"value":"Aktuelle Blockbelohnung"}],"components.mining.calculator.currentPrice":[{"type":0,"value":"Aktueller Preis"}],"components.mining.calculator.description":[{"type":0,"value":"Autolykos ist der zugrunde liegende memory-hard ASIC-resistente Proof of Work (PoW)-Algorithmus, der auf GPUs ausgerichtet ist."}],"components.mining.calculator.networkHashrate":[{"type":0,"value":"Netzwerk-Hashrate"}],"components.mining.calculator.rev":[{"type":0,"value":"Tägliche Einnahmen"}],"components.mining.calculator.title":[{"type":0,"value":"Mining-Rechner"}],"components.mining.minersTitle":[{"type":0,"value":"Bergleute"}],"components.mining.miningPoolsTitle":[{"type":0,"value":"Mining-Pools"}],"components.mining.text.1":[{"type":0,"value":"Ergos Mining basiert auf Autolykos, einem in Scala programmierten, ASIC-resistenten Proof-of-Work-Algorithmus. Er kann auf den meisten Low-End-GPUs bei vergleichsweise niedrigeren Temperaturen laufen und holt dadurch mehr Lebenszeit aus der Hardware. In Kombination mit dem eUTXO-Modell und der Off-Chain-Auslagerung von größeren Rechenoperationen entsteht so ein äußerst effizientes Proof-of-Work."}],"components.mining.text.2":[{"type":0,"value":"Willkommen in der Zukunft von Proof-of-Work."}],"components.mining.text.3":[{"type":0,"value":"Um loszulegen, schau ins Mining-Handbuch der Community oder trete den Mining-Diskussionskanälen bei."}],"components.mining.title":[{"type":0,"value":"Mining"}],"components.news.blog":[{"type":0,"value":"Blog"}],"components.news.latest":[{"type":0,"value":"Aktuelle News"}],"components.news.title":[{"type":0,"value":"News"}],"components.ourFavorites.heading":[{"type":0,"value":"UNSERE FAVORITEN"}],"components.ourmission.description":[{"type":0,"value":"Die Ergo Foundation hat sich zu einer organischen und störungsfreien Entwicklung des Ergo-Platform-Protokolls verpflichtet."}],"components.ourmission.emissionAndTokenomics":[{"type":0,"value":"AUSSCHÜTTUNG UND TOKENOMICS"}],"components.ourmission.ergofoundation":[{"type":0,"value":"DIE ERGO FOUNDATION"}],"components.ourmission.reachus.twitter":[{"type":0,"value":"ERREICHE UNS BEI TWITTER"}],"components.ourmission.subdescription":[{"type":0,"value":"Die Ergo Foundation ist bestrebt, die Anzahl der wertvollen Ökosystementwicklungen zu erhöhen, die auf Open-Source-Basis mit einer möglichst permissiven Lizenz durchgeführt werden."}],"components.ourmission.title":[{"type":0,"value":"Unsere Mission"}],"components.partners.title":[{"type":0,"value":"Partner"}],"components.roadmap.coinmarketcal":[{"type":0,"value":"MEHR INFOS AUF COINMARKETCAL"}],"components.roadmap.description":[{"type":0,"value":"Bitte beachte, dass Ergo eine offene Plattform ist. Viele der unten aufgeführten Projekte haben keine formale Verbindung zur Ergo Foundation oder zueinander."}],"components.roadmap.section1.title":[{"type":0,"value":"BISHER"}],"components.roadmap.section2.title":[{"type":0,"value":"ÖKOSYSTEM"}],"components.roadmap.section3.title":[{"type":0,"value":"BALD"}],"components.roadmap.section4.title":[{"type":0,"value":"2024 & DANACH"}],"components.roadmap.title":[{"type":0,"value":"Roadmap"}],"components.software.description":[{"type":0,"value":"Der Ergo-Knoten ist Ihr Einstieg in die Entwicklung auf Ergo und ermöglicht die Kommunikation mit der Blockchain."}],"components.software.heading":[{"type":0,"value":"Software"}],"components.uniqueErgo.card1.button":[{"type":0,"value":"MEHR INFOS"}],"components.uniqueErgo.card1.text":[{"type":0,"value":"Ergo stützt sich auf zehn Jahre Blockchain-Entwicklung und ergänzt bewährte Prinzipien mit der besten von Expert*innen begutachteten akademischen Forschung zu Kryptografie, Konsensmodellen und digitalen Währungen. Wir beginnen mit robusten Blockchain-Grundlagen und implementieren neue und leistungsstarke Kryptografie auf nativer Basis."}],"components.uniqueErgo.card1.title":[{"type":0,"value":"FORSCHUNGSBASIERT MIT REAL-WORLD-FOKUS"}],"components.uniqueErgo.card2.button":[{"type":0,"value":"MEHR INFOS"}],"components.uniqueErgo.card2.text":[{"type":0,"value":"Ergo bietet ausgezeichnete Unterstützung für wirtschaftliche Verträge in der realen Welt. Ergo unterstützt vielseitige dApps, die berechenbar und mit bekannten Kosten ausgeführt werden und keine der Gefahren uneingeschränkter Funktionalität aufweisen. Die Smart Contracts von Ergo ermöglichen es, weitreichende Aufgaben auszuführen und können Turing-vollständig sein, doch wir wissen immer im Voraus, wie viel der Code kosten wird und ob er erfolgreich laufen wird."}],"components.uniqueErgo.card2.title":[{"type":0,"value":"MÄCHTIG UND SICHER"}],"components.uniqueErgo.card3.button":[{"type":0,"value":"MEHR INFOS"}],"components.uniqueErgo.card3.text":[{"type":0,"value":"Sigma-Protokolle sind die Grundlage für die Smart Contracts von Ergo. Sie ermöglichen eine Reihe effizienter Zero-Knowledge-Protokolle, die es uns ermöglichen, Dinge zu implementieren, die sonst entweder unmöglich oder aber riskant und teuer wären. Dies ermöglicht eine souveräne Privatsphäre auf Anwendungsebene: vertrauenslose Skripte, die für den Zugriff auf Mixer oder andere Funktionen verwendet werden können - ohne dass Dritte erforderlich sind."}],"components.uniqueErgo.card3.title":[{"type":0,"value":"INTELLIGENT UND EINGÄNGIG"}],"components.uniqueErgo.card4.button":[{"type":0,"value":"MEHR INFOS"}],"components.uniqueErgo.card4.text":[{"type":0,"value":"Wir finden, dass normale Nutzer*innen, die keinen vollständigen Node betreiben, die gleichen Sicherheitsvorteile genießen sollten wie Miner*innen. Ergos nicht-interaktives Proof-of-Proof-of-Work (NiPoPoW) ermöglicht es allen, Transaktionen mit vollem Vertrauen durchzuführen und zu verifizieren, ohne den Speicherplatz, die Bandbreite und die Zeit für das Herunterladen der vollständigen Blockchain zu benötigen. Tatsächlich ist nur 1 MB an Daten erforderlich - das bedeutet, dass ein beliebiges Endgerät verwendet werden kann."}],"components.uniqueErgo.card4.title":[{"type":0,"value":"SICHER UND ZUGÄNGLICH"}],"components.uniqueErgo.title":[{"type":0,"value":"WAS MACHT ERGO EINZIGARTIG"}],"components.usingErg.BuyIt.text":[{"type":0,"value":"Erhältlich auf beliebten zentralisierten und dezentralisierten Börsen."}],"components.usingErg.BuyIt.title":[{"type":0,"value":"Börsen"}],"components.usingErg.MineIt.text":[{"type":0,"value":"Autolykos, ein ASIC-resistenter und fairer Proof-of-Work-Algorithmus, der für gängige GPUs geeignet ist."}],"components.usingErg.MineIt.title":[{"type":0,"value":"Abbau"}],"components.usingErg.StoreIt.text":[{"type":0,"value":"Einfache und sichere nicht-betreute Geldbörsen, um Ihre ERG sicher aufzubewahren."}],"components.usingErg.StoreIt.title":[{"type":0,"value":"Brieftaschen"}],"components.usingErg.UseIt.title":[{"type":0,"value":"Nutzen Sie heute Ihre ERG in unserem wachsenden Ökosystem."}],"components.usingErg.description":[{"type":0,"value":"Auf Ergo ist ein reichhaltiges Ökosystem entstanden. Ob Du Entwickler*in, Miner*in oder Investor*in bist - wir haben alles für Dich."}],"components.usingErg.subtitle":[{"type":0,"value":"UNAUFHALTSAME DEFI"}],"components.usingErg.title":[{"type":0,"value":"HOL DIR ERG"}],"components.wallets.chooseYours":[{"type":0,"value":"WÄHLEN SIE IHRES"}],"components.wallets.coldStorageHeader":[{"type":0,"value":"Kaltspeicherung"}],"components.wallets.featureHeader":[{"type":0,"value":"Feature"}],"components.wallets.hotStorageHeader":[{"type":0,"value":"Heißlagerung"}],"components.wallets.mobileAppHeader":[{"type":0,"value":"Mobile App"}],"components.wallets.setupGuides":[{"type":0,"value":"SETUP-ANLEITUNGEN"}],"components.wallets.walletDescription1":[{"type":0,"value":"Digitale Brieftaschen können dazu beitragen, Ihre digitale Währung sicher, privat und unter Ihrer Kontrolle zu halten."}],"components.wallets.walletDescription2":[{"type":0,"value":"Beachten Sie, dass Brieftaschen von Drittanbietern unterstützt werden. Wir stellen die unten aufgeführten Informationen nur als Höflichkeit zur Verfügung, um das gesamte Erlebnis mit digitalen Währungen für Sie zu vereinfachen."}],"components.wallets.walletsHeader":[{"type":0,"value":"Brieftaschen"}],"components.wallets.walletsTitle":[{"type":0,"value":"Brieftaschen"}],"components.wiki.description":[{"type":0,"value":"ergonaut.space ist unser von der Community betriebenes Wiki! Randvoll mit vielen großartigen Informationen zu den zugrunde liegenden technischen Details der Ergo-Blockchain in einer leicht verständlichen Sprache für nicht-technische Personen. Es gibt auch viele Anleitungen, Tutorials und von Benutzern eingereichte Inhalte. Erstellen Sie ein Konto, um beizutragen!"}],"components.wiki.description.short":[{"type":0,"value":"ergonaut.space ist das Community-Wiki der Ergo-Blockchain, ein Leitfaden, der erklärt, wie man die Ergo-Blockchain verwendet und die zugrunde liegenden technischen Details in einer leicht verständlichen Sprache für nicht-technische Personen übersetzt."}],"components.wiki.heading":[{"type":0,"value":"Wiki"}],"footer.blog.title":[{"type":0,"value":"BLOG"}],"footer.community.1":[{"type":0,"value":"Trete unseren Kanälen bei"}],"footer.community.2":[{"type":0,"value":"Sigmanauten"}],"footer.community.3":[{"type":0,"value":"Bei Ergo mitmachen"}],"footer.community.4":[{"type":0,"value":"Hall of Fame"}],"footer.community.5":[{"type":0,"value":"Ergo Foundation"}],"footer.community.title":[{"type":0,"value":"COMMUNITY"}],"footer.discover.1":[{"type":0,"value":"Software Releases"}],"footer.discover.2":[{"type":0,"value":"Förderungen & Prämien"}],"footer.discover.3":[{"type":0,"value":"FAQ"}],"footer.discover.4":[{"type":0,"value":"Explorer"}],"footer.discover.5":[{"type":0,"value":"Dokumente"}],"footer.discover.title":[{"type":0,"value":"ENTDECKEN"}],"footer.ecosystem.1":[{"type":0,"value":"DApps"}],"footer.ecosystem.2":[{"type":0,"value":"Roadmap"}],"footer.ecosystem.3":[{"type":0,"value":"Wiki"}],"footer.ecosystem.4":[{"type":0,"value":"Ergo Raffle"}],"footer.ecosystem.5":[{"type":0,"value":"Videocasts"}],"footer.ecosystem.title":[{"type":0,"value":"ÖKOSYSTEM"}],"footer.getErg.1":[{"type":0,"value":"Minen"}],"footer.getErg.2":[{"type":0,"value":"Mining Rechner"}],"footer.getErg.3":[{"type":0,"value":"Wallets"}],"footer.getErg.4":[{"type":0,"value":"Exchanges/Börsen"}],"footer.getErg.title":[{"type":0,"value":"HOL DIR ERG"}],"footer.legal":[{"type":0,"value":"Rechtliches"}],"footer.news.title":[{"type":0,"value":"NEWS"}],"footer.privacyPolicy":[{"type":0,"value":"Datenschutzhinweise"}],"footer.weGotIt":[{"type":0,"value":"We got it!"}],"navigation.discover":[{"type":0,"value":"ENTDECKEN"}],"navigation.ecosystem":[{"type":0,"value":"ÖKOSYSTEM"}],"navigation.ergoCommunity":[{"type":0,"value":"ERGO COMMUNITY"}],"navigation.getErg":[{"type":0,"value":"HOL DIR ERG"}],"navigation.moreContent":[{"type":0,"value":"Mehr Inhalte?"}],"pages.404.hero":[{"type":0,"value":"404. Seite nicht gefunden."}],"pages.404.title":[{"type":0,"value":"Nicht gefunden"}],"pages.blog.title":[{"type":0,"value":"Blog"}],"pages.community.title":[{"type":0,"value":"Community"}],"pages.discover.title":[{"type":0,"value":"Entdecken"}],"pages.ecosystem.title":[{"type":0,"value":"Ökosystem"}],"pages.get-erg.title":[{"type":0,"value":"Hol dir Erg"}],"pages.home.title":[{"type":0,"value":"Home"}],"pages.legal.title":[{"type":0,"value":"Rechtliches"}],"pages.mobile-wallets":[{"type":0,"value":"Mobile Wallets"}],"pages.privacyPolicy.title":[{"type":0,"value":"Datenschutzrichtlinie"}]}');
;// CONCATENATED MODULE: ./content/compiled-locales/it.json
var it_namespaceObject = JSON.parse('{"components.ContributeForm.company.subTitle":[{"type":0,"value":"VUOI DIVENTARE PARTNER?"}],"components.ContributeForm.company.title":[{"type":0,"value":"Sono una "},{"children":[{"type":0,"value":"azienda"}],"type":8,"value":"b"}],"components.ContributeForm.developer.subTitle":[{"type":0,"value":"COME POSSO CONTRIBUIRE?"}],"components.ContributeForm.developer.title":[{"type":0,"value":"Sono uno "},{"children":[{"type":0,"value":"sviluppatore"}],"type":8,"value":"b"}],"components.ContributeForm.text":[{"type":0,"value":"Ergo opera su un modello aperto in cui "},{"children":[{"type":0,"value":"chiunque può aiutare."}],"type":8,"value":"b"}],"components.ContributeForm.title":[{"type":0,"value":"Contribuisci"}],"components.DApps.seeAllProjects":[{"type":0,"value":"VEDI TUTTI I PROGETTI"}],"components.Sigmanauts.button":[{"type":0,"value":"LEGGI DI PIÙ E APPLICA"}],"components.Sigmanauts.button.buttonContribute":[{"type":0,"value":"LINEE GUIDA PER IL CONTRIBUTO"}],"components.Sigmanauts.button.discord":[{"type":0,"value":"UNISCITI A NOI SU DISCORD"}],"components.Sigmanauts.button.grantsAndBounties":[{"type":0,"value":"GRANTS & BOUNTIES"}],"components.Sigmanauts.button.writeAndReviewCode":[{"type":0,"value":"ESPLORA IL MONDO DI ERGO"}],"components.Sigmanauts.formInput.button":[{"type":0,"value":"INVIA"}],"components.Sigmanauts.formInput.email":[{"type":0,"value":"E-Mail"}],"components.Sigmanauts.formInput.name":[{"type":0,"value":"Nome/Azienda"}],"components.Sigmanauts.formInput.text":[{"type":0,"value":"Scrivici i tuoi suggerimenti e idee, parliamo!"}],"components.Sigmanauts.subTitle":[{"type":0,"value":"Programma di formazione"}],"components.Sigmanauts.text":[{"type":0,"value":"Richiedi informazioni sul programma di formazione Sigmanaut se vuoi aiutare a modellare e far crescere Ergo. "},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":" Creiamo finanziamenti di base."}],"components.Sigmanauts.title":[{"type":0,"value":"Sigmanauts"}],"components.Spotlight.button":[{"type":0,"value":"GUARDA TUTTI I POST"}],"components.Spotlight.title":[{"type":0,"value":"Spotlight"}],"components.autolykos.button":[{"type":0,"value":"MINA ERG"}],"components.autolykos.header":[{"type":0,"value":"AUTOLYKOS"}],"components.autolykos.text":[{"children":[{"type":0,"value":"Autolykos"}],"type":8,"value":"b"},{"type":0,"value":" è l\'algoritmo Proof of Work sottostante resistente agli ASIC con memoria rigida orientato alle GPU."}],"components.autolykos.title":[{"type":0,"value":"Il futuro della prova di lavoro"}],"components.communityHero.Discord.text":[{"type":0,"value":"Unisciti a noi su Discord!"}],"components.communityHero.Discord.title":[{"type":0,"value":"Discord"}],"components.communityHero.Discourse.text":[{"type":0,"value":"Unisciti alla discussione sul forum di Ergo."}],"components.communityHero.Discourse.title":[{"type":0,"value":"Forum"}],"components.communityHero.Github.text":[{"type":0,"value":"Parlare è facile, ecco il codice. 100% Open-Source."}],"components.communityHero.Github.title":[{"type":0,"value":"Github"}],"components.communityHero.Reddit.text":[{"type":0,"value":"Iscriviti ai nostri subreddit."}],"components.communityHero.Reddit.title":[{"type":0,"value":"Reddit"}],"components.communityHero.Telegram.text":[{"type":0,"value":"Vieni a parlare con noi su Telegram."}],"components.communityHero.Telegram.title":[{"type":0,"value":"Telegram"}],"components.communityHero.Twitter.text":[{"type":0,"value":"Seguici su Twitter."}],"components.communityHero.Twitter.title":[{"type":0,"value":"Twitter"}],"components.communityHero.Wiki.text":[{"type":0,"value":"Il tuo wiki della comunità. Contribuisci in qualsiasi lingua!"}],"components.communityHero.Wiki.title":[{"type":0,"value":"Wiki"}],"components.communityHero.Youtube.text":[{"type":0,"value":"Iscriviti per le AMAs settimanali, ErgoPulse e altro ancora!"}],"components.communityHero.Youtube.title":[{"type":0,"value":"Youtube"}],"components.communityHero.subtitle":[{"type":0,"value":"GRASSROOTS FINANCE"}],"components.communityHero.title":[{"type":0,"value":"Ecosistema"}],"components.communitySection.communityHero.linkText":[{"type":0,"value":"Contributing"}],"components.communitySection.communityHero.text1":[{"type":0,"value":"Ergo è una piattaforma decentralizzata nata dalla base della sua comunità. "}],"components.communitySection.communityHero.text2":[{"type":0,"value":"Unisciti a noi sui social per partecipare, dai un\'occhiata alla pagina "}],"components.communitySection.communityHero.text3":[{"type":0,"value":" per maggiori informazioni"}],"components.dApps.heading":[{"type":0,"value":"DApps"}],"components.discoverErgo.text.1":[{"type":0,"value":"Ergo è una piattaforma smart-contract Proof of Work di nuova generazione che consente nuovi modelli di interazione finanziaria, supportati da un linguaggio di scripting sicuro e ricco costruito con prove Zero-Knowledge flessibile e potenti ( Σ-protocolli)."}],"components.discoverHero.button1":[{"type":0,"value":"LEGGI I DOCUMENTI"}],"components.discoverHero.button2":[{"type":0,"value":"IMPARA CON DECO"}],"components.discoverHero.button3":[{"type":0,"value":"LEGGI IL MANIFESTO"}],"components.discoverHero.button4":[{"type":0,"value":"CONTROLLA IL BLOG"}],"components.discoverHero.button5":[{"type":0,"value":"OTTIENI CONFIGURAZIONE"}],"components.discoverHero.button6":[{"type":0,"value":"VISITA ERGONAUT.SPACE"}],"components.documents.description":[{"type":0,"value":"Ergo adotta un approccio basato sulla ricerca e utilizza soluzioni stabili e ben testate per fornire una piattaforma robusta su cui i developer possono costruire per anni. La maggior parte delle soluzioni di Ergo sono formalizzate in articoli presentati a conferenze peer-reviewed e sono state ampiamente discusse nella comunità."}],"components.documents.heading":[{"type":0,"value":"Documenti"}],"components.ecosystemHero.title":[{"type":0,"value":"Ecosistema"}],"components.ergoExplorer.button1":[{"type":0,"value":"EXPLORER"}],"components.ergoExplorer.button2":[{"type":0,"value":"ERGO.WATCH"}],"components.ergoRaffle.description":[{"type":0,"value":"ErgoRaffle è un servizio di crowdfunding costruito sulla piattaforma Ergo che consente a chiunque di raccogliere fondi per un progetto. Questo progetto può variare da una donazione diretta a un ente di beneficenza, un piano accademico o commerciale, o qualsiasi altra cosa per cui puoi convincere le persone a cedere i loro ERG guadagnati duramente! Come bonus aggiuntivo, dopo la conclusione della Raffle, viene effettuata una lotteria e un fortunato partecipante vince una percentuale predefinita della Raffle come \'premio della raffle\'"}],"components.ergoRaffle.heading":[{"type":0,"value":"Ergo Raffle"}],"components.ergofoundation.list1":[{"type":0,"value":"Promuovere lo "},{"children":[{"type":0,"value":"sviluppo senza interruzioni "}],"type":8,"value":"b"},{"type":0,"value":" del protocollo Ergo Platform;"}],"components.ergofoundation.list2":[{"type":0,"value":"Pubblicare l\'adozione e l\'uso diffusi di Ergo Platform e del suo "},{"children":[{"type":0,"value":" token nativo "}],"type":8,"value":"b"},{"type":0,"value":" (ERG);"}],"components.ergofoundation.list3":[{"type":0,"value":"Sviluppo dell<b>ecosistema </b> attorno alla piattaforma Ergo;"}],"components.ergofoundation.list4":[{"type":0,"value":"Diffondere l\'uso della piattaforma Ergo e della tecnologia blockchain per il "},{"children":[{"type":0,"value":" bene sociale "}],"type":8,"value":"b"},{"type":0,"value":";"}],"components.ergofoundation.list5":[{"type":0,"value":"Sostenere "},{"children":[{"type":0,"value":"un\'infrastruttura veramente decentralizzata"}],"type":8,"value":"b"},{"type":0,"value":" e;"}],"components.ergofoundation.list6":[{"type":0,"value":"Sostenere la "},{"children":[{"type":0,"value":"privacy "}],"type":8,"value":"b"},{"type":0,"value":" come diritto umano fondamentale."}],"components.ergofoundation.title":[{"type":0,"value":"La "},{"children":[{"type":0,"value":"Ergo Foundation"}],"type":8,"value":"b"},{"type":0,"value":" è un\'entità guidata e incentrata sulla comunità"}],"components.exchanges.available":[{"type":0,"value":"Disponibile su popolari exchange centralizzati e decentralizzati."}],"components.exchanges.disclaimer":[{"type":0,"value":"Avvertenza: gli scambi forniscono gradi di sicurezza, privacy e controllo dei tuoi fondi e delle tue informazioni altamente variabili. Consigliamo vivamente di custodire i propri fondi e utilizzare una delle opzioni di portafoglio sopra fornite."}],"components.exchanges.heading":[{"type":0,"value":"COMPRA, VENDI E SCAMBIA ERGO"}],"components.exchanges.subheading":[{"type":0,"value":"Exchange"}],"components.explore.description":[{"type":0,"value":"L\'Esploratore Ergo è la tua interfaccia con la blockchain. Guarda ogni transazione effettuata in tempo reale. Oppure, visualizza le metriche curate dalla comunità su ergo.watch."}],"components.explore.heading":[{"type":0,"value":"Esplora"}],"components.explore.subheading":[{"type":0,"value":"IMMERGITI NEL MARE DI TRANSAZIONI DI ERGO"}],"components.faq.anyQuestions":[{"type":0,"value":"QUALSIASI DOMANDA?"}],"components.faq.description":[{"type":0,"value":"Abbiamo raccolto alcune delle domande più frequenti."}],"components.faq.heading":[{"type":0,"value":"FAQ"}],"components.faq.text.2":[{"type":0,"value":"NON TROVI QUELLO "},{"type":1,"value":"breakingLine"},{"type":0,"value":"CHE CERCHI?"}],"components.favorites.button1":[{"type":0,"value":"ESPLORA ERGO RAFFLE"}],"components.getErg.BuyIt.text":[{"type":0,"value":"Disponibile su popolari scambi centralizzati e decentralizzati."}],"components.getErg.BuyIt.title":[{"type":0,"value":"Scambi"}],"components.getErg.MineIt.text":[{"type":0,"value":"Autolykos, un algoritmo di Proof-of-Work resistente alle ASIC e equamente estratto, amichevole alle GPU comuni."}],"components.getErg.MineIt.title":[{"type":0,"value":"Mineralo"}],"components.getErg.StoreIt.text":[{"type":0,"value":"Portafogli non custoditi semplici e sicuri per mantenere al sicuro i tuoi ERG."}],"components.getErg.StoreIt.title":[{"type":0,"value":"Portafogli"}],"components.getErg.UseIt.title":[{"type":0,"value":"Metti i tuoi ERG in uso oggi stesso nel nostro crescente ecosistema."}],"components.getErg.description":[{"type":0,"value":"C\'è un ecosistema florido che si sta sviluppando su Ergo. Che tu sia uno sviluppatore, un minatore o un investitore, siamo pronti a soddisfare le tue esigenze."}],"components.getErg.heroTitle":[{"type":0,"value":"DEFI IMPARABILE"}],"components.getErg.title":[{"type":0,"value":"Ottieni ERG"}],"components.grantsAndBounties.button1":[{"type":0,"value":"BOUNTIES"}],"components.grantsAndBounties.button2":[{"type":0,"value":"INIZIA UNA RAFFLE"}],"components.grantsAndBounties.button3":[{"type":0,"value":"CONTATTACI"}],"components.grantsAndBounties.description":[{"type":0,"value":"In generale, qualsiasi cosa educativa per la comunità è soggetta ad una ricompensa anche se non elencata specificamente. Cerchiamo di finanziare borse di studio per progetti che si concentrano sulla costruzione di infrastrutture chiave dell\'ecosistema. Tuttavia, il modo più veloce per ottenere un finanziamento è di avviare una lotteria."}],"components.grantsAndBounties.heading":[{"type":0,"value":"Borse di studio e incentivi"}],"components.hallOfFame.description1":[{"type":0,"value":"Ergo è stata fondata con un team che ha una solida esperienza nello sviluppo di base con criptovalute e framework blockchain tra cui NXT, Scorex, Cardano e Waves. Di seguito sono riportate brevi biografie per alcuni dei team principali di ERGO, nonché alcuni dei molti altri sviluppatori e membri della comunità coinvolti, alcuni dei quali sono anonimi."}],"components.hallOfFame.description2":[{"type":0,"value":"Ergo è di base, e la maggior parte dei membri del team principale (e anche dei membri della fondazione) hanno iniziato come membri della comunità. C\'è una breve descrizione e informazioni per saperne di più sulla Fondazione Ergo in fondo a questa pagina."}],"components.hallOfFame.tab1":[{"type":0,"value":"CORE"}],"components.hallOfFame.tab2":[{"type":0,"value":"COMMUNITY"}],"components.hallOfFame.tab3":[{"type":0,"value":"FONDAZIONE"}],"components.hallOfFame.title":[{"type":0,"value":"Hall Of Fame"}],"components.highlights.slide.1.quote":[{"type":0,"value":"95,57% "},{"type":1,"value":"breakingLine"},{"type":0,"value":" Allocazione pubblica"}],"components.highlights.slide.1.text":[{"type":0,"value":"Quando Ergo è stato lanciato nel 2019, non c\'è stata alcuna offerta iniziale di monete, pre-mining o pre-allocazione di token a membri del team o venture capitalist. Un vero e proprio lancio equo con il 4,43% dei fondi allocati allo sviluppo dell\'ecosistema. Ineguagliabile in qualsiasi altra piattaforma smart-contract."}],"components.highlights.slide.1.title":[{"type":0,"value":"Un inizio equo"}],"components.highlights.slide.2.quote":[{"type":0,"value":"Vero P2P"}],"components.highlights.slide.2.text":[{"type":0,"value":"Permette implementazioni più innovative e mirate che la banca tradizionale non può eguagliare. Ergo offre strumenti potenti con strutture di microcredito alimentate da smart contract e Local Exchange Trading Systems (LETS)."}],"components.highlights.slide.2.title":[{"type":0,"value":"Economia alternativa"}],"components.highlights.slide.3.quote":[{"type":0,"value":"Σ-protocolli"}],"components.highlights.slide.3.text":[{"type":0,"value":"La privacy deve rimanere un\'opzione per proteggere l\'autonomia. La privacy è la capacità di creare barriere e alzare le frontiere per creare uno spazio per l\'individuo. Sta a ciascuno decidere quali confini e barriere creare. Ciò consente nuovi modelli di interazione finanziaria, supportati da un linguaggio di scripting sicuro e ricco, ErgoScript e da prove di zero-conoscenza flessibili e potenti."}],"components.highlights.slide.3.title":[{"type":0,"value":"Privacy opzionale"}],"components.highlights.title":[{"type":0,"value":"IN EVIDENZA"}],"components.homeHero.button":[{"type":0,"value":"ESPLORA"}],"components.homeHero.text":[{"type":0,"value":"Ergo è una piattaforma di smart contract di nuova generazione che garantisce la libertà economica delle persone attraverso strumenti finanziari sicuri, accessibili e decentralizzati."}],"components.homeHero.title":[{"type":0,"value":"Alimentare il futuro della finanza"}],"components.homeInfo.blockReward":[{"type":0,"value":"RICONOSCIMENTO BLOCCO"}],"components.homeInfo.circulatingSupply":[{"type":0,"value":"RIFORNIMENTO CIRCOLANTE"}],"components.homeInfo.hashRate":[{"type":0,"value":"FREQUENZA HASH"}],"components.homeInfo.transactionPerDay":[{"type":0,"value":"TRASAZIONI AL GIORNO"}],"components.learn.description":[{"type":0,"value":"Parti dalle basi. Cos\'è Ergo? Cosa puoi fare su Ergo?"}],"components.learn.heading":[{"type":0,"value":"Imparare"}],"components.mining.button1":[{"type":0,"value":"DOCUMENTAZIONE"}],"components.mining.button2":[{"type":0,"value":"STATISTICHE DELLA POOL DI MINING"}],"components.mining.button3":[{"type":0,"value":"DISCORD"}],"components.mining.button4":[{"type":0,"value":"SUBREDDIT"}],"components.mining.button5":[{"type":0,"value":"POST DEL BLOG DI MINING"}],"components.mining.calculator.currentBlockReward":[{"type":0,"value":"Ricompensa attuale per blocco"}],"components.mining.calculator.currentPrice":[{"type":0,"value":"Prezzo attuale"}],"components.mining.calculator.description":[{"type":0,"value":"Autolykos è l\'algoritmo di Proof of Work (PoW) ASIC-resistant orientato alla memoria resistente ai miner orientato alle GPU."}],"components.mining.calculator.networkHashrate":[{"type":0,"value":"Hashrate di rete"}],"components.mining.calculator.rev":[{"type":0,"value":"Guadagno giornaliero"}],"components.mining.calculator.title":[{"type":0,"value":"Calcolatore di mining"}],"components.mining.minersTitle":[{"type":0,"value":"Minatori"}],"components.mining.miningPoolsTitle":[{"type":0,"value":"Pool di mining"}],"components.mining.text.1":[{"type":0,"value":"Il mining di Ergo si basa su Autolikos, un algoritmo Proof of Work scritto in Scala, resistente agli ASIC. Può funzionare sulla maggior parte delle GPU di fascia bassa a temperature più basse rispetto ad altri algoritmi, aumentando la longevità delle apparecchiature di mining. Combinato con il modello eUTXO e spostando la catena di sollevamento pesante, questo crea una prova di lavoro altamente efficiente."}],"components.mining.text.2":[{"type":0,"value":"Benvenuto nel futuro di Proof of Work."}],"components.mining.text.3":[{"type":0,"value":"Per iniziare, dai un\'occhiata al Manuale di Mining creato dalla community o unisciti agli spazi di discussione sul mining."}],"components.mining.title":[{"type":0,"value":"Mining"}],"components.news.blog":[{"type":0,"value":"Blog"}],"components.news.latest":[{"type":0,"value":"ultime notizie"}],"components.news.title":[{"type":0,"value":"Notizie"}],"components.ourFavorites.heading":[{"type":0,"value":"I NOSTRI PREFERITI"}],"components.ourmission.description":[{"type":0,"value":"Ergo Foundation è impegnata nello sviluppo organico e senza interruzioni del protocollo Ergo Platform."}],"components.ourmission.emissionAndTokenomics":[{"type":0,"value":"EMISSIONE E TOKENOMICS"}],"components.ourmission.ergofoundation":[{"type":0,"value":"LA FONDAZIONE ERGO"}],"components.ourmission.reachus.twitter":[{"type":0,"value":"RAGGIUNGICI SU TWITTER"}],"components.ourmission.subdescription":[{"type":0,"value":"La Fondazione Ergo si impegna a compiere sforzi per massimizzare il numero di preziosi sviluppi dell\'ecosistema realizzati in modo open-source con la licenza meno permissiva possibile."}],"components.ourmission.title":[{"type":0,"value":"La nostra missione"}],"components.partners.title":[{"type":0,"value":"Partner"}],"components.roadmap.coinmarketcal":[{"type":0,"value":"VISUALIZZA ALTRO SU COINMARKETCAL"}],"components.roadmap.description":[{"type":0,"value":"Si prega di notare che Ergo è una piattaforma. Molti dei progetti elencati di seguito non hanno alcun legame formale con la Ergo Foundation o tra di loro."}],"components.roadmap.section1.title":[{"type":0,"value":"FINORA"}],"components.roadmap.section2.title":[{"type":0,"value":"ECOSISTEMA"}],"components.roadmap.section3.title":[{"type":0,"value":"PRESTO"}],"components.roadmap.section4.title":[{"type":0,"value":"2024 & OLTRE"}],"components.roadmap.title":[{"type":0,"value":"Roadmap"}],"components.software.description":[{"type":0,"value":"Il nodo Ergo è il tuo punto di ingresso per lo sviluppo su Ergo e ti consente di comunicare con la blockchain."}],"components.software.heading":[{"type":0,"value":"Software"}],"components.uniqueErgo.card1.button":[{"type":0,"value":"ESPLORA"}],"components.uniqueErgo.card1.text":[{"type":0,"value":"Ergo attinge da dieci anni di sviluppo blockchain, integrando principi collaudati con la migliore ricerca accademica peer-reviewed su crittografia, modelli di consenso e valute digitali. Iniziamo con solide basi blockchain e implementiamo nuova e potente crittografia in modo nativo."}],"components.uniqueErgo.card1.title":[{"type":0,"value":"LA RICERCA E IL MONDO REALE"}],"components.uniqueErgo.card2.button":[{"type":0,"value":"ESPLORA"}],"components.uniqueErgo.card2.text":[{"type":0,"value":"Ergo fornisce un supporto superiore per accordi finanziari del mondo reale. Ergo può supportare dApp versatili che funzionano in modo prevedibile, con costi noti e non presentano nessuno dei pericoli di funzionalità illimitate. Ergo è intelligente e i suoi contratti ci consentono di eseguire attività ad ampio raggio e può essere Turing completo, ma sappiamo sempre in anticipo quanto costerà il codice e se funzionerà correttamente."}],"components.uniqueErgo.card2.title":[{"type":0,"value":"POTENTE E SICURO"}],"components.uniqueErgo.card3.button":[{"type":0,"value":"ESPLORA"}],"components.uniqueErgo.card3.text":[{"type":0,"value":"I protocolli Sigma sono alla base degli smart contract di Ergo. Consentono una classe di protocolli efficienti a conoscenza zero che ci consentono di implementare compiti che altrimenti sarebbero impossibili, oppure rischiosi e costosi. Ciò consente la privacy a livello di applicazione auto-sovranimica: script trustless che possono essere utilizzati per accedere a mixer o altre funzionalità, senza che sia richiesta alcuna terza parte."}],"components.uniqueErgo.card3.title":[{"type":0,"value":"INTELLIGENTE E SEMPLICE"}],"components.uniqueErgo.card4.button":[{"type":0,"value":"ESPLORA"}],"components.uniqueErgo.card4.text":[{"type":0,"value":"Pensiamo che gli utenti ordinari che non eseguono un nodo completo dovrebbero godere degli stessi vantaggi in termini di sicurezza dei minatori. La prova di lavoro non interattiva di Ergo (NiPoPoW) consente a chiunque di effettuare e verificare transazioni in totale sicurezza, senza la necessità di spazio di archiviazione, larghezza di banda e tempo necessari per scaricare l\'intera blockchain. In effetti, è necessario solo 1 MB di dati, il che significa che può essere utilizzato su qualsiasi dispositivo."}],"components.uniqueErgo.card4.title":[{"type":0,"value":"SICURO E ACCESSIBILE"}],"components.uniqueErgo.title":[{"type":0,"value":"COSA RENDE ERGO UNICO"}],"components.usingErg.BuyIt.text":[{"type":0,"value":"Disponibile su popolari scambi centralizzati e decentralizzati."}],"components.usingErg.BuyIt.title":[{"type":0,"value":"Scambi"}],"components.usingErg.MineIt.text":[{"type":0,"value":"Autolykos, un algoritmo di Proof-of-Work resistente alle ASIC e equamente estratto, amichevole alle GPU comuni."}],"components.usingErg.MineIt.title":[{"type":0,"value":"Mineralo"}],"components.usingErg.StoreIt.text":[{"type":0,"value":"Portafogli non custoditi semplici e sicuri per mantenere al sicuro i tuoi ERG."}],"components.usingErg.StoreIt.title":[{"type":0,"value":"Portafogli"}],"components.usingErg.UseIt.title":[{"type":0,"value":"Metti subito in uso i tuoi ERG nel nostro ecosistema in crescita."}],"components.usingErg.description":[{"type":0,"value":"C\'è un ricco ecosistema in erba in cima a Ergo. Che tu sia uno sviluppatore, un minatore o un investitore, ti abbiamo coperto."}],"components.usingErg.subtitle":[{"type":0,"value":"DEFI UNSTOPPABLE"}],"components.usingErg.title":[{"type":0,"value":"GET ERG"}],"components.wallets.chooseYours":[{"type":0,"value":"SCEGLI LA TUA"}],"components.wallets.coldStorageHeader":[{"type":0,"value":"Memorizzazione a freddo"}],"components.wallets.featureHeader":[{"type":0,"value":"Caratteristiche"}],"components.wallets.hotStorageHeader":[{"type":0,"value":"Memorizzazione a caldo"}],"components.wallets.mobileAppHeader":[{"type":0,"value":"App mobile"}],"components.wallets.setupGuides":[{"type":0,"value":"GUIDE DI CONFIGURAZIONE"}],"components.wallets.walletDescription1":[{"type":0,"value":"I portafogli digitali possono aiutare a mantenere al sicuro, privata e sotto il tuo controllo la tua valuta digitale."}],"components.wallets.walletDescription2":[{"type":0,"value":"Si noti che i portafogli sono supportati da terze parti, forniamo le informazioni di seguito solo a titolo di cortesia, al fine di semplificare l\'esperienza complessiva della valuta digitale per te."}],"components.wallets.walletsHeader":[{"type":0,"value":"Portafogli"}],"components.wallets.walletsTitle":[{"type":0,"value":"Portafogli"}],"components.wiki.description":[{"type":0,"value":"ergonaut.space è il nostro wiki gestito dalla comunità! Pieno di informazioni dettagliate sulla tecnologia sottostante la blockchain Ergo, esposte in un linguaggio facile da capire anche per le persone non tecniche. Inoltre, ci sono molti tutorial, guide e contenuti inviati dagli utenti. Crea un account per cominciare a contribuire!"}],"components.wiki.description.short":[{"type":0,"value":"ergonaut.space è il wiki della comunità della blockchain Ergo, una guida che traduce come utilizzare la blockchain Ergo e la tecnologia sottostante in un linguaggio facile da capire anche per le persone non tecniche."}],"components.wiki.heading":[{"type":0,"value":"Wiki"}],"footer.blog.title":[{"type":0,"value":"BLOG"}],"footer.community.1":[{"type":0,"value":"Unisciti ai nostri canali"}],"footer.community.2":[{"type":0,"value":"Sigmanauts"}],"footer.community.3":[{"type":0,"value":"Contribuisci a Ergo"}],"footer.community.4":[{"type":0,"value":"Hall of Fame"}],"footer.community.5":[{"type":0,"value":"Fondazione Ergo"}],"footer.community.title":[{"type":0,"value":"COMMUNITY"}],"footer.discover.1":[{"type":0,"value":"Versioni software"}],"footer.discover.2":[{"type":0,"value":"Finanziamenti e ricompense"}],"footer.discover.3":[{"type":0,"value":"Domande frequenti"}],"footer.discover.4":[{"type":0,"value":"Esplora"}],"footer.discover.5":[{"type":0,"value":"Documenti"}],"footer.discover.title":[{"type":0,"value":"SCOPRI"}],"footer.ecosystem.1":[{"type":0,"value":"DApps"}],"footer.ecosystem.2":[{"type":0,"value":"Roadmap"}],"footer.ecosystem.3":[{"type":0,"value":"Wiki"}],"footer.ecosystem.4":[{"type":0,"value":"Ergo Raffle"}],"footer.ecosystem.5":[{"type":0,"value":"Videocast"}],"footer.ecosystem.title":[{"type":0,"value":"ECOSISTEMA"}],"footer.getErg.1":[{"type":0,"value":"Mining"}],"footer.getErg.2":[{"type":0,"value":"Calcolatore di data mining"}],"footer.getErg.3":[{"type":0,"value":"Portafogli"}],"footer.getErg.4":[{"type":0,"value":"Scambi"}],"footer.getErg.title":[{"type":0,"value":"OTTIENI ERG"}],"footer.legal":[{"type":0,"value":"Legale"}],"footer.news.title":[{"type":0,"value":"ULTIME NEWS"}],"footer.privacyPolicy":[{"type":0,"value":"Informativa sulla privacy"}],"footer.weGotIt":[{"type":0,"value":"Ci siamo!"}],"navigation.discover":[{"type":0,"value":"SCOPRI"}],"navigation.ecosystem":[{"type":0,"value":"ECOSISTEMA"}],"navigation.ergoCommunity":[{"type":0,"value":"ERGO COMMUNITY"}],"navigation.getErg":[{"type":0,"value":"OTTIENI ERG"}],"navigation.moreContent":[{"type":0,"value":"Continua a leggere"}],"pages.404.hero":[{"type":0,"value":"404. Pagina non trovata."}],"pages.404.title":[{"type":0,"value":"Non trovato"}],"pages.blog.title":[{"type":0,"value":"Blog"}],"pages.community.title":[{"type":0,"value":"Community"}],"pages.discover.title":[{"type":0,"value":"Scopri"}],"pages.ecosystem.title":[{"type":0,"value":"Ecosistema"}],"pages.get-erg.title":[{"type":0,"value":"GetErg"}],"pages.home.title":[{"type":0,"value":"Casa"}],"pages.legal.title":[{"type":0,"value":"Legale"}],"pages.mobile-wallets":[{"type":0,"value":"Portafogli mobili"}],"pages.privacyPolicy.title":[{"type":0,"value":"Informativa sulla privacy"}]}');
;// CONCATENATED MODULE: ./content/compiled-locales/tr.json
var tr_namespaceObject = JSON.parse('{"components.ContributeForm.company.subTitle":[{"type":0,"value":"ORTAK OLMAK İSTER MİSİN?"}],"components.ContributeForm.company.title":[{"type":0,"value":"Biz "},{"children":[{"type":0,"value":"şirketiz"}],"type":8,"value":"b"}],"components.ContributeForm.developer.subTitle":[{"type":0,"value":"NASIL KATKI YAPABİLİRİM?"}],"components.ContributeForm.developer.title":[{"type":0,"value":"Ben bir  "},{"children":[{"type":0,"value":"geliştiriciyim."}],"type":8,"value":"b"}],"components.ContributeForm.text":[{"type":0,"value":"Ergo, "},{"children":[{"type":0,"value":"herkesin katkıda bulunabileceği"}],"type":8,"value":"b"},{"type":0,"value":" açık bir model üzerinde çalışıyor."}],"components.ContributeForm.title":[{"type":0,"value":"Katkı yap"}],"components.DApps.seeAllProjects":[{"type":0,"value":"TÜM PROJELERİ GÖRÜNTÜLE"}],"components.Sigmanauts.button":[{"type":0,"value":"DAHA FAZLA & UYGULA"}],"components.Sigmanauts.button.buttonContribute":[{"type":0,"value":"KATKI KILAVUZLARI"}],"components.Sigmanauts.button.discord":[{"type":0,"value":"DISCORD\'A KATILIN"}],"components.Sigmanauts.button.grantsAndBounties":[{"type":0,"value":"BAĞIŞLAR & ÖDÜLLLER"}],"components.Sigmanauts.button.writeAndReviewCode":[{"type":0,"value":"ERGO\'YA DALIŞ"}],"components.Sigmanauts.formInput.button":[{"type":0,"value":"Gönder"}],"components.Sigmanauts.formInput.email":[{"type":0,"value":"E-Posta"}],"components.Sigmanauts.formInput.name":[{"type":0,"value":"İsim / Şirket"}],"components.Sigmanauts.formInput.text":[{"type":0,"value":"Önerilerinizi ve fikirlerinizi bize yazın. Hadi konuşalım!"}],"components.Sigmanauts.subTitle":[{"type":0,"value":"Eğitim Programı"}],"components.Sigmanauts.text":[{"type":0,"value":"Ergo\'nun şekillenmesine ve büyümesine yardımcı olmak için Sigmanaut Eğitim Programına başvurun. "},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":" Sıfırdan finansman oluşturalım."}],"components.Sigmanauts.title":[{"type":0,"value":"Sigmanauts"}],"components.Spotlight.button":[{"type":0,"value":"TÜM GÖNDERİLERİ GÖR"}],"components.Spotlight.title":[{"type":0,"value":"Gündem"}],"components.autolykos.button":[{"type":0,"value":"ERG EDİN"}],"components.autolykos.header":[{"type":0,"value":"AUTOLYKOS"}],"components.autolykos.text":[{"children":[{"type":0,"value":"Autolykos"}],"type":8,"value":"b"},{"type":0,"value":" GPU\'lara yönelik, ASIC\'e dayanıklı İş Kanıtı algoritmasıdır."}],"components.autolykos.title":[{"type":0,"value":"İş Kanıtı\'nın Geleceği"}],"components.communityHero.subtitle":[{"type":0,"value":"SIFIRDAN FİNANSMAN"}],"components.communityHero.title":[{"type":0,"value":"Topluluk"}],"components.communitySection.communityHero.linkText":[{"type":0,"value":"Katkı"}],"components.communitySection.communityHero.text1":[{"type":0,"value":"Ergo sıfırdan oluşturulan merkezi olmayan bir platformdur ve kendi topluluğu tarafından desteklenir."}],"components.communitySection.communityHero.text2":[{"type":0,"value":"Sosyalden bize katılın ve dahil olun. Kontrol edin"}],"components.communitySection.communityHero.text3":[{"type":0,"value":"daha fazla bilgi için sayfasına bakın"}],"components.dApps.heading":[{"type":0,"value":"DApps"}],"components.discoverErgo.text.1":[{"type":0,"value":"Ergo, esnek ve güçlü Sıfır Bilgi kanıtlarıyla (Σ-protokolleri) oluşturulmuş güvenli ve zengin bir kodlama diliyle desteklenen, yeni finansal etkileşim modellerine olanak tanıyan yeni nesil bir İş Kanıtı akıllı sözleşme platformudur."}],"components.discoverHero.button1":[{"type":0,"value":"DÖKÜMANLARI OKUYUN"}],"components.discoverHero.button2":[{"type":0,"value":"DECO İLE ÖĞRENİN"}],"components.discoverHero.button3":[{"type":0,"value":"MANİFESTO\'YU OKUYUN"}],"components.discoverHero.button4":[{"type":0,"value":"BLOG\'A BAKIN"}],"components.discoverHero.button5":[{"type":0,"value":"KURULUM DOSYASI ALIN"}],"components.discoverHero.button6":[{"type":0,"value":"ERGONAUT.SPACE\'İ ZİYARET EDİN"}],"components.discoverHero.title":[{"type":0,"value":"Ergo\'yu Keşfet"}],"components.documents.description":[{"type":0,"value":"Ergo, araştırmaya dayalı bir yaklaşım benimsiyor ve geliştiricilerin gelecek yıllarda üzerine inşa edebileceği sağlam bir platform sağlamak için istikrarlı, iyi test edilmiş çözümler kullanıyor. Ergo çözümlerinin çoğu, hakemli konferanslarda sunulan makalelerde resmileştirilmiş ve toplulukta geniş çapta tartışılmıştır."}],"components.documents.heading":[{"type":0,"value":"Belgeler"}],"components.ecosystemHero.title":[{"type":0,"value":"Eko sistem"}],"components.ergoExplorer.button1":[{"type":0,"value":"TARAYICI"}],"components.ergoExplorer.button2":[{"type":0,"value":"ERGO.WATCH"}],"components.ergoRaffle.description":[{"type":0,"value":"ErgoRaffle, herkesin bir proje için para toplamasını sağlayan, Ergo Platformu üzerine kurulu bir kitlesel fonlama hizmetidir. Bu proje, doğrudan bir bağıştan bir hayır kurumuna, akademik veya iş planına veya insanları zorlukla kazandıkları ERG\'den ayrılmaya ikna edebileceğiniz herhangi bir şey olabilir! Ek bir bonus olarak, Çekilişi bitirdikten sonra bir piyango düzenlenir ve şanslı bir katılımcı, \\"çekiliş ödülü\\" olarak çekilişin belirli bir yüzdesini kazanır."}],"components.ergoRaffle.heading":[{"type":0,"value":"Ergo Çekiliş"}],"components.ergofoundation.list1":[{"type":0,"value":"Ergo Platform protokolünün "},{"children":[{"type":0,"value":"kesintisiz gelişiminin"}],"type":8,"value":"b"},{"type":0,"value":" desteklenmesi;"}],"components.ergofoundation.list2":[{"type":0,"value":"Ergo Platformunun ve onun "},{"children":[{"type":0,"value":" yerel tokeninin "}],"type":8,"value":"b"},{"type":0,"value":" (ERG) yaygın şekilde benimsenmesini ve kullanımını artırmak;"}],"components.ergofoundation.list3":[{"type":0,"value":"Ergo Platformu çevresinde "},{"children":[{"type":0,"value":"ekosistemin"}],"type":8,"value":"b"},{"type":0,"value":" geliştirilmesi;"}],"components.ergofoundation.list4":[{"children":[{"type":0,"value":" Toplumsal fayda "}],"type":8,"value":"b"},{"type":0,"value":" için Ergo Platformu ve blockchain teknolojisinin kullanımını yaygınlaştırmak;"}],"components.ergofoundation.list5":[{"children":[{"type":0,"value":"Gerçekten merkezi olmayan altyapıyı"}],"type":8,"value":"b"},{"type":0,"value":" destekleyin ve;"}],"components.ergofoundation.list6":[{"children":[{"type":0,"value":"Gizliliği"}],"type":8,"value":"b"},{"type":0,"value":" temel bir insan hakkı olarak desteklemek."}],"components.ergofoundation.title":[{"children":[{"type":0,"value":"Ergo Vakfı"}],"type":8,"value":"b"},{"type":0,"value":", topluluk odaklı bir kuruluş olup,"}],"components.exchanges.available":[{"type":0,"value":"Popüler borsalarda ve merkezi olmayan borsalarda mevcuttur."}],"components.exchanges.disclaimer":[{"type":0,"value":"Sorumluluk reddi: Borsalar, fonlarınız ve bilgileriniz üzerinde oldukça farklı derecelerde emniyet, güvenlik, gizlilik ve kontrol sağlar. Kendi paranızı cüzdanınızda saklamanızı ve yukarıda verilen cüzdan seçeneklerinden birini kullanmanızı önemle tavsiye ederiz."}],"components.exchanges.heading":[{"type":0,"value":"ERGO\'YU AL, SAT VE TİCARET YAP"}],"components.exchanges.subheading":[{"type":0,"value":"Borsalar"}],"components.explore.description":[{"type":0,"value":"Ergo Explorer, blockchain arayüzüdür. Gerçek zamanlı olarak yapılan her işlemi izleyin. Veya ergo.watch\'ta topluluğun seçtiği ölçümleri görüntüleyin."}],"components.explore.heading":[{"type":0,"value":"Keşfet"}],"components.explore.subheading":[{"type":0,"value":"ERGO\'NUN İŞLEMLER DENİZİNE DALIN"}],"components.faq.anyQuestions":[{"type":0,"value":"HERHANGİ BİR SORU?"}],"components.faq.description":[{"type":0,"value":"En sık sorulan sorulardan bazılarını derledik."}],"components.faq.heading":[{"type":0,"value":"SSS"}],"components.faq.text.2":[{"type":0,"value":"ARADIĞINIZ ŞEYİ "},{"type":1,"value":"breakingLine"},{"type":0,"value":" BULAMADINIZ MI?"}],"components.favorites.button1":[{"type":0,"value":"ERGO ÇEKİLİŞLERİNİ KEŞFET"}],"components.getErg.BuyIt.text":[{"type":0,"value":"Popüler merkezi ve merkezi olmayan borsalarda mevcuttur."}],"components.getErg.BuyIt.title":[{"type":0,"value":"Borsalar"}],"components.getErg.MineIt.text":[{"type":0,"value":"Autolykos, ASIC\'e dayanıklı ve yaygın olarak kullanılan GPU\'lara (Ekran Kartları) uygun bir İş Kanıtı algoritması."}],"components.getErg.MineIt.title":[{"type":0,"value":"Kazmaya başla"}],"components.getErg.StoreIt.text":[{"type":0,"value":"ERG\'nizi güvende tutmak için basit ve güvenli gözetlenemeyen cüzdanlar."}],"components.getErg.StoreIt.title":[{"type":0,"value":"Cüzdanlar"}],"components.getErg.UseIt.text":[{"type":0,"value":"ERG\'nizi büyüyen ekosistemimizde bugün kullanmaya başlayın"}],"components.getErg.UseIt.title":[{"type":0,"value":"Ekosistem"}],"components.getErg.description":[{"type":0,"value":"Ergo\'nun üzerinde gelişen zengin bir ekosistem var. İster geliştirici, madenci veya yatırımcı olun, yanınızdayız."}],"components.getErg.title":[{"type":0,"value":"ERG Al"}],"components.grantsAndBounties.button1":[{"type":0,"value":"KATKI"}],"components.grantsAndBounties.button2":[{"type":0,"value":"ÇEKİLİŞ BAŞLAT"}],"components.grantsAndBounties.button3":[{"type":0,"value":"TEMAS SAĞLAYIN"}],"components.grantsAndBounties.description":[{"type":0,"value":"Genel olarak, toplum için eğitici olan her şey, özel olarak belirtilmemiş olsa bile, bir miktar ödüle tabidir. Temel ekosistem altyapısı oluşturmaya odaklanan projeler için yardım fonu arıyoruz. Ancak, biraz fon almanın en hızlı yolu bir Çekiliş başlatmaktır."}],"components.grantsAndBounties.heading":[{"type":0,"value":"Yardımlar & Ödüller"}],"components.hallOfFame.description1":[{"type":0,"value":"Ergo, NXT, Scorex, Cardano ve Waves dahil olmak üzere kripto para birimleri ve blockchain çerçeveleri ile temel geliştirme konusunda sağlam bir geçmişe sahip bir ekiple kuruldu. Aşağıda, bazı çekirdek ERGO ekibinin yanı sıra, bazılarının anonim olduğu diğer birçok geliştirici ve topluluk üyesinin kısa biyografileri bulunmaktadır."}],"components.hallOfFame.description2":[{"type":0,"value":"Ergo sıfırdan kurulmadır ve çekirdek ekip üyelerinin çoğu (ve hatta vakıf üyeleri) topluluk üyesi olarak işe başlamıştır. Bu sayfanın alt kısmında Ergo Vakfı hakkında daha fazla bilgi edinmek için kısa bir açıklama ve bilgi bulunmaktadır."}],"components.hallOfFame.tab1":[{"type":0,"value":"ÇEKİRDEK"}],"components.hallOfFame.tab2":[{"type":0,"value":"TOPLULUK"}],"components.hallOfFame.tab3":[{"type":0,"value":"VAKIF"}],"components.hallOfFame.title":[{"type":0,"value":"Onur Listesi"}],"components.highlights.slide.1.quote":[{"type":0,"value":"%95.57 "},{"type":1,"value":"breakingLine"},{"type":0,"value":" Halk\'a Tahsis"}],"components.highlights.slide.1.text":[{"type":0,"value":"Ergo, 2019\'da başka hiçbir akıllı sözleşme platformuna benzemeyen bir dağıtımla hayata geçirilen, topluluk odaklı bir projedir; fonların %4,43\'ü Ergo Vakfı Hazinesine tahsis edilmiş olup, sağlam ve merkezi olmayan bir ekosistemi teşvik etme kararlılığımızın altını çizmektedir. "},{"type":1,"value":"breakingLine"}],"components.highlights.slide.1.title":[{"type":0,"value":"Adil Bir Başlangıç"}],"components.highlights.slide.2.quote":[{"type":0,"value":"GERÇEK P2P"}],"components.highlights.slide.2.text":[{"type":0,"value":"Geleneksel bankacılığın karşılayamayacağı daha yenilikçi, hedefe yönelik uygulamaları mümkün kılmak. Ergo, akıllı sözleşmeyle desteklenen mikrokredi olanakları ve Yerel Borsa Ticaret Sistemleri (LETS) ile güçlü araçlar sunar. "},{"type":1,"value":"breakingLine"}],"components.highlights.slide.2.title":[{"type":0,"value":"Alternatif Ekonomi"}],"components.highlights.slide.3.quote":[{"type":0,"value":"Σ-Protokolleri"}],"components.highlights.slide.3.text":[{"type":0,"value":"Özerkliği korumak için gizlilik bir seçenek olarak kalmalıdır. Mahremiyet, bireye alan yaratmak için bariyerler yaratma ve sınırlar koyma yeteneğidir. Hangi sınırları çizmek istediği kişiye bağlıdır. Bu, güvenli ve zengin bir kodlama dili. ErgoScript, esnek ve güçlü Sıfır Bilgi kanıtlarıyla desteklenen yeni finansal etkileşim modellerine olanak tanır. "},{"type":1,"value":"breakingLine"}],"components.highlights.slide.3.title":[{"type":0,"value":"İsteğe Bağlı Gizlilik"}],"components.highlights.title":[{"type":0,"value":"ÖNE ÇIKANLAR"}],"components.homeHero.button":[{"type":0,"value":"KEŞFET"}],"components.homeHero.pitchDeckButton":[{"type":0,"value":"SUNUM"}],"components.homeHero.text":[{"type":0,"value":"Ergo, güvenli, erişilebilir ve merkezi olmayan finansal araçlar aracılığıyla sıradan insanların ekonomik özgürlüğünü sağlayan bir sonraki nesil akıllı sözleşme platformudur."}],"components.homeHero.title":[{"type":0,"value":"Finansın Geleceğine Verilen Güç"}],"components.homeInfo.blockReward":[{"type":0,"value":"BLOK ÖDÜLÜ"}],"components.homeInfo.circulatingSupply":[{"type":0,"value":"DOLAŞIMDAKİ ARZ"}],"components.homeInfo.hashRate":[{"type":0,"value":"HASH ORANI"}],"components.homeInfo.transactionPerDay":[{"type":0,"value":"GÜNLÜK İŞLEMLER"}],"components.learn.description":[{"type":0,"value":"Temelden başlayın. Ergo nedir? Ergo\'da neler yapabilirsiniz?"}],"components.learn.heading":[{"type":0,"value":"Öğren"}],"components.mining.button1":[{"type":0,"value":"DOKÜMANTASYON"}],"components.mining.button2":[{"type":0,"value":"MADENCİ HAVUZ İSTATİSTİKLERİ"}],"components.mining.button3":[{"type":0,"value":"DISCORD"}],"components.mining.button4":[{"type":0,"value":"SUBREDDIT"}],"components.mining.button5":[{"type":0,"value":"MADENCİ BLOG YAZILARI"}],"components.mining.button6":[{"type":0,"value":"EMİSYON & TOKENOMICS"}],"components.mining.calculator.currentBlockReward":[{"type":0,"value":"Mevcut blok ödülü"}],"components.mining.calculator.currentPrice":[{"type":0,"value":"Mevcut fiyat"}],"components.mining.calculator.description":[{"type":0,"value":"Autolykos, GPU\'lar için yönlendirilmiş, bellek-zor ASIC-dirençli Proof of Work (PoW) algoritmasıdır."}],"components.mining.calculator.hash":[{"type":0,"value":"Hash oranınız"}],"components.mining.calculator.networkHashrate":[{"type":0,"value":"Ağ hash oranı"}],"components.mining.calculator.rev":[{"type":0,"value":"Günlük gelir"}],"components.mining.calculator.title":[{"type":0,"value":"Madencilik Hesaplayıcı"}],"components.mining.minersTitle":[{"type":0,"value":"Madenciler"}],"components.mining.miningPoolsTitle":[{"type":0,"value":"Madencilik Havuzları"}],"components.mining.text.1":[{"type":0,"value":"Ergo madenciliği, Autolykos\'a dayalı olarak gerçekleştirilen verimli ASIC-dirençli Proof of Work algoritmasına dayanmaktadır. Madenciler, zincir üzerinde oylama ile parametreleri ayarlayabilir; daha büyük değişiklikler, yumuşak bir çatal ile süper çoğunluk tarafından uygulanır. Ayrıca, oy tokenleri, alt havuzlama ve log-alan madenciliği gibi heyecan verici gelişmelerin herhangi birine katılabilirler. Ergo, çekirdekte basitlik üzerine odaklanırken, dayanıklı, sözleşmeli para yaratmak için uygulama katmanında gelişmiş özellikler bulunmaktadır."}],"components.mining.text.2":[{"type":0,"value":"Proof of Work\'ün geleceğine hoş geldiniz."}],"components.mining.text.3":[{"type":0,"value":"Başlamak için, topluluk tarafından oluşturulan Madencilik El Kitabı\'nı, Dokümantasyonu kontrol edin veya madencilik tartışma alanlarına katılın."}],"components.mining.title":[{"type":0,"value":"Madencilik"}],"components.news.blog":[{"type":0,"value":"Blog"}],"components.news.latest":[{"type":0,"value":"en son haberler"}],"components.news.title":[{"type":0,"value":"Haberler"}],"components.ourFavorites.heading":[{"type":0,"value":"FAVORİLERİMİZ"}],"components.ourmission.description":[{"type":0,"value":"Ergo Vakfı, Ergo Platform protokolünün organik ve bozulmamış gelişimine bağlıdır."}],"components.ourmission.emissionAndTokenomics":[{"type":0,"value":"EMİSYON VE TOKENOMICS"}],"components.ourmission.ergofoundation":[{"type":0,"value":"ERGO VAKFI"}],"components.ourmission.reachus.twitter":[{"type":0,"value":"TWITTER\'DA BİZE ULAŞIN"}],"components.ourmission.subdescription":[{"type":0,"value":"Ergo Vakfı, en az izin veren lisansla yapılan değerli ekosistem gelişmelerinin sayısını maksimize etmek için çaba göstermektedir."}],"components.ourmission.title":[{"type":0,"value":"Misyonumuz"}],"components.partners.title":[{"type":0,"value":"Ortaklar"}],"components.roadmap.coinmarketcal":[{"type":0,"value":"COINMARKETCAL\'DA DAHA FAZLASINI GÖRÜNTÜLE"}],"components.roadmap.description":[{"type":0,"value":"Lütfen Ergo\'nun bir platform olduğunu unutmayın. Aşağıda listelenen projelerin çoğunun Ergo Vakfı veya birbiriyle resmi bir bağlantısı yoktur."}],"components.roadmap.section1.title":[{"type":0,"value":"ŞUANA KADAR"}],"components.roadmap.section2.title":[{"type":0,"value":"EKOSİSTEM"}],"components.roadmap.section3.title":[{"type":0,"value":"YAKINDA"}],"components.roadmap.section4.title":[{"type":0,"value":"2023 VE SONRASI"}],"components.roadmap.title":[{"type":0,"value":"Yol Haritası"}],"components.software.description":[{"type":0,"value":"Ergo Düğümü, Ergo üzerinde geliştirme yapmanızı sağlar ve blok zinciri ile iletişim kurmanıza olanak tanır."}],"components.software.heading":[{"type":0,"value":"Yazılım"}],"components.uniqueErgo.card1.button":[{"type":0,"value":"KEŞFET"}],"components.uniqueErgo.card1.text":[{"type":0,"value":"Ergo, on yılın üzerinde blok zinciri gelişiminden faydalanarak, kriptografi, uzlaşma modelleri ve dijital para birimleri üzerine en iyi hakemli akademik araştırmalarla test edilmiş prensipleri tamamlar. Sağlam blok zinciri temelleriyle başlarız ve yeni ve güçlü kriptografiyi doğal olarak uygularız."}],"components.uniqueErgo.card1.title":[{"type":0,"value":"ARAŞTIRMA VE GERÇEK DÜNYAYA ODAKLI"}],"components.uniqueErgo.card2.button":[{"type":0,"value":"KEŞFET"}],"components.uniqueErgo.card2.text":[{"type":0,"value":"Ergo, gerçek dünya finansal anlaşmaları için üstün destek sağlar. Ergo, tahmin edilebilir bir şekilde çalışan çok yönlü dApp\'leri destekler, belirli maliyetlere sahiptir ve sınırsız işlevselliğin hiçbir tehlikesi yoktur. Ergo\'nun akıllı sözleşmeleri geniş kapsamlı görevleri yürütmemize izin verir ve Turing tamamlanabilir, ancak her zaman önceden ne kadar mal olacağını ve başarılı bir şekilde çalışıp çalışmayacağını biliriz."}],"components.uniqueErgo.card2.title":[{"type":0,"value":"GÜÇLÜ VE GÜVENLİ"}],"components.uniqueErgo.card3.button":[{"type":0,"value":"KEŞFET"}],"components.uniqueErgo.card3.text":[{"type":0,"value":"Sigma Protokolleri (Σ-Protokolleri), Ergo\'nun akıllı sözleşmelerinin temelidir. Bu protokoller, imkansız, riskli veya pahalı olacak karmaşık görevleri uygulamamıza olanak tanıyan verimli sıfır bilgi protokollerinin bir sınıfına izin verir. Kendi kendine egemen uygulama seviyesi gizliliğine hoş geldiniz: üçüncü taraflara gerek duyulmadan karıştırıcıları veya diğer işlevleri kullanmak için üçüncü tarafa ihtiyaç duymayan betikler."}],"components.uniqueErgo.card3.title":[{"type":0,"value":"AKILLI VE BASİT"}],"components.uniqueErgo.card4.button":[{"type":0,"value":"KEŞFET"}],"components.uniqueErgo.card4.text":[{"type":0,"value":"Tam düğüm çalıştırmayan sıradan kullanıcılar, madencilerle aynı güvenlik avantajlarından faydalanmalıdır. Non-Interactive Proofs of Proof-of-Work (NIPOPOWS), tam blok zincirini indirmek için gereken depolama, bant genişliği ve zaman gerektirmeksizin tamamen güvenle işlem yapmamızı ve doğrulamamızı sağlar. Yalnızca 1 MB veri gereklidir, bu da herhangi bir cihazı kullanabileceğiniz anlamına gelir."}],"components.uniqueErgo.card4.title":[{"type":0,"value":"GÜVENLİ VE ERİŞİLEBİLİR"}],"components.uniqueErgo.title":[{"type":0,"value":"ERGO\'YU BENZERSİZ YAPAN NEDİR?"}],"components.usingErg.BuyIt.text":[{"type":0,"value":"Popüler merkezi ve merkezi olmayan borsalarda mevcuttur."}],"components.usingErg.BuyIt.title":[{"type":0,"value":"Borsalar"}],"components.usingErg.MineIt.text":[{"type":0,"value":"Autolykos, ASIC\'e dayanıklı ve yaygın olarak kullanılan GPU\'lara (Ekran Kartları) uygun bir İş Kanıtı algoritması."}],"components.usingErg.MineIt.title":[{"type":0,"value":"Kazmaya başla"}],"components.usingErg.StoreIt.text":[{"type":0,"value":"ERG\'nizi güvende tutmak için basit ve güvenli gözetlenemeyen cüzdanlar."}],"components.usingErg.description":[{"type":0,"value":"Ergo zengin bir ekosistem gelişmektedir. Geliştirici, madenci veya yatırımcı olmanız fark etmez, herkesi destekleriz."}],"components.usingErg.subtitle":[{"type":0,"value":"DURDURULAMAZ DEFI"}],"components.usingErg.title":[{"type":0,"value":"ERG EDİN"}],"components.wallets.ErgoPay":[{"type":0,"value":"ErgoPay"}],"components.wallets.chooseYours":[{"type":0,"value":"SENİNKİNİ SEÇ"}],"components.wallets.coldStorageHeader":[{"type":0,"value":"Soğuk Depolama"}],"components.wallets.dAppConnectorHeader":[{"type":0,"value":"dApp Bağlayıcı"}],"components.wallets.featureHeader":[{"type":0,"value":"Özellik"}],"components.wallets.setupGuides":[{"type":0,"value":"KURULUM REHBERLERİ"}],"components.wallets.walletDescription1":[{"type":0,"value":"Dijital cüzdanlar dijital paranızı güvenli, özel ve kontrolünüzde tutmanıza yardımcı olabilir."}],"components.wallets.walletDescription2":[{"type":0,"value":"Cüzdanlar üçüncü taraflar tarafından desteklenmektedir, aşağıdaki bilgileri size genel dijital para deneyiminizi basitleştirmek için bir nezaket olarak sağlıyoruz."}],"components.wallets.walletsHeader":[{"type":0,"value":"Cüzdanlar"}],"components.wallets.walletsTitle":[{"type":0,"value":"Cüzdanlar"}],"components.wiki.description":[{"type":0,"value":"ergonaut.space topluluk destekli bir wiki\'dir! Ergo blok zincirinin temel teknik detayları hakkında, teknik olmayan kişiler için anlaşılabilir bir dilde bol miktarda harika bilgi doludur. Ayrıca birçok kılavuz, eğitim ve kullanıcı tarafından gönderilen içerik bulunmaktadır. Katkıda bulunmaya başlamak için bir hesap oluşturun!"}],"components.wiki.description.short":[{"type":0,"value":"ergonaut.space, Ergo blok zincirinin topluluk wiki\'sidir, teknik olmayan kişiler için Ergo blok zincirinin kullanımı ve temel teknik detaylarını çeviren bir rehberdir."}],"components.wiki.heading":[{"type":0,"value":"Wiki"}],"footer.blog.title":[{"type":0,"value":"BLOG"}],"footer.community.1":[{"type":0,"value":"Kanallarımıza katılın"}],"footer.community.2":[{"type":0,"value":"Sigmanauts"}],"footer.community.3":[{"type":0,"value":"Ergo\'ya Katkıda Bulunun"}],"footer.community.4":[{"type":0,"value":"Onur Listesi"}],"footer.community.5":[{"type":0,"value":"Ergo Vakfı"}],"footer.community.title":[{"type":0,"value":"TOPLULUK"}],"footer.discover.1":[{"type":0,"value":"Yazılım Sürümleri"}],"footer.discover.2":[{"type":0,"value":"Bağışlar ve Ödüller"}],"footer.discover.3":[{"type":0,"value":"SSS"}],"footer.discover.4":[{"type":0,"value":"Keşfet"}],"footer.discover.5":[{"type":0,"value":"Belgeler"}],"footer.discover.title":[{"type":0,"value":"KEŞFET"}],"footer.ecosystem.1":[{"type":0,"value":"DApps"}],"footer.ecosystem.2":[{"type":0,"value":"Yol Haritası"}],"footer.ecosystem.3":[{"type":0,"value":"Wiki"}],"footer.ecosystem.4":[{"type":0,"value":"Ergo Çekilişi"}],"footer.ecosystem.5":[{"type":0,"value":"Videolar"}],"footer.ecosystem.title":[{"type":0,"value":"EKOSİSTEM"}],"footer.getErg.1":[{"type":0,"value":"Madencilik"}],"footer.getErg.2":[{"type":0,"value":"Madencilik Hesaplayıcı"}],"footer.getErg.3":[{"type":0,"value":"Cüzdanlar"}],"footer.getErg.4":[{"type":0,"value":"Borsalar"}],"footer.getErg.title":[{"type":0,"value":"ERG EDİN"}],"footer.legal":[{"type":0,"value":"Yasal"}],"footer.news.title":[{"type":0,"value":"HABERLER"}],"footer.privacyPolicy":[{"type":0,"value":"Gizlilik Politikası"}],"footer.weGotIt":[{"type":0,"value":"Anladık!"}],"navigation.discover":[{"type":0,"value":"KEŞFET"}],"navigation.ecosystem":[{"type":0,"value":"EKOSİSTEM"}],"navigation.ergoCommunity":[{"type":0,"value":"ERGO TOPLULUĞU"}],"navigation.getErg":[{"type":0,"value":"ERG EDİN"}],"navigation.moreContent":[{"type":0,"value":"Daha fazla içerik?"}],"pages.404.hero":[{"type":0,"value":"404. Sayfa Bulunamadı."}],"pages.404.title":[{"type":0,"value":"Bulunamadı"}],"pages.blog.title":[{"type":0,"value":"Blog"}],"pages.community.title":[{"type":0,"value":"Topluluk"}],"pages.discover.title":[{"type":0,"value":"Keşfet"}],"pages.ecosystem.title":[{"type":0,"value":"Ekosistem"}],"pages.get-erg.title":[{"type":0,"value":"Erg Edin"}],"pages.home.title":[{"type":0,"value":"Ana Sayfa"}],"pages.legal.title":[{"type":0,"value":"Yasal"}],"pages.mobile-wallets":[{"type":0,"value":"Mobil Cüzdanlar"}],"pages.privacyPolicy.title":[{"type":0,"value":"Gizlilik Politikası"}]}');
;// CONCATENATED MODULE: ./content/compiled-locales/hu.json
var hu_namespaceObject = JSON.parse('{"components.ContributeForm.company.subTitle":[{"type":0,"value":"AKAR PARTNERRÉ VÁLNI?"}],"components.ContributeForm.company.title":[{"children":[{"type":0,"value":"Cégeknek"}],"type":8,"value":"b"}],"components.ContributeForm.developer.subTitle":[{"type":0,"value":"HOGYAN TUDOK HOZZÁJÁRULNI?"}],"components.ContributeForm.developer.title":[{"children":[{"type":0,"value":"Fejlesztőknek"}],"type":8,"value":"b"}],"components.ContributeForm.text":[{"type":0,"value":"Ergo egy olyan nyitott modellt követ, ahol "},{"children":[{"type":0,"value":"bárkit tárt karokkal várnak, hogy hozzájáruljon."}],"type":8,"value":"b"}],"components.ContributeForm.title":[{"type":0,"value":"Hozzájárulás"}],"components.DApps.seeAllProjects":[{"type":0,"value":"ÖSSZES PROJEKT MEGTEKINTÉSE"}],"components.Sigmanauts.button":[{"type":0,"value":"OLVASS TÖBBET & JELENTKEZZ"}],"components.Sigmanauts.button.buttonContribute":[{"type":0,"value":"IRÁNYELVEK A HOZZÁJÁRULÁSHOZ"}],"components.Sigmanauts.button.discord":[{"type":0,"value":"CSATLAKOZZ HOZZÁNK DISCORDON"}],"components.Sigmanauts.button.grantsAndBounties":[{"type":0,"value":"ADOMÁNYOK & JUTALMAK"}],"components.Sigmanauts.button.writeAndReviewCode":[{"type":0,"value":"MERÜLJ EL ERGOBAN"}],"components.Sigmanauts.formInput.button":[{"type":0,"value":"KÜLDÉS"}],"components.Sigmanauts.formInput.email":[{"type":0,"value":"E-Mail"}],"components.Sigmanauts.formInput.name":[{"type":0,"value":"Név / Cég"}],"components.Sigmanauts.formInput.text":[{"type":0,"value":"Írd meg javaslataidat és ötleteidet nekünk, beszéljünk!"}],"components.Sigmanauts.subTitle":[{"type":0,"value":"Tréningprogram"}],"components.Sigmanauts.text":[{"type":0,"value":"Jelentkezz a Sigmanaut Tréningprogramra és segítsd formázni és gyarapítani Ergo-t. "},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":" Készítsük el a közemberek pénzügyét."}],"components.Sigmanauts.title":[{"type":0,"value":"Sigmanauták"}],"components.Spotlight.button":[{"type":0,"value":"LÁSD AZ ÖSSZES HOZZÁSZOLÁST"}],"components.Spotlight.title":[{"type":0,"value":"Eredményeink"}],"components.autolykos.button":[{"type":0,"value":"ERG BÁNYÁSZÁSA"}],"components.autolykos.header":[{"type":0,"value":"AUTOLYKOS"}],"components.autolykos.text":[{"children":[{"type":0,"value":"Autolykos"}],"type":8,"value":"b"},{"type":0,"value":" az alapja a memória-nehéz (memory-hard) ASIC ellenálló munka bizonyítékát használó algoritmusnak, amely GPU-k felé van orientálva."}],"components.autolykos.title":[{"type":0,"value":"A munka bizonyítéka (Proof of Work) jövője"}],"components.communityHero.Discord.text":[{"type":0,"value":"Csatlakozz hozzánk a Discord-on!"}],"components.communityHero.Discord.title":[{"type":0,"value":"Discord"}],"components.communityHero.Discourse.text":[{"type":0,"value":"Csatlakozz a beszélgetéshez az Ergo Fórumon."}],"components.communityHero.Discourse.title":[{"type":0,"value":"Fórum"}],"components.communityHero.Github.text":[{"type":0,"value":"A cselekedetek beszélnek, itt a kód. 100% nyílt forráskód."}],"components.communityHero.Github.title":[{"type":0,"value":"Github"}],"components.communityHero.Reddit.text":[{"type":0,"value":"Iratkozz fel a subreddit-ünkre."}],"components.communityHero.Reddit.title":[{"type":0,"value":"Reddit"}],"components.communityHero.Telegram.text":[{"type":0,"value":"Beszélgess velünk a Telegram-on."}],"components.communityHero.Telegram.title":[{"type":0,"value":"Telegram"}],"components.communityHero.Twitter.text":[{"type":0,"value":"Kövess minket a Twitteren."}],"components.communityHero.Twitter.title":[{"type":0,"value":"Twitter"}],"components.communityHero.Wiki.text":[{"type":0,"value":"Közösségi wikid. Tegyél hozzá bármilyen nyelven!"}],"components.communityHero.Wiki.title":[{"type":0,"value":"Wiki"}],"components.communityHero.Youtube.text":[{"type":0,"value":"Iratkozz fel a heti AMAs, ErgoPulse és még sok más videóra!"}],"components.communityHero.Youtube.title":[{"type":0,"value":"Youtube"}],"components.communityHero.subtitle":[{"type":0,"value":"KÖZEMBEREK PÉNZÜGYE"}],"components.communityHero.title":[{"type":0,"value":"Ökoszisztéma"}],"components.communitySection.communityHero.linkText":[{"type":0,"value":"Együttműködési oldalt"}],"components.communitySection.communityHero.text1":[{"type":0,"value":"Az Ergo egy decentralizált, közösségalapú platform. "}],"components.communitySection.communityHero.text2":[{"type":0,"value":"Csatlakozz hozzánk a közösségi oldalakon, és szerezz részt a fejlesztésben. További információkért látogasd meg az "}],"components.communitySection.communityHero.text3":[{"type":0,"value":"."}],"components.dApps.heading":[{"type":0,"value":"DApp-ok"}],"components.discoverErgo.text.1":[{"type":0,"value":"Ergo egy következő generációs munka bizonyítékot (Proof of Work) használó okos-szerződés platform, ami lehetővé tesz egy új pénzügyi interakciós modellt, alátámasztva egy biztonságos és gazdag szkript nyelvel, amely flexibilisen és Nulla-Tudás (Zero-Knowledge) bizonyítékokra (Σ-protokolok) van építve."}],"components.discoverHero.button1":[{"type":0,"value":"OLVASSA A DOKUMENTUMOKAT"}],"components.discoverHero.button2":[{"type":0,"value":"TANULJ DEVO-VAL"}],"components.discoverHero.button3":[{"type":0,"value":"OLVASD EL A KIÁLTVÁNYT"}],"components.discoverHero.button4":[{"type":0,"value":"NÉZD MEG A BLOGOT"}],"components.discoverHero.button5":[{"type":0,"value":"ELŐKÉSZÜLETEK"}],"components.discoverHero.button6":[{"type":0,"value":"LÁTOGAS EL ERGONAUT.SPACE-RE"}],"components.discoverHero.title":[{"type":0,"value":"Fedezd fel az Ergot"}],"components.documents.description":[{"type":0,"value":"Az Ergo kutatás-alapú megközelítést alkalmaz, és stabil, jól tesztelt megoldásokat használ, hogy évekre előre biztosítsa az alap platformot a fejlesztőknek. Az Ergo megoldásainak többsége papír alapú formalizálásban van, amelyeket szakértői körökben rendezett konferenciákon mutatnak be és a közösségben széles körben megvitatnak."}],"components.documents.heading":[{"type":0,"value":"Dokumentumok"}],"components.ecosystemHero.title":[{"type":0,"value":"Ökoszisztéma"}],"components.ergoExplorer.button1":[{"type":0,"value":"LÁNCFELFEDEZŐ"}],"components.ergoExplorer.button2":[{"type":0,"value":"ERGO.WATCH"}],"components.ergoRaffle.description":[{"type":0,"value":"Az Ergo Raffle egy támogatási szolgáltatás, amelyet az Ergo platformon építettek, és lehetővé teszi bárki számára, hogy pénzt gyűjtsön egy projekt számára. Ez a projekt közvetlen adományozástól, jótékonysági célú támogatásig, akadémiai vagy üzleti tervig terjedhet, vagy bármire, amivel meg tudja győzni az embereket, hogy részt vegyenek keményen megkeresett ERG-jük elengedésében! Az Raffle befejezése után egy lottóhúzás kerül sor, és egy szerencsés résztvevő nyer egy meghatározott százalékot az Raffle összegéből, mint \\"raffle jutalom\\"."}],"components.ergoRaffle.heading":[{"type":0,"value":"Ergo Raffle"}],"components.ergofoundation.list1":[{"type":0,"value":"Az Ergo Platform protokolljának "},{"children":[{"type":0,"value":"nem-bontó fejlesztése"}],"type":8,"value":"b"},{"type":0,"value":" elősegítése;"}],"components.ergofoundation.list2":[{"type":0,"value":"Az Ergo Platform és a "},{"children":[{"type":0,"value":"született tokenje"}],"type":8,"value":"b"},{"type":0,"value":" (ERG) széles körű elfogadásának és használatának nyilvánosságra hozatala;"}],"components.ergofoundation.list3":[{"type":0,"value":"Az Ergo Platform "},{"children":[{"type":0,"value":"ökoszisztéma"}],"type":8,"value":"b"},{"type":0,"value":"jának fejlesztése;"}],"components.ergofoundation.list4":[{"type":0,"value":"Az Ergo Platform és a blokklánc-technológia "},{"children":[{"type":0,"value":"társadalmi célra történő"}],"type":8,"value":"b"},{"type":0,"value":" terjesztésének elősegítése;"}],"components.ergofoundation.list5":[{"type":0,"value":"Az "},{"children":[{"type":0,"value":"igazán decentralizált infrastruktúra"}],"type":8,"value":"b"},{"type":0,"value":" fenntartása, és;"}],"components.ergofoundation.list6":[{"type":0,"value":"Az "},{"children":[{"type":0,"value":"adatvédelem"}],"type":8,"value":"b"},{"type":0,"value":" támogatása, mint az emberi jogok alapvető joga."}],"components.ergofoundation.title":[{"type":0,"value":"Az "},{"children":[{"type":0,"value":"Ergo Alapítvány"}],"type":8,"value":"b"},{"type":0,"value":" közösségalapította entitás, amely az alábbiakra összpontosít"}],"components.exchanges.available":[{"type":0,"value":"Elérhető a népszerű központosított és decentralizált tőzsdéken."}],"components.exchanges.disclaimer":[{"type":0,"value":"Nyilatkozat: A tőzsdék nagyon változó mértékben biztosítanak biztonságot, védelmet, adatvédelmet és kontrollt a vagyon és az információ felett. Nagyon ajánlott, hogy vigyázzon saját vagyonára, és az itt felsorolt pénztárcaválasztások egyikét használja."}],"components.exchanges.heading":[{"type":0,"value":"ERGO VÁSÁRLÁSA, ELADÁSA ÉS KERESKEDELMÉNEK LEHETŐSÉGEI"}],"components.exchanges.subheading":[{"type":0,"value":"Tőzsdék"}],"components.explore.description":[{"type":0,"value":"Az Ergo Explorer segítségével egyszerűen figyelemmel kísérheti az összes tranzakciót, amely az Ergo hálózaton történik. Vagy nézze meg a közösség által összeállított metrikákat az ergo.watch oldalon."}],"components.explore.heading":[{"type":0,"value":"Felfedezés"}],"components.explore.subheading":[{"type":0,"value":"MERÜLJÖN EL AZ ERGO TRANZAKCIÓK VILÁGÁBAN"}],"components.faq.anyQuestions":[{"type":0,"value":"BÁRMILYEN KÉRDÉSE VAN?"}],"components.faq.description":[{"type":0,"value":"Az egyik leggyakrabban feltett kérdéseket összegyűjtöttük itt."}],"components.faq.heading":[{"type":0,"value":"GYIK"}],"components.faq.text.2":[{"type":0,"value":"NEM TALÁLOD, "},{"type":1,"value":"breakingLine"},{"type":0,"value":" AMIT KERESTÉL?"}],"components.favorites.button1":[{"type":0,"value":"ERGO RAFFLE FELFEDEZÉSE"}],"components.getErg.BuyIt.title":[{"type":0,"value":"Tőzsdék"}],"components.getErg.MineIt.text":[{"type":0,"value":"Az Autolykos egy ASIC rezisztens és igazságosan bányászható Proof-of-Work algoritmus, amely barátságos az általános GPU-k számára."}],"components.getErg.MineIt.title":[{"type":0,"value":"Bányászd Ki"}],"components.getErg.description":[{"type":0,"value":"Az Ergo platformján egy gazdag ökoszisztéma fejlődik. Legyél fejlesztő, bányász, vagy befektető - nálunk megtalálod, amit keresel."}],"components.getErg.heroTitle":[{"type":0,"value":"ELLENÁLLHATATLAN DEFI"}],"components.getErg.title":[{"type":0,"value":"Szerezd be az ERG-t"}],"components.grantsAndBounties.button1":[{"type":0,"value":"ADOMÁNYOK"}],"components.grantsAndBounties.button2":[{"type":0,"value":"TOMBOLA INDÍTÁSA"}],"components.grantsAndBounties.button3":[{"type":0,"value":"VEDD FEL VELÜNK A KAPCSOLATOT"}],"components.grantsAndBounties.description":[{"type":0,"value":"Általában a közösség számára oktató jellegű dolgok is bónuszra jogosulnak, még akkor is, ha nincsenek kifejezetten felsorolva. Olyan projektekre keresünk finanszírozást, amelyek az ökoszisztéma alapjainak kiépítésére összpontosítanak. Azonban a leggyorsabb módja a finanszírozáshoz, ha elindít egy Raffle-t."}],"components.grantsAndBounties.heading":[{"type":0,"value":"Támogatások és jutalmak"}],"components.hallOfFame.description1":[{"type":0,"value":"Az Ergót olyan csapat alapította, akiknek szilárd háttere van a kriptovaluták és blokklánc-keretrendszerek központi fejlesztésében, beleértve az NXT-t, a Scorex-et, a Cardano-t és a Waves-t. Az alábbiakban rövid életrajzok találhatók az ERGO csapat néhány alapvető tagjához, valamint a sok más fejlesztőhöz és közösségi taghoz, akik közül néhány névtelen."}],"components.hallOfFame.description2":[{"type":0,"value":"Az Ergo gyökerei az emberekben vannak, és a legtöbb alapvető csapattag (és még az alapítványtagok) is közösségi tagokként kezdtek. Az oldal alján rövid leírás és információ található az Ergo Alapítványról."}],"components.hallOfFame.tab1":[{"type":0,"value":"ALAPVETŐ"}],"components.hallOfFame.tab2":[{"type":0,"value":"KÖZÖSSÉG"}],"components.hallOfFame.tab3":[{"type":0,"value":"ALAPÍTVÁNY"}],"components.hallOfFame.title":[{"type":0,"value":"Hírességek Csarnoka"}],"components.highlights.slide.1.quote":[{"type":0,"value":"95.57% "},{"type":1,"value":"breakingLine"},{"type":0,"value":"Nyilvános Allokáció"}],"components.highlights.slide.1.text":[{"type":0,"value":"Amikor az Ergo 2019-ben indult, nem volt kezdeti érme kibocsátás, előbányászás vagy érmeelosztás sem a csapat tagjai vagy befektetők között. Egy igazán tisztességes indítás 4,43% -os allokációval az ökoszisztéma fejlesztésére. Ez más okos szerződés platformokon egyedülálló."}],"components.highlights.slide.1.title":[{"type":0,"value":"Egy Igazságos Kezdet"}],"components.highlights.slide.2.quote":[{"type":0,"value":"IGAZI P2P"}],"components.highlights.slide.2.text":[{"type":0,"value":"Az Ergo lehetővé teszi az innovatívabb, célzott megvalósításokat, amelyeket a hagyományos bankok nem tudnak biztosítani. Az Ergo erős eszközöket kínál, mint az okos szerződésekkel vezérelt mikrohitel és helyi cserekereskedelmi rendszerek (LETS)."}],"components.highlights.slide.2.title":[{"type":0,"value":"Alternatív Gazdaság"}],"components.highlights.slide.3.quote":[{"type":0,"value":"Σ-Protokollok"}],"components.highlights.slide.3.text":[{"type":0,"value":"A magánélet védelme az autonómia védelmének kulcsa. A magánélet lehetőséget ad a határok és korlátok megteremtésére, amelyek biztonságos teret biztosítanak az egyén számára. Mindenkinek saját határait és korlátait kell meghatároznia. Ez új pénzügyi interakciós modelleket tesz lehetővé, amelyeket biztonságos és gazdag script nyelv, az ErgoScript, és rugalmas és erős Zero-Knowledge bizonyítékok támasztanak alá."}],"components.highlights.slide.3.title":[{"type":0,"value":"Opcionális Magánélet"}],"components.highlights.title":[{"type":0,"value":"EREDMÉNYEINK"}],"components.homeHero.button":[{"type":0,"value":"MERÜLJ EL"}],"components.homeHero.text":[{"type":0,"value":"Ergo egy következő-generációs okos szerződés (smart contract) platform, amely biztosítja a gazdasági szabadásgot az átlagembernek biztonságos elérhető és központosítatlan pénzügyi eszközökkel."}],"components.homeHero.title":[{"type":0,"value":"Hajtja a Pénzügyek Jövőjét"}],"components.homeInfo.blockReward":[{"type":0,"value":"BLOCK JUTALMAK"}],"components.homeInfo.circulatingSupply":[{"type":0,"value":"FORGALOMBAN LÉVŐ KÉSZLET"}],"components.homeInfo.hashRate":[{"type":0,"value":"HASÍTÁSI RÁTA"}],"components.homeInfo.transactionPerDay":[{"type":0,"value":"TRANZAKCIÓK NAPONTA"}],"components.learn.description":[{"type":0,"value":"Kezdje az alapoknál. Mi az Ergo? Mit lehet rajta csinálni?"}],"components.learn.heading":[{"type":0,"value":"Tudj meg többet"}],"components.mining.button1":[{"type":0,"value":"DOKUMENTÁCIÓ"}],"components.mining.button2":[{"type":0,"value":"BÁNYÁSZATI MEDENCE STADISZTIKA"}],"components.mining.button3":[{"type":0,"value":"DISCORD"}],"components.mining.button4":[{"type":0,"value":"SUBREDDIT"}],"components.mining.button5":[{"type":0,"value":"BÁNYÁSZATI BLOG BEJEGYZÉSEK"}],"components.mining.calculator.currentBlockReward":[{"type":0,"value":"Jelenlegi blokkjutalom"}],"components.mining.calculator.currentPrice":[{"type":0,"value":"Aktuális ár"}],"components.mining.calculator.description":[{"type":0,"value":"Az Autolykos az ASIC-rezisztens memóriaigényes Proof of Work (PoW) algoritmus, amely GPU-k számára optimalizált."}],"components.mining.calculator.networkHashrate":[{"type":0,"value":"Hálózati hash érték"}],"components.mining.calculator.rev":[{"type":0,"value":"Napi Bevétel"}],"components.mining.calculator.title":[{"type":0,"value":"Bányászat Kalkulátor"}],"components.mining.minersTitle":[{"type":0,"value":"Bányászok"}],"components.mining.miningPoolsTitle":[{"type":0,"value":"Bányászmedencék"}],"components.mining.text.1":[{"type":0,"value":"Ergo bányászata Autolykos algoritmuson alapszik, amely egy ASIC ellenálló munka bizonyítéka (Proof of Work) algoritmus, Scala-ban írva. A többi algoritmusnál alacsonyabb hőfokon futtatható a legtöbb alsókategóriás videókártyán, növelve a bányászási berendezés élettartamát. Az eUTOXO modellel és a komplex számolások láncon kívüli elvégzésének kombinálásával egy hatékony munka bizonyíték (Proof of Work) modell jön létre."}],"components.mining.text.2":[{"type":0,"value":"Üdvözöljük a munka bizonyítékának jövőjében."}],"components.mining.text.3":[{"type":0,"value":"Kezdésképpen, csekkold a közösség-készítette Bányász Kézikönyvet, vagy csatlakozz a bányász társalgó közösségekbe"}],"components.mining.title":[{"type":0,"value":"Bányászat"}],"components.news.blog":[{"type":0,"value":"Blog"}],"components.news.latest":[{"type":0,"value":"legfrissebb hírek"}],"components.news.title":[{"type":0,"value":"Hírek"}],"components.ourFavorites.heading":[{"type":0,"value":"KEDVENCINK"}],"components.ourmission.description":[{"type":0,"value":"Az Ergo Alapítvány elkötelezett az Ergo Platform protokoll organikus és nem bontó fejlesztése mellett."}],"components.ourmission.emissionAndTokenomics":[{"type":0,"value":"EMISSZIÓ ÉS TOKENOMICS"}],"components.ourmission.ergofoundation":[{"type":0,"value":"AZ ERGO ALAPÍTVÁNY"}],"components.ourmission.reachus.twitter":[{"type":0,"value":"KAPCSOLATFELVÉTEL TWITTEREN"}],"components.ourmission.subdescription":[{"type":0,"value":"Az Ergo Alapítvány elkötelezett amellett, hogy erőfeszítéseket tegyen annak érdekében, hogy a lehető legkevésbé engedékeny engedély alatt, nyílt forráskódú módon maximalizálja az értékes ökoszisztéma-fejlesztések számát."}],"components.ourmission.title":[{"type":0,"value":"Missziónk"}],"components.partners.title":[{"type":0,"value":"Partnerek"}],"components.roadmap.coinmarketcal":[{"type":0,"value":"TÖBB MEGTEKINTÉSE A COINMARKETCAL OLDALON"}],"components.roadmap.description":[{"type":0,"value":"Kérjük, vegye figyelembe, hogy az Ergo egy platform. Az alább felsorolt projektek közül soknak nincs hivatalos kapcsolata az Ergo Alapítvánnyal vagy egymással."}],"components.roadmap.section1.title":[{"type":0,"value":"EDDIG"}],"components.roadmap.section2.title":[{"type":0,"value":"ÖKOSZISZTÉMA"}],"components.roadmap.section3.title":[{"type":0,"value":"HAMAR"}],"components.roadmap.section4.title":[{"type":0,"value":"2024 ÉS TÚL"}],"components.roadmap.title":[{"type":0,"value":"Ütemterv"}],"components.software.description":[{"type":0,"value":"Az Ergo Node az Ergo fejlesztésének bejáratát jelenti, és lehetővé teszi az Ön kommunikációját a blokklánccal."}],"components.software.heading":[{"type":0,"value":"Szoftver"}],"components.uniqueErgo.card1.button":[{"type":0,"value":"FELTÁRKOZÁS"}],"components.uniqueErgo.card1.text":[{"type":0,"value":"Az Ergo tíz évnyi blokklánc-fejlesztésre támaszkodik, amely a kipróbált és tesztelt elveket kiegészíti a kriptográfiára, a konszenzusmodellekre és a digitális valutákra vonatkozó legjobb, szakértői áttekintéseken alapuló kutatási eredményekkel. Szilárd blokklánc-alapokkal kezdünk és új, erős kriptográfiát helyezünk be az alapokba."}],"components.uniqueErgo.card1.title":[{"type":0,"value":"KUTATÁSOKRA ÉPÜLŐ ÉS A VALÓ VILÁGRA ÖSSZEPONTOSÍTÓ"}],"components.uniqueErgo.card2.button":[{"type":0,"value":"FELTÁRKOZÁS"}],"components.uniqueErgo.card2.text":[{"type":0,"value":"Az Ergo kiváló támogatást nyújt a valós világbeli pénzügyi megállapodásokhoz. Az Ergo sokoldalú dApp-okat támogathat, amelyek kiszámíthatóan futnak ismert költségekkel, és nem jelentenek semmilyen korlátlan funkció veszélyét. Az Ergo okos szerződései lehetővé teszik számunkra, hogy széles körű feladatokat hajtsunk végre, és Turing teljesek lehetnek, de mindig előre tudjuk, hogy mennyibe fog kerülni a kód és sikeresen fog-e futni."}],"components.uniqueErgo.card2.title":[{"type":0,"value":"ERŐTELJES ÉS BIZTONSÁGOS"}],"components.uniqueErgo.card3.button":[{"type":0,"value":"FEDÉLZETRE LÉPÉS"}],"components.uniqueErgo.card3.text":[{"type":0,"value":"A Sigma Protokollok (Σ-Protokollok) az Ergo okos szerződéseinek alapja. Lehetővé teszik a hatékony zéró ismeretű protokollok osztályát, amelyek lehetővé teszik számunkra, hogy olyan összetett feladatokat hajtsunk végre, amelyek egyébként lehetetlenek, kockázatosak vagy drágák lennének. Üdvözöljük az ön-önrendelkező alkalmazásszintű adatvédelmet: bizalmatlan szkriptek, amelyeket keverőkhez vagy más funkcionalitáshoz lehet használni, nélkülözve bármilyen harmadik felet."}],"components.uniqueErgo.card3.title":[{"type":0,"value":"INTELLIGENS ÉS EGYSZERŰ"}],"components.uniqueErgo.card4.button":[{"type":0,"value":"FEDÉLZETRE LÉPÉS"}],"components.uniqueErgo.card4.text":[{"type":0,"value":"Az átlagos felhasználók, akik nem futtatnak teljes csomópontot, élvezhetik ugyanazokat a biztonsági előnyöket, mint az bányászok. A Non-Interactive Proofs of Proof-of-Work (NIPOPOWS) lehetővé teszi, hogy teljes bizalommal végezzünk és ellenőrizzük a tranzakciókat anélkül, hogy szükségünk lenne a teljes blokklánc letöltéséhez szükséges tárolásra, sávszélességre és időre. Már 1 MB adat is elegendő, ami azt jelenti, hogy bármilyen eszköz használható."}],"components.uniqueErgo.card4.title":[{"type":0,"value":"BIZTONSÁGOS ÉS HOZZÁFÉRHETŐ"}],"components.uniqueErgo.title":[{"type":0,"value":"MI TESZI AZ ERGO-T EGYEDI"}],"components.usingErg.BuyIt.text":[{"type":0,"value":"Elérhető a népszerű központi és decentralizált tőzsdéken."}],"components.usingErg.StoreIt.text":[{"type":0,"value":"Egyszerű és biztonságos nem-befektetett pénztárcák az ERG biztonságos tárolásához."}],"components.usingErg.StoreIt.title":[{"type":0,"value":"Pénztárca"}],"components.usingErg.UseIt.title":[{"type":0,"value":"Használd az ERG-t ma a növekvő ökoszisztémánkban."}],"components.usingErg.description":[{"type":0,"value":"Az Ergo tetején virágzó gazdag ökoszisztéma van kialakulóban. Legyen szó fejlesztőről, bányászról vagy befektetőről, mi segítünk neked."}],"components.usingErg.subtitle":[{"type":0,"value":"FOLYAMATOSAN BŐVÜLŐ DEFI"}],"components.usingErg.title":[{"type":0,"value":"SZEREZD BE AZ ERGO-T"}],"components.wallets.chooseYours":[{"type":0,"value":"VÁLASSZ AZ ALÁBBI KÖZÜL"}],"components.wallets.coldStorageHeader":[{"type":0,"value":"Hideg tárolás"}],"components.wallets.featureHeader":[{"type":0,"value":"Funkció"}],"components.wallets.hotStorageHeader":[{"type":0,"value":"Meleg tárolás"}],"components.wallets.mobileAppHeader":[{"type":0,"value":"Mobilalkalmazás"}],"components.wallets.setupGuides":[{"type":0,"value":"BEÁLLÍTÁSI ÚTMUTATÓK"}],"components.wallets.walletDescription1":[{"type":0,"value":"Az online pénztárcák segítenek megőrizni digitális pénzed biztonságát, privátját és irányításod alatt tartani."}],"components.wallets.walletDescription2":[{"type":0,"value":"Felhívjuk figyelmedet, hogy a pénztárcák nem az Ergo Foundation által támogatott fejlesztések, és adataid védelme a szolgáltatók felelőssége. Az itt található információkat pusztán tájékoztató jelleggel közöljük, és nem minősülnek ajánlásnak."}],"components.wallets.walletsHeader":[{"type":0,"value":"Pénztárcák"}],"components.wallets.walletsTitle":[{"type":0,"value":"Pénztárcák"}],"components.wiki.description":[{"type":0,"value":"Az ergonaut.space egy közösségi által létrehozott wiki oldal, amely rengeteg információt tartalmaz az Ergo blokklánc műszaki részleteiről, amelyeket nem műszaki személyek is egyszerűen megérthetnek. Itt számos útmutatót, oktatóanyagot és felhasználók által beküldött tartalmat találhat. Hozzon létre egy fiókot, és kezdjen hozzájárulni Ön is!"}],"components.wiki.description.short":[{"type":0,"value":"Az ergonaut.space az Ergo blokklánc közösség által létrehozott wiki oldala, amelyben az Ergo blokklánc műszaki részletei egyszerűen érthető módon vannak leírva."}],"components.wiki.heading":[{"type":0,"value":"Wiki"}],"footer.blog.title":[{"type":0,"value":"BLOG"}],"footer.community.1":[{"type":0,"value":"Csatlakozz csatornáinkhoz"}],"footer.community.2":[{"type":0,"value":"Sigmanauták"}],"footer.community.3":[{"type":0,"value":"Hozzájárulás Ergo-hoz"}],"footer.community.4":[{"type":0,"value":"Hírességek Csarnoka"}],"footer.community.5":[{"type":0,"value":"Ergo Alapítvány"}],"footer.community.title":[{"type":0,"value":"KÖZÖSSÉG"}],"footer.discover.1":[{"type":0,"value":"Szoftver Kiadványok"}],"footer.discover.2":[{"type":0,"value":"Adományok & Jutalmak"}],"footer.discover.3":[{"type":0,"value":"GYIK"}],"footer.discover.4":[{"type":0,"value":"Felfedezés"}],"footer.discover.5":[{"type":0,"value":"Dokumentumok"}],"footer.discover.title":[{"type":0,"value":"FELFEDEZÉS"}],"footer.ecosystem.1":[{"type":0,"value":"DAppok"}],"footer.ecosystem.2":[{"type":0,"value":"Ütemterv"}],"footer.ecosystem.3":[{"type":0,"value":"Wiki"}],"footer.ecosystem.4":[{"type":0,"value":"Ergo Raffle"}],"footer.ecosystem.5":[{"type":0,"value":"Videó tartalmak"}],"footer.ecosystem.title":[{"type":0,"value":"ÖKOSZISZTÉMA"}],"footer.getErg.1":[{"type":0,"value":"BÁNYÁSZAT"}],"footer.getErg.2":[{"type":0,"value":"BÁNYÁSZ KALKULÁTOR"}],"footer.getErg.3":[{"type":0,"value":"Tárcák"}],"footer.getErg.4":[{"type":0,"value":"Tőzsdék"}],"footer.getErg.title":[{"type":0,"value":"SZEREZZ ERG-ET"}],"footer.legal":[{"type":0,"value":"Legalitások"}],"footer.news.title":[{"type":0,"value":"HÍREK"}],"footer.privacyPolicy":[{"type":0,"value":"Adatvédelmi nyilatkozat"}],"footer.weGotIt":[{"type":0,"value":"Képesek vagyunk rá!"}],"navigation.discover":[{"type":0,"value":"FELFEDEZÉS"}],"navigation.ecosystem":[{"type":0,"value":"ÖKOSZISZTÉMA"}],"navigation.ergoCommunity":[{"type":0,"value":"ERGO KÖZÖSSÉG"}],"navigation.getErg":[{"type":0,"value":"SZEREZZ ERG-ET"}],"navigation.moreContent":[{"type":0,"value":"További tartalom?"}],"pages.404.hero":[{"type":0,"value":"404. Oldal Nem Található."}],"pages.404.title":[{"type":0,"value":"Nem Található"}],"pages.blog.title":[{"type":0,"value":"Blog"}],"pages.community.title":[{"type":0,"value":"Közösség"}],"pages.discover.title":[{"type":0,"value":"Láncfelfedező"}],"pages.ecosystem.title":[{"type":0,"value":"Ekoszisztéma"}],"pages.get-erg.title":[{"type":0,"value":"GetErg"}],"pages.home.title":[{"type":0,"value":"Fő oldal"}],"pages.legal.title":[{"type":0,"value":"Legalitások"}],"pages.mobile-wallets":[{"type":0,"value":"Mobil tárcák"}]}');
;// CONCATENATED MODULE: ./content/compiled-locales/cn.json
var cn_namespaceObject = JSON.parse('{"components.ContributeForm.company.subTitle":[{"type":0,"value":"想要成为合作伙伴？"}],"components.ContributeForm.company.title":[{"type":0,"value":"我是一家"},{"children":[{"type":0,"value":"公司"}],"type":8,"value":"b"}],"components.ContributeForm.developer.subTitle":[{"type":0,"value":"我可以如何做贡献？"}],"components.ContributeForm.developer.title":[{"type":0,"value":"我是一名"},{"children":[{"type":0,"value":"开发者"}],"type":8,"value":"b"}],"components.ContributeForm.text":[{"type":0,"value":"Ergo以开放模式运作，"},{"children":[{"type":0,"value":"欢迎任何人来做贡献。"}],"type":8,"value":"b"}],"components.ContributeForm.title":[{"type":0,"value":"贡献"}],"components.DApps.seeAllProjects":[{"type":0,"value":"查看全部项目"}],"components.Sigmanauts.button":[{"type":0,"value":"阅读更多并申请"}],"components.Sigmanauts.button.buttonContribute":[{"type":0,"value":"贡献指南"}],"components.Sigmanauts.button.discord":[{"type":0,"value":"来Discord加入我们"}],"components.Sigmanauts.button.grantsAndBounties":[{"type":0,"value":"补助金与赏金"}],"components.Sigmanauts.button.writeAndReviewCode":[{"type":0,"value":"深入了解ERGO"}],"components.Sigmanauts.formInput.button":[{"type":0,"value":"发送"}],"components.Sigmanauts.formInput.email":[{"type":0,"value":"E-Mail"}],"components.Sigmanauts.formInput.name":[{"type":0,"value":"姓名/公司"}],"components.Sigmanauts.formInput.text":[{"type":0,"value":"把您的建议和想法写给我们，让我们谈谈！"}],"components.Sigmanauts.subTitle":[{"type":0,"value":"培训计划"}],"components.Sigmanauts.text":[{"type":0,"value":"申请Sigmanaut培训计划以帮助塑造和发展Ergo。"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"我们来共建草根金融吧。"}],"components.Sigmanauts.title":[{"type":0,"value":"Sigmanaut"}],"components.Spotlight.button":[{"type":0,"value":"查看全部文章"}],"components.Spotlight.title":[{"type":0,"value":"焦点内容"}],"components.autolykos.button":[{"type":0,"value":"挖掘ERG"}],"components.autolykos.header":[{"type":0,"value":"AUTOLYKOS"}],"components.autolykos.text":[{"children":[{"type":0,"value":"Autolykos"}],"type":8,"value":"b"},{"type":0,"value":"是面向GPU的底层内存高占用抗ASIC工作量证明算法。"}],"components.autolykos.title":[{"type":0,"value":"工作量证明的未来"}],"components.communityHero.Discord.text":[{"type":0,"value":"加入我们的Discord！"}],"components.communityHero.Discord.title":[{"type":0,"value":"Discord"}],"components.communityHero.Discourse.text":[{"type":0,"value":"在Ergo论坛上加入讨论。"}],"components.communityHero.Discourse.title":[{"type":0,"value":"Forum"}],"components.communityHero.Github.text":[{"type":0,"value":"言之无物，代码为证。100%开源。"}],"components.communityHero.Github.title":[{"type":0,"value":"Github"}],"components.communityHero.Reddit.text":[{"type":0,"value":"订阅我们的subreddit。"}],"components.communityHero.Reddit.title":[{"type":0,"value":"Reddit"}],"components.communityHero.Telegram.text":[{"type":0,"value":"在Telegram上来和我们聊天。"}],"components.communityHero.Telegram.title":[{"type":0,"value":"Telegram"}],"components.communityHero.Twitter.text":[{"type":0,"value":"关注我们的Twitter。"}],"components.communityHero.Twitter.title":[{"type":0,"value":"Twitter"}],"components.communityHero.Wiki.text":[{"type":0,"value":"您的社区维基。用任何语言贡献"}],"components.communityHero.Wiki.title":[{"type":0,"value":"维基"}],"components.communityHero.Youtube.text":[{"type":0,"value":"订阅我们的周访谈、ErgoPulse等节目！"}],"components.communityHero.Youtube.title":[{"type":0,"value":"Youtube"}],"components.communityHero.subtitle":[{"type":0,"value":"草根金融"}],"components.communityHero.title":[{"type":0,"value":"社区"}],"components.communitySection.communityHero.linkText":[{"type":0,"value":"贡献指南"}],"components.communitySection.communityHero.text1":[{"type":0,"value":"Ergo 是一个由社区驱动的去中心化的基础设施。"}],"components.communitySection.communityHero.text2":[{"type":0,"value":"加入我们的社交媒体获取更多信息，查看"}],"components.communitySection.communityHero.text3":[{"type":0,"value":" 页面以获取更多信息。"}],"components.dApps.heading":[{"type":0,"value":"去中心化应用"}],"components.discoverErgo.text.1":[{"type":0,"value":"Ergo是下一代工作量证明智能合约平台，它以安全且丰富的脚本语言为基础支持全新的金融交互模型，而该脚本语言是用灵活而强大的零知识证明（西格玛协议）构建。"}],"components.discoverHero.button1":[{"type":0,"value":"阅读文档"}],"components.discoverHero.button2":[{"type":0,"value":"来DECO学习"}],"components.discoverHero.button3":[{"type":0,"value":"阅读《宣言》"}],"components.discoverHero.button4":[{"type":0,"value":"查看博客"}],"components.discoverHero.button5":[{"type":0,"value":"获取设置"}],"components.discoverHero.button6":[{"type":0,"value":"访问ERGONAUT.SPACE"}],"components.discoverHero.title":[{"type":0,"value":"发现Ergo"}],"components.documents.description":[{"type":0,"value":"Ergo 采用研究为基础的方法，使用稳定且经过充分测试的解决方案，为开发人员提供一个强大的平台，可供未来多年建设。Ergo 的大多数解决方案都在同行评审的会议上以论文形式呈现，并在社区中得到了广泛讨论。"}],"components.documents.heading":[{"type":0,"value":"文件"}],"components.ecosystemHero.title":[{"type":0,"value":"生态系统"}],"components.ergoExplorer.button1":[{"type":0,"value":"浏览器"}],"components.ergoExplorer.button2":[{"type":0,"value":"ERGO.WATCH"}],"components.ergoRaffle.description":[{"type":0,"value":"ErgoRaffle 是一个基于 Ergo 平台构建的众筹服务，使任何人都可以为项目筹集资金。这个项目可以是直接向慈善机构捐款、学术或商业计划，或者任何你能说服人们用他们辛苦赚来的 ERG 来支持的东西！作为额外的奖励，在完成抽奖后，将进行一次彩票抽奖，一个幸运的参与者将赢得抽奖的一定百分比作为“抽奖奖励”。"}],"components.ergoRaffle.heading":[{"type":0,"value":"Ergo 抽奖"}],"components.ergofoundation.list1":[{"type":0,"value":"促进Ergo平台协议的"},{"children":[{"type":0,"value":"不间断开发"}],"type":8,"value":"b"},{"type":0,"value":"；"}],"components.ergofoundation.list2":[{"type":0,"value":"宣传Ergo平台及其"},{"children":[{"type":0,"value":"原生代币"}],"type":8,"value":"b"},{"type":0,"value":"（ERG）的广泛采用和使用；"}],"components.ergofoundation.list3":[{"type":0,"value":"围绕Ergo平台开发"},{"children":[{"type":0,"value":"生态系统"}],"type":8,"value":"b"},{"type":0,"value":"；"}],"components.ergofoundation.list4":[{"type":0,"value":"传播Ergo平台和区块链技术的使用，"},{"children":[{"type":0,"value":"造福社会"}],"type":8,"value":"b"},{"type":0,"value":"；"}],"components.ergofoundation.list5":[{"type":0,"value":"维护"},{"children":[{"type":0,"value":"真正去中心化的基础设施"}],"type":8,"value":"b"},{"type":0,"value":"，且；"}],"components.ergofoundation.list6":[{"type":0,"value":"支持将"},{"children":[{"type":0,"value":"隐私"}],"type":8,"value":"b"},{"type":0,"value":"作为一项基本人权。"}],"components.ergofoundation.title":[{"children":[{"type":0,"value":"Ergo基金会"}],"type":8,"value":"b"},{"type":0,"value":"是一个社区驱动的实体，专注于"}],"components.exchanges.available":[{"type":0,"value":"在流行的交易所和去中心化交易所中可用。"}],"components.exchanges.disclaimer":[{"type":0,"value":"免责声明：交易所在安全性、保密性、隐私性以及对您的资金和信息的控制方面存在很大差异。我们强烈建议您自己保管资金，并使用上面提供的钱包选项之一。"}],"components.exchanges.heading":[{"type":0,"value":"购买、出售和交易ERGO"}],"components.exchanges.subheading":[{"type":0,"value":"交易所"}],"components.explore.description":[{"type":0,"value":"Ergo Explorer 是您与区块链的接口。实时观察每笔交易。或者，在 ergo.watch 上查看社区策划的指标。"}],"components.explore.heading":[{"type":0,"value":"探索"}],"components.explore.subheading":[{"type":0,"value":"深入探索 Ergo 的交易海洋"}],"components.faq.anyQuestions":[{"type":0,"value":"有任何问题吗？"}],"components.faq.description":[{"type":0,"value":"我们整理了一些最常见的问题。"}],"components.faq.heading":[{"type":0,"value":"常见问题解答"}],"components.faq.text.2":[{"type":0,"value":"找不到"},{"type":1,"value":"breakingLine"},{"type":0,"value":"您在找的内容？"}],"components.favorites.button1":[{"type":0,"value":"探索ERGO RAFFLE"}],"components.getErg.BuyIt.text":[{"type":0,"value":"在流行的中心化和去中心化交易所中都可获取。"}],"components.getErg.BuyIt.title":[{"type":0,"value":"交易所"}],"components.getErg.MineIt.text":[{"type":0,"value":"Autolykos，一种对ASIC抗性强且适用于普通GPU的公平挖矿工作证明算法。"}],"components.getErg.MineIt.title":[{"type":0,"value":"挖矿"}],"components.getErg.StoreIt.text":[{"type":0,"value":"简单且安全的非托管钱包，保证您的ERG安全。"}],"components.getErg.StoreIt.title":[{"type":0,"value":"钱包"}],"components.getErg.UseIt.text":[{"type":0,"value":"立即在我们不断壮大的生态系统中使用您的ERG。"}],"components.getErg.UseIt.title":[{"type":0,"value":"用它"}],"components.getErg.description":[{"type":0,"value":"Ergo正在顶尖生态系统的萌芽期。无论您是开发人员、矿工还是投资者，我们都会照顾到您。"}],"components.getErg.heroTitle":[{"type":0,"value":"不可阻挡的DeFi"}],"components.getErg.title":[{"type":0,"value":"获取 ERG"}],"components.grantsAndBounties.button1":[{"type":0,"value":"贡献"}],"components.grantsAndBounties.button2":[{"type":0,"value":"发起一个RAFFLE"}],"components.grantsAndBounties.button3":[{"type":0,"value":"联系我们"}],"components.grantsAndBounties.description":[{"type":0,"value":"总的来说，即使没有特别列出，社区内的任何教育性内容都可能有一些赏金。我们希望为关注建设关键生态系统基础设施的项目提供拨款。然而，获得资金的最快方法是开始一场抽奖。"}],"components.grantsAndBounties.heading":[{"type":0,"value":"拨款与赏金"}],"components.hallOfFame.description1":[{"type":0,"value":"Ergo创始团队在加密货币和区块链框架（包括NXT、Scorex、Cardano和Waves）的核心开发方面拥有扎实背景。以下是ERGO核心团队部分成员以及参与其中的许多其他开发者和社区成员的简介，其中部分人员匿名。"}],"components.hallOfFame.description2":[{"type":0,"value":"Ergo是草根的，大多数核心团队成员（甚至基金会成员）都是从社区成员做起的。有关Ergo基金会的简短描述以及更多值得一读的信息，见此页面下方。"}],"components.hallOfFame.tab1":[{"type":0,"value":"核心"}],"components.hallOfFame.tab2":[{"type":0,"value":"社区"}],"components.hallOfFame.tab3":[{"type":0,"value":"基金会"}],"components.hallOfFame.title":[{"type":0,"value":"名人堂"}],"components.highlights.slide.1.quote":[{"type":0,"value":"95.57% "},{"type":1,"value":"breakingLine"},{"type":0,"value":"公共分配"}],"components.highlights.slide.1.text":[{"type":0,"value":"当Ergo于2019年推出时，没有任何初始硬币发行，也没有将代币预先分配给任何团队成员或风险投资家。这是一个真正公平的启动，其中4.43%的资金分配给生态系统的发展。这在任何其他智能合约平台中都是无与伦比的。"}],"components.highlights.slide.1.title":[{"type":0,"value":"公平起跑"}],"components.highlights.slide.2.quote":[{"type":0,"value":"真正的P2P"}],"components.highlights.slide.2.text":[{"type":0,"value":"实现更具创新性、针对性的应用，传统银行无法匹敌。Ergo通过智能合约驱动的小额信贷设施和本地交换交易系统（LETS）提供强大的工具。"}],"components.highlights.slide.2.title":[{"type":0,"value":"替代经济"}],"components.highlights.slide.3.quote":[{"type":0,"value":"Σ-协议"}],"components.highlights.slide.3.text":[{"type":0,"value":"为了保护自主权，隐私必须保持为一个可选项。隐私是创造障碍和设立边界以为个人创造空间的能力。每个人都可以选择设立哪些边界和边界。这使得新的金融互动模式得以实现，基于安全且丰富的脚本语言ErgoScript以及灵活且强大的零知识证明。"}],"components.highlights.slide.3.title":[{"type":0,"value":"可选隐私"}],"components.highlights.title":[{"type":0,"value":"亮点"}],"components.homeHero.button":[{"type":0,"value":"深入了解"}],"components.homeHero.text":[{"type":0,"value":"Ergo是下一代智能合约平台，通过安全、可访问且去中心化的金融工具确保普通人的经济自由。"}],"components.homeHero.title":[{"type":0,"value":"赋能金融未来"}],"components.homeInfo.blockReward":[{"type":0,"value":"区块奖励"}],"components.homeInfo.circulatingSupply":[{"type":0,"value":"流通量"}],"components.homeInfo.hashRate":[{"type":0,"value":"算力"}],"components.homeInfo.transactionPerDay":[{"type":0,"value":"每日交易笔数"}],"components.learn.description":[{"type":0,"value":"从基础开始。什么是Ergo？您可以在Ergo上做什么？"}],"components.learn.heading":[{"type":0,"value":"学习"}],"components.mining.button1":[{"type":0,"value":"文档"}],"components.mining.button2":[{"type":0,"value":"矿池统计"}],"components.mining.button3":[{"type":0,"value":"Discord"}],"components.mining.button4":[{"type":0,"value":"Subreddit"}],"components.mining.button5":[{"type":0,"value":"挖矿博客文章"}],"components.mining.calculator.currentBlockReward":[{"type":0,"value":"当前区块奖励"}],"components.mining.calculator.currentPrice":[{"type":0,"value":"当前价格"}],"components.mining.calculator.description":[{"type":0,"value":"Autolykos 是面向 GPU 的底层内存硬ASIC抗性工作证明（PoW）算法。"}],"components.mining.calculator.networkHashrate":[{"type":0,"value":"网络哈希率"}],"components.mining.calculator.rev":[{"type":0,"value":"每日收入"}],"components.mining.calculator.title":[{"type":0,"value":"挖矿计算器"}],"components.mining.minersTitle":[{"type":0,"value":"矿工"}],"components.mining.miningPoolsTitle":[{"type":0,"value":"矿池"}],"components.mining.text.1":[{"type":0,"value":"Ergo挖矿基于Autolykos，这是一种公平启动的高效抗ASIC工作量证明算法。矿工可以通过链上投票来调整参数，更大的变动由绝对多数人通过软分叉实现，还可以参与任何令人激动的开发成果，例如投票代币、子矿池化和对数空间挖矿。Ergo专注于核心的简单性，并在应用层上构建有高级功能，以创造高适应力的合约币。"}],"components.mining.text.2":[{"type":0,"value":"欢迎加入工作量证明的未来。"}],"components.mining.text.3":[{"type":0,"value":"如要开始挖矿，请查阅社区编写的《挖矿指南》，或加入挖矿讨论空间。"}],"components.mining.title":[{"type":0,"value":"挖矿"}],"components.news.blog":[{"type":0,"value":"博客"}],"components.news.latest":[{"type":0,"value":"最新新闻"}],"components.news.title":[{"type":0,"value":"新闻"}],"components.ourFavorites.heading":[{"type":0,"value":"我们的最爱"}],"components.ourmission.description":[{"type":0,"value":"Ergo基金会致力于Ergo平台协议的有机不间断开发。"}],"components.ourmission.emissionAndTokenomics":[{"type":0,"value":"释放和代币经济学"}],"components.ourmission.ergofoundation":[{"type":0,"value":"ERGO基金会"}],"components.ourmission.reachus.twitter":[{"type":0,"value":"来TWITTER联系我们"}],"components.ourmission.subdescription":[{"type":0,"value":"Ergo基金会致力于努力以尽可能少的宽松式许可证以开源方式完成有价值的生态系统开发的数量最大化。"}],"components.ourmission.title":[{"type":0,"value":"我们的使命"}],"components.partners.title":[{"type":0,"value":"伙伴"}],"components.roadmap.coinmarketcal":[{"type":0,"value":"进一步了解COINMARKETCAL"}],"components.roadmap.description":[{"type":0,"value":" 请注意，Ergo 是一个平台。下面列出的许多项目与Ergo基金会之间或二者之间彼此没有正式关联。"}],"components.roadmap.section1.title":[{"type":0,"value":"迄今为止"}],"components.roadmap.section2.title":[{"type":0,"value":"生态系统"}],"components.roadmap.section3.title":[{"type":0,"value":"很快"}],"components.roadmap.section4.title":[{"type":0,"value":"2024年及以后"}],"components.roadmap.title":[{"type":0,"value":"路线图"}],"components.software.description":[{"type":0,"value":"Ergo节点是您在Ergo上进行开发的入口点，让您与区块链进行通信。"}],"components.software.heading":[{"type":0,"value":"软件"}],"components.uniqueErgo.card1.button":[{"type":0,"value":"探索"}],"components.uniqueErgo.card1.text":[{"type":0,"value":"Ergo借鉴了十年区块链开发经验，采用久经考验的原则，并结合了经同行评审、有关密码学、共识模型和数字货币的最佳学术研究。我们从扎实的区块链基础开始，并原生实现强大的全新密码学。"}],"components.uniqueErgo.card1.title":[{"type":0,"value":"以研究为主导，以现实为焦点"}],"components.uniqueErgo.card2.button":[{"type":0,"value":"探索"}],"components.uniqueErgo.card2.text":[{"type":0,"value":"Ergo为现实世界的金融协议提供卓越的支持。Ergo可以支持以已知成本可预测地运行的多功能dApp，且没有任何功能不受限制的危险。Ergo的智能合约允许我们执行各种各样的任务，且可以是图灵完备的，但我们总是提前知道代码的成本是多少以及它是否会成功运行。"}],"components.uniqueErgo.card2.title":[{"type":0,"value":"强大且安全"}],"components.uniqueErgo.card3.button":[{"type":0,"value":"探索"}],"components.uniqueErgo.card3.text":[{"type":0,"value":"西格玛协议（Σ-Protocol）是Ergo智能合约的基础。它们允许一类高效的零知识协议，使我们能够实现无法以其他方式完成、或者高风险、高费用的任务。欢迎使用自主的应用级隐私：可用于访问混币器或其他功能的无信任脚本，无需任何第三方。"}],"components.uniqueErgo.card3.title":[{"type":0,"value":"智能且简明"}],"components.uniqueErgo.card4.button":[{"type":0,"value":"探索"}],"components.uniqueErgo.card4.text":[{"type":0,"value":"不运行全节点的普通用户应当与矿工享有同等的安全性益处。工作量证明之非交互式证明（NiPoPoW）允许我们完全自信地进行并验证交易，而无需下载完整区块链所需的存储、带宽和时间。只需要少到1 MB的数据即可——这意味着可以使用任何设备。"}],"components.uniqueErgo.card4.title":[{"type":0,"value":"安全有保障且可访问"}],"components.uniqueErgo.title":[{"type":0,"value":"ERGO有何独特之处"}],"components.usingErg.BuyIt.text":[{"type":0,"value":"在流行的中心化和去中心化交易所中都可获取。"}],"components.usingErg.BuyIt.title":[{"type":0,"value":"交易所"}],"components.usingErg.MineIt.text":[{"type":0,"value":"Autolykos，一种对ASIC抗性强且适用于普通GPU的公平挖矿工作证明算法。"}],"components.usingErg.MineIt.title":[{"type":0,"value":"挖矿"}],"components.usingErg.StoreIt.text":[{"type":0,"value":"简单且安全的非托管钱包，保证您的ERG安全。"}],"components.usingErg.StoreIt.title":[{"type":0,"value":"钱包"}],"components.usingErg.UseIt.text":[{"type":0,"value":"立即在我们不断壮大的生态系统中使用您的ERG"}],"components.usingErg.UseIt.title":[{"type":0,"value":"用它"}],"components.usingErg.description":[{"type":0,"value":"Ergo之上有一个丰富的生态系统正在萌芽。无论您是开发者、矿工还是投资者 —— 我们都欢迎您的加入。"}],"components.usingErg.subtitle":[{"type":0,"value":"DEFI势不可挡"}],"components.usingErg.title":[{"type":0,"value":"获取ERG"}],"components.wallets.chooseYours":[{"type":0,"value":"选择您的"}],"components.wallets.coldStorageHeader":[{"type":0,"value":"冷存储"}],"components.wallets.featureHeader":[{"type":0,"value":"特点"}],"components.wallets.hotStorageHeader":[{"type":0,"value":"热存储"}],"components.wallets.mobileAppHeader":[{"type":0,"value":"手机应用"}],"components.wallets.setupGuides":[{"type":0,"value":"设置指南"}],"components.wallets.walletDescription1":[{"type":0,"value":"数字钱包可以帮助您保护您的数字货币安全、私密并且在您的控制之下。"}],"components.wallets.walletDescription2":[{"type":0,"value":"请注意，钱包由第三方支持，我们只提供下面的信息作为礼貌，以简化您的整体数字货币体验。"}],"components.wallets.walletsHeader":[{"type":0,"value":"钱包"}],"components.wallets.walletsTitle":[{"type":0,"value":"钱包"}],"components.wiki.description":[{"type":0,"value":"ergonaut.space 是我们的社区运营维基！里面有大量关于 Ergo 区块链底层技术细节的信息，用易于非技术人员理解的语言呈现。还有很多指南、教程和用户提交的内容。创建一个帐户开始贡献吧！"}],"components.wiki.description.short":[{"type":0,"value":"ergonaut.space 是 Ergo 区块链的社区维基，它指导着如何使用 Ergo 区块链，以及 Ergo 区块链的底层技术细节，以便非技术人员容易理解。"}],"components.wiki.heading":[{"type":0,"value":"维基"}],"footer.blog.title":[{"type":0,"value":"博客"}],"footer.community.1":[{"type":0,"value":"加入我们的频道"}],"footer.community.2":[{"type":0,"value":"Sigmanaut"}],"footer.community.3":[{"type":0,"value":"为Ergo做贡献"}],"footer.community.4":[{"type":0,"value":"名人堂"}],"footer.community.5":[{"type":0,"value":"Ergo基金会"}],"footer.community.title":[{"type":0,"value":"社区"}],"footer.discover.1":[{"type":0,"value":"软件发布"}],"footer.discover.2":[{"type":0,"value":"补助金&赏金"}],"footer.discover.3":[{"type":0,"value":"常见问答"}],"footer.discover.4":[{"type":0,"value":"探索"}],"footer.discover.5":[{"type":0,"value":"文档"}],"footer.discover.title":[{"type":0,"value":"发现"}],"footer.ecosystem.1":[{"type":0,"value":"去中心化应用"}],"footer.ecosystem.2":[{"type":0,"value":"路线图"}],"footer.ecosystem.3":[{"type":0,"value":"维基"}],"footer.ecosystem.4":[{"type":0,"value":"Ergo Raffle"}],"footer.ecosystem.5":[{"type":0,"value":"视频广播"}],"footer.ecosystem.title":[{"type":0,"value":"生态系统"}],"footer.getErg.1":[{"type":0,"value":"挖矿"}],"footer.getErg.2":[{"type":0,"value":"挖矿计算器"}],"footer.getErg.3":[{"type":0,"value":"钱包"}],"footer.getErg.4":[{"type":0,"value":"交易所"}],"footer.getErg.title":[{"type":0,"value":"获取ERG"}],"footer.legal":[{"type":0,"value":"法律"}],"footer.news.title":[{"type":0,"value":"新闻"}],"footer.privacyPolicy":[{"type":0,"value":"隐私政策"}],"footer.weGotIt":[{"type":0,"value":"我们已获得它！"}],"navigation.discover":[{"type":0,"value":"发现"}],"navigation.ecosystem":[{"type":0,"value":"生态系统"}],"navigation.ergoCommunity":[{"type":0,"value":"ERGO社区"}],"navigation.getErg":[{"type":0,"value":"获取ERG"}],"navigation.moreContent":[{"type":0,"value":"更多内容？"}],"pages.404.hero":[{"type":0,"value":"404. 网页未找到。"}],"pages.404.title":[{"type":0,"value":"未找到"}],"pages.blog.title":[{"type":0,"value":"博客"}],"pages.community.title":[{"type":0,"value":"社区"}],"pages.discover.title":[{"type":0,"value":"发现"}],"pages.ecosystem.title":[{"type":0,"value":"生态系统"}],"pages.get-erg.title":[{"type":0,"value":"获取Erg"}],"pages.home.title":[{"type":0,"value":"主页"}],"pages.legal.title":[{"type":0,"value":"法律"}],"pages.mobile-wallets":[{"type":0,"value":"移动钱包"}],"pages.privacyPolicy.title":[{"type":0,"value":"隐私政策"}]}');
;// CONCATENATED MODULE: ./content/compiled-locales/ru.json
var ru_namespaceObject = JSON.parse('{"components.ContributeForm.company.subTitle":[{"type":0,"value":"ХОТИТЕ СТАТЬ ПАРТНЕРОМ?"}],"components.ContributeForm.company.title":[{"type":0,"value":"Я представитель "},{"children":[{"type":0,"value":"компании"}],"type":8,"value":"b"}],"components.ContributeForm.developer.subTitle":[{"type":0,"value":"ЧЕМ Я МОГУ ПОМОЧЬ?"}],"components.ContributeForm.developer.title":[{"type":0,"value":"Я "},{"children":[{"type":0,"value":"разработчик"}],"type":8,"value":"b"}],"components.ContributeForm.text":[{"type":0,"value":"Мы открыты для сотрудничества, "},{"children":[{"type":0,"value":"любой может внести свой вклад."}],"type":8,"value":"b"}],"components.ContributeForm.title":[{"type":0,"value":"Сотрудничество"}],"components.DApps.seeAllProjects":[{"type":0,"value":"ПОСМОТРЕТЬ ВСЕ ПРОЕКТЫ"}],"components.Sigmanauts.button":[{"type":0,"value":"УЗНАТЬ БОЛЬШЕ & ЗАПИСАТЬСЯ"}],"components.Sigmanauts.button.buttonContribute":[{"type":0,"value":"ПРАВИЛА СОТРУДНИЧЕСТВА"}],"components.Sigmanauts.button.discord":[{"type":0,"value":"ПРИСОЕДИНИТЕСЬ К НАМ В DISCORD"}],"components.Sigmanauts.button.grantsAndBounties":[{"type":0,"value":"ГРАНТЫ & НАГРАДЫ"}],"components.Sigmanauts.button.writeAndReviewCode":[{"type":0,"value":"ПОГРУЖЕНИЕ В ERGO"}],"components.Sigmanauts.formInput.button":[{"type":0,"value":"ОТПРАВИТЬ"}],"components.Sigmanauts.formInput.email":[{"type":0,"value":"E-Mail"}],"components.Sigmanauts.formInput.name":[{"type":0,"value":"Имя / Компания"}],"components.Sigmanauts.formInput.text":[{"type":0,"value":"Пишите нам ваши предложения и идеи, обсудим!"}],"components.Sigmanauts.subTitle":[{"type":0,"value":"Программа обучения"}],"components.Sigmanauts.text":[{"type":0,"value":"Подайте заявку на участие в программе обучения Сигманавтов, чтобы помочь формировать и развивать Ergo. "},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":" Создайте основу финансов будущего."}],"components.Sigmanauts.title":[{"type":0,"value":"Сигманавты"}],"components.Spotlight.button":[{"type":0,"value":"ПОСМОТРЕТЬ ВСЕ ЗАПИСИ"}],"components.Spotlight.title":[{"type":0,"value":"В центре внимания"}],"components.autolykos.button":[{"type":0,"value":"Майнинг ERGO"}],"components.autolykos.header":[{"type":0,"value":"AUTOLYKOS"}],"components.autolykos.text":[{"children":[{"type":0,"value":"Autolykos"}],"type":8,"value":"b"},{"type":0,"value":" это, основанный на принципе «Доказательтве выполнения работы» (Proof of Work), алгоритм, требовательный к памяти, устойчивый к майнингу на ASIC и ориентированный на графические ускорители."}],"components.autolykos.title":[{"type":0,"value":"Будущее принципа «Доказательство выполнения работы» (Proof of Work)"}],"components.communityHero.Discord.text":[{"type":0,"value":"Присоединяйтесь к нам в Discord!"}],"components.communityHero.Discord.title":[{"type":0,"value":"Discord"}],"components.communityHero.Discourse.text":[{"type":0,"value":"Присоединяйтесь к обсуждению на форуме Ergo."}],"components.communityHero.Discourse.title":[{"type":0,"value":"Форум"}],"components.communityHero.Github.text":[{"type":0,"value":"Действия важнее слов. 100% Открытый код."}],"components.communityHero.Github.title":[{"type":0,"value":"Github"}],"components.communityHero.Reddit.text":[{"type":0,"value":"Подпишитесь на наши сабреддиты."}],"components.communityHero.Reddit.title":[{"type":0,"value":"Reddit"}],"components.communityHero.Telegram.text":[{"type":0,"value":"Присоединяйтесь к нам в Telegram для общения."}],"components.communityHero.Telegram.title":[{"type":0,"value":"Telegram"}],"components.communityHero.Twitter.text":[{"type":0,"value":"Подписывайтесь на наш Twitter."}],"components.communityHero.Twitter.title":[{"type":0,"value":"Twitter"}],"components.communityHero.Wiki.text":[{"type":0,"value":"Ваша вики сообщества. Внесите свой вклад на любом языке!"}],"components.communityHero.Wiki.title":[{"type":0,"value":"Вики"}],"components.communityHero.Youtube.text":[{"type":0,"value":"Подписывайтесь на наш Youtube канал для еженедельных AMAs, ErgoPulse и многое другое!"}],"components.communityHero.Youtube.title":[{"type":0,"value":"Youtube"}],"components.communityHero.subtitle":[{"type":0,"value":"ОСНОВА ФИНАНСОВ БУДУЩЕГО"}],"components.communityHero.title":[{"type":0,"value":"Экосистема"}],"components.communitySection.communityHero.linkText":[{"type":0,"value":"Участие"}],"components.communitySection.communityHero.text1":[{"type":0,"value":"Ergo - это децентрализованная платформа, созданная и поддерживаемая своим сообществом. "}],"components.communitySection.communityHero.text2":[{"type":0,"value":"Присоединяйтесь к нам в социальных сетях, чтобы стать частью сообщества. Обязательно ознакомьтесь с разделом "}],"components.communitySection.communityHero.text3":[{"type":0,"value":", чтобы узнать больше информации."}],"components.dApps.heading":[{"type":0,"value":"DApps"}],"components.discoverErgo.text.1":[{"type":0,"value":"Ergo — это платформа смарт-контрактов следующего поколения, построенная на принципе «Доказательтве выполнения работы» (Proof of Work), которая позволяет использовать новые модели финансового взаимодействия, основанные на безопасном и богатом языке сценариев, построенном с гибкими и мощными доказательствами с нулевым разглашением (Σ-протоколы)."}],"components.discoverHero.button1":[{"type":0,"value":"ПРОЧИТАТЬ ДОКУМЕНТАЦИЮ"}],"components.discoverHero.button2":[{"type":0,"value":"ВИДЕО-ОБУЧЕНИЕ С DECO"}],"components.discoverHero.button3":[{"type":0,"value":"ИЗУЧИТЬ МАНИФЕСТ"}],"components.discoverHero.button4":[{"type":0,"value":"ПОСМОТРЕТЬ В БЛОГЕ"}],"components.discoverHero.button5":[{"type":0,"value":"КАК УСТАНОВИТЬ"}],"components.discoverHero.button6":[{"type":0,"value":"ПОСЕТИТЬ ERGONAUT.SPACE"}],"components.discoverHero.title":[{"type":0,"value":"Откройте для себя Ergo"}],"components.documents.description":[{"type":0,"value":"Ergo подходит к своей платформе на основе исследований и использует стабильные, хорошо проверенные решения для создания прочной платформы для разработчиков, чтобы они могли строить на этом годами. Большинство решений Ergo формализованы в статьях, представленных на научно-практических конференциях и были широко обсуждены в сообществе."}],"components.documents.heading":[{"type":0,"value":"Документы"}],"components.ecosystemHero.title":[{"type":0,"value":"Экосистема"}],"components.ergoExplorer.button1":[{"type":0,"value":"ИССЛЕДОВАТЕЛЬ"}],"components.ergoExplorer.button2":[{"type":0,"value":"ERGO.WATCH"}],"components.ergoRaffle.description":[{"type":0,"value":"ErgoRaffle is a crowdfunding service built on Ergo Platform that enables anyone to raise money for a project. This project can range from a direct donation to a charity, an academic or business plan, or anything you can convince people to part with their hard-earned ERG for! As an added bonus, after finishing the Raffle, a lottery takes place, and one lucky participant wins a set percent of the Raffle as a \\"raffle reward\\"."}],"components.ergoRaffle.heading":[{"type":0,"value":"Ergo Raffle"}],"components.ergofoundation.list1":[{"type":0,"value":"Содействие "},{"children":[{"type":0,"value":"непрерывной разработке "}],"type":8,"value":"b"},{"type":0,"value":" протокола платформы Ergo;"}],"components.ergofoundation.list2":[{"type":0,"value":"Информирование о широком внедрении и использовании платформы Ergo и ее "},{"children":[{"type":0,"value":" нативного токена "}],"type":8,"value":"b"},{"type":0,"value":" (ERG);"}],"components.ergofoundation.list3":[{"type":0,"value":"Развитие "},{"children":[{"type":0,"value":"экосистемы "}],"type":8,"value":"b"},{"type":0,"value":" вокруг платформы Ergo;"}],"components.ergofoundation.list4":[{"type":0,"value":"Распространять использование платформы Ergo и технологии блокчейн для "},{"children":[{"type":0,"value":" общественного блага "}],"type":8,"value":"b"},{"type":0,"value":" ;"}],"components.ergofoundation.list5":[{"type":0,"value":"Поддерживать "},{"children":[{"type":0,"value":"действительно децентрализованную инфраструктуру"}],"type":8,"value":"b"},{"type":0,"value":" и;"}],"components.ergofoundation.list6":[{"type":0,"value":"Поддерживать "},{"children":[{"type":0,"value":"неприкосновенность частной жизни "}],"type":8,"value":"b"},{"type":0,"value":" как основного права человека."}],"components.ergofoundation.title":[{"children":[{"type":0,"value":"Фонд Ergo"}],"type":8,"value":"b"},{"type":0,"value":" – это общественная организация, ориентированная на:"}],"components.exchanges.available":[{"type":0,"value":"Доступно на популярных централизованных и децентрализованных биржах."}],"components.exchanges.disclaimer":[{"type":0,"value":"Отказ от ответственности: биржи предоставляют сильно отличающийся уровень безопасности, защиты конфиденциальности и контроля над вашими средствами и информацией. Мы настоятельно рекомендуем управлять своими собственными средствами и использовать один из предоставленных выше вариантов кошельков."}],"components.exchanges.heading":[{"type":0,"value":"ПОКУПАЙТЕ, ПРОДАВАЙТЕ И ТОРГУЙТЕ ERGO"}],"components.exchanges.subheading":[{"type":0,"value":"Биржи"}],"components.explore.description":[{"type":0,"value":"Ergo Explorer - это ваш интерфейс с блокчейном. Следите за каждой сделкой в реальном времени. Или просматривайте метрики, подобранные сообществом на ergo.watch."}],"components.explore.heading":[{"type":0,"value":"Исследуйте"}],"components.explore.subheading":[{"type":0,"value":"ОКУНИТЕСЬ В МОРЕ ТРАНЗАКЦИЙ ERGO"}],"components.faq.anyQuestions":[{"type":0,"value":"ЕСТЬ ВОПРОСЫ?"}],"components.faq.description":[{"type":0,"value":"Мы собрали наиболее часто задаваемые вопросы."}],"components.faq.heading":[{"type":0,"value":"Часто задаваемые вопросы"}],"components.faq.text.2":[{"type":0,"value":"НЕ МОЖЕТЕ НАЙТИ ТО, "},{"type":1,"value":"breakingLine"},{"type":0,"value":" ЧТО ИЩЕТЕ?"}],"components.favorites.button1":[{"type":0,"value":"УЗНАТЬ ОБ ERGO RAFFLE"}],"components.getErg.BuyIt.text":[{"type":0,"value":"Доступно на популярных централизованных и децентрализованных биржах."}],"components.getErg.BuyIt.title":[{"type":0,"value":"Биржи"}],"components.getErg.MineIt.text":[{"type":0,"value":"Autolykos - алгоритм ASIC-resistant и справедливой добычи Proof-of-Work, дружественный для обычных GPU."}],"components.getErg.MineIt.title":[{"type":0,"value":"Добыть"}],"components.getErg.StoreIt.text":[{"type":0,"value":"Простые и безопасные некастодиальные кошельки для сохранения ваших ERG."}],"components.getErg.StoreIt.title":[{"type":0,"value":"Кошельки"}],"components.getErg.UseIt.title":[{"type":0,"value":"Используйте ERG уже сегодня в нашей развивающейся экосистеме."}],"components.getErg.description":[{"type":0,"value":"На платформе Ergo развивается богатая экосистема. Мы предлагаем решения для разработчиков, майнеров и инвесторов."}],"components.getErg.heroTitle":[{"type":0,"value":"НЕПОБЕДИМЫЙ ДЕЦЕНТРАЛИЗОВАННЫЙ ФИНАНС"}],"components.getErg.title":[{"type":0,"value":"Получите ERG"}],"components.grantsAndBounties.button1":[{"type":0,"value":"СОТРУДНИЧЕСТВО"}],"components.grantsAndBounties.button2":[{"type":0,"value":"НАЧАТЬ RAFFLE"}],"components.grantsAndBounties.button3":[{"type":0,"value":"СВЯЗАТЬСЯ"}],"components.grantsAndBounties.description":[{"type":0,"value":"В общем, любое обучающее материалы для сообщества подлежит вознаграждению, даже если оно не указано в списке. Мы ищем проекты, направленные на построение ключевой инфраструктуры экосистемы. Однако, самый быстрый способ получить финансирование - это начать розыгрыш."}],"components.grantsAndBounties.heading":[{"type":0,"value":"Гранты и вознаграждения"}],"components.hallOfFame.description1":[{"type":0,"value":"Ergo была основана командой, которая имеет солидный опыт в разработке основных криптовалют и фреймворков блокчейна, включая NXT, Scorex, Cardano и Waves. Ниже приведены краткие биографии некоторых из основной команды ERGO, а также многих других разработчиков и участников сообщества, некоторые из которых анонимны."}],"components.hallOfFame.description2":[{"type":0,"value":"Ergo – это основа, и большинство членов основной команды (и даже членов фонда) начинали как члены сообщества. Внизу этой страницы есть краткое описание, а также информация, чтобы узнать больше о Фонде Эрго."}],"components.hallOfFame.tab1":[{"type":0,"value":"ЯДРО"}],"components.hallOfFame.tab2":[{"type":0,"value":"СООБЩЕСТВО"}],"components.hallOfFame.tab3":[{"type":0,"value":"ФОНД"}],"components.hallOfFame.title":[{"type":0,"value":"Зал Славы"}],"components.highlights.slide.1.quote":[{"type":0,"value":"95,57% "},{"type":1,"value":"breakingLine"},{"type":0,"value":"Публичное распределение"}],"components.highlights.slide.1.text":[{"type":0,"value":"Когда Ergo запустился в 2019 году, не было ни начального предложения монет, ни предварительной добычи, ни предварительного распределения токенов каким-либо членам команды или венчурным капиталистам. Действительно справедливый запуск с 4,43% средств, выделенных на развитие экосистемы. Без прецедента в любой другой платформе смарт-контрактов."}],"components.highlights.slide.1.title":[{"type":0,"value":"Справедливый старт"}],"components.highlights.slide.2.quote":[{"type":0,"value":"TRUE P2P"}],"components.highlights.slide.2.text":[{"type":0,"value":"Позволяя более инновационные, целевые реализации, которые не могут соответствовать традиционному банковскому сектору. Ergo предлагает мощные инструменты с умными контрактами для микрокредитных учреждений и местных торговых систем обмена (LETS)."}],"components.highlights.slide.2.title":[{"type":0,"value":"Альтернативная экономика"}],"components.highlights.slide.3.quote":[{"type":0,"value":"Σ-protocols"}],"components.highlights.slide.3.text":[{"type":0,"value":"Конфиденциальность должна оставаться вариантом для защиты автономии. Конфиденциальность - это возможность создания барьеров и установки границ для создания пространства для индивидуальности. Каждый сам выбирает границы и ограничения, которые он хочет создать. Это позволяет новым моделям финансового взаимодействия, основанным на безопасном и богатом языке сценариев ErgoScript и гибких и мощных доказательствах нулевого знания."}],"components.highlights.slide.3.title":[{"type":0,"value":"Дополнительная конфиденциальность"}],"components.highlights.title":[{"type":0,"value":"Главное"}],"components.homeHero.button":[{"type":0,"value":"УЗНАТЬ БОЛЬШЕ"}],"components.homeHero.text":[{"type":0,"value":"Ergo — это платформа смарт-контрактов нового поколения, которая обеспечивает экономическую свободу обычных людей с помощью безопасных, доступных и децентрализованных финансовых инструментов."}],"components.homeHero.title":[{"type":0,"value":"Обеспечение финансовой системы будущего"}],"components.homeInfo.blockReward":[{"type":0,"value":"НАГРАДА ЗА БЛОК"}],"components.homeInfo.circulatingSupply":[{"type":0,"value":"ОБЪЕМ В ОБРАЩЕНИИ"}],"components.homeInfo.hashRate":[{"type":0,"value":"МОЩНОСТЬ СЕТИ"}],"components.homeInfo.transactionPerDay":[{"type":0,"value":"ТРАНЗАКЦИЙ В ДЕНЬ"}],"components.learn.description":[{"type":0,"value":"Начните с основ. Что такое Ergo? Что вы можете делать на Ergo?"}],"components.learn.heading":[{"type":0,"value":"Учиться"}],"components.mining.button1":[{"type":0,"value":"ДОКУМЕНТАЦИЯ"}],"components.mining.button2":[{"type":0,"value":"СТАТИСТИКА ПУЛА ДЛЯ МАЙНИНГА"}],"components.mining.button3":[{"type":0,"value":"DISCORD"}],"components.mining.button4":[{"type":0,"value":"SUBREDDIT"}],"components.mining.button5":[{"type":0,"value":"ПОСТЫ БЛОГА О МАЙНИНГЕ"}],"components.mining.calculator.currentBlockReward":[{"type":0,"value":"Текущая награда за блок"}],"components.mining.calculator.currentPrice":[{"type":0,"value":"Текущая цена"}],"components.mining.calculator.description":[{"type":0,"value":"Autolykos - это алгоритм, ориентированный на GPU, основанный на устойчивой к ASIC технологии Proof of Work (PoW) с жестким доступом к памяти."}],"components.mining.calculator.networkHashrate":[{"type":0,"value":"Хешрейт сети"}],"components.mining.calculator.rev":[{"type":0,"value":"Дневной доход"}],"components.mining.calculator.title":[{"type":0,"value":"Калькулятор майнинга"}],"components.mining.minersTitle":[{"type":0,"value":"Майнеры"}],"components.mining.miningPoolsTitle":[{"type":0,"value":"Пулы для майнинга"}],"components.mining.text.1":[{"type":0,"value":"Майнинг Ergo основан на алгоритме «Autolykos», основанном на принципе «Доказательтве выполнения работы» (Proof of Work), устойчивом к ASIC. Майнеры могут настраивать параметры с помощью голосования в сети, а более крупные изменения вносятся квалифицированным большинством с помощью софт-форка. А также можно участвовать в любых захватывающих разработках, таких как токены для голосования, под-пулы и майнинг пространства журналов. Ergo фокусируется на простоте в ядре, с расширенными функциями, построенными на прикладном уровне, для создания устойчивых договорных денег."}],"components.mining.text.2":[{"type":0,"value":"Добро пожаловать в будущее принципа «Доказательтво выполнения работы» (Proof of Work)"}],"components.mining.text.3":[{"type":0,"value":"Чтобы начать работу, ознакомьтесь с созданным сообществом Справочником по майнингу, документацией или присоединитесь к дискуссионным площадкам по майнингу."}],"components.mining.title":[{"type":0,"value":"Майнинг"}],"components.news.blog":[{"type":0,"value":"Блог"}],"components.news.latest":[{"type":0,"value":"Последние новости"}],"components.news.title":[{"type":0,"value":"Новости"}],"components.ourFavorites.heading":[{"type":0,"value":"НАШИ ИЗБРАННЫЕ"}],"components.ourmission.description":[{"type":0,"value":"Фонд Ergo стремится к органичному и непрерывному развитию протокола платформы Ergo."}],"components.ourmission.emissionAndTokenomics":[{"type":0,"value":"ЭМИССИЯ И ТОКЕНОМИКА"}],"components.ourmission.ergofoundation":[{"type":0,"value":"ФОНД ERGO"}],"components.ourmission.reachus.twitter":[{"type":0,"value":"СЛЕДИТЬ ЗА НАМИ В TWITTER"}],"components.ourmission.subdescription":[{"type":0,"value":"Фонд Ergo стремится приложить усилия, чтобы максимизировать количество ценных разработок экосистемы, сделанных с открытым исходным кодом с минимально возможной разрешительной лицензией."}],"components.ourmission.title":[{"type":0,"value":"Наша Миссия"}],"components.partners.title":[{"type":0,"value":"Партнеры"}],"components.roadmap.coinmarketcal":[{"type":0,"value":"УЗНАТЬ БОЛЬШЕ НА COINMARKETCAL"}],"components.roadmap.description":[{"type":0,"value":"Обратите внимание, что Ergo — это платформа. Многие из перечисленных ниже проектов не имеют формальной связи ни с Фондом Ergo, ни друг с другом."}],"components.roadmap.section1.title":[{"type":0,"value":"СДЕЛАНО"}],"components.roadmap.section2.title":[{"type":0,"value":"ЭКОСИСТЕМА"}],"components.roadmap.section3.title":[{"type":0,"value":"СКОРО"}],"components.roadmap.section4.title":[{"type":0,"value":"2024 И ДАЛЕЕ"}],"components.roadmap.title":[{"type":0,"value":"Дорожная карта"}],"components.software.description":[{"type":0,"value":"Узел Ergo - ваша точка входа для разработки на Ergo и позволяет вам взаимодействовать с блокчейном."}],"components.software.heading":[{"type":0,"value":"Программное обеспечение"}],"components.uniqueErgo.card1.button":[{"type":0,"value":"ИЗУЧИТЬ"}],"components.uniqueErgo.card1.text":[{"type":0,"value":"Ergo опирается на десятилетний опыт разработки блокчейна, дополняя проверенные принципы лучшими рецензируемыми академическими исследованиями в области криптографии, моделей консенсуса и цифровых валют. Мы начинаем с прочных основ блокчейна и изначально реализуем новую и мощную криптографию."}],"components.uniqueErgo.card1.title":[{"type":0,"value":"ИССЛЕДОВАНИЯ И ФОКУС НА РЕАЛЬНОМ ПРИМЕНЕНИИ"}],"components.uniqueErgo.card2.button":[{"type":0,"value":"ИЗУЧИТЬ"}],"components.uniqueErgo.card2.text":[{"type":0,"value":"Ergo обеспечивает превосходную поддержку для реальных финансовых соглашений. Ergo может поддерживать универсальные распределенные приложения (dApps), которые работают предсказуемо, с известными затратами и не несут никаких опасностей неограниченной функциональности. Смарт-контракты Ergo позволяют нам выполнять широкий спектр задач и могут быть Тьюринг-полными, но мы всегда заранее знаем, сколько будет стоить код и будет ли он работать успешно."}],"components.uniqueErgo.card2.title":[{"type":0,"value":"МОЩНОСТЬ И БЕЗОПАСНОСТЬ"}],"components.uniqueErgo.card3.button":[{"type":0,"value":"ИЗУЧИТЬ"}],"components.uniqueErgo.card3.text":[{"type":0,"value":"Сигма-протоколы (Σ-протоколы) являются основой смарт-контрактов Ergo. Они позволяют создать класс эффективных протоколов с нулевым разглашением, которые позволяют нам выполнять сложные задачи, которые в противном случае были бы невозможными, рискованными или дорогостоящими. Добро пожаловать в самостоятельную конфиденциальность на уровне приложений: ненадежные сценарии, которые можно использовать для доступа к микшерам или другим функциям без участия третьих лиц."}],"components.uniqueErgo.card3.title":[{"type":0,"value":"ИНТЕЛЛЕКТУАЛЬНОСТЬ И ПРОСТОТА"}],"components.uniqueErgo.card4.button":[{"type":0,"value":"ИЗУЧИТЬ"}],"components.uniqueErgo.card4.text":[{"type":0,"value":"Обычные пользователи, которые не используют полный узел, должны пользоваться теми же преимуществами безопасности, что и майнеры. Неинтерактивные доказательства работы (NIPOPOWS) позволяют нам совершать и проверять транзакции с полной уверенностью, не требуя хранения, пропускной способности и времени, необходимых для загрузки полной цепочки блоков. Требуется всего 1 МБ данных, что означает, что вы можете использовать любое устройство."}],"components.uniqueErgo.card4.title":[{"type":0,"value":"БЕЗОПАСНОСТЬ И ДОСТУПНОСТЬ"}],"components.uniqueErgo.title":[{"type":0,"value":"ЧТО ДЕЛАЕТ ERGO УНИКАЛЬНЫМ"}],"components.usingErg.BuyIt.text":[{"type":0,"value":"Доступны на популярных централизованных и децентрализованных биржах."}],"components.usingErg.BuyIt.title":[{"type":0,"value":"Биржи"}],"components.usingErg.MineIt.text":[{"type":0,"value":"Autolykos - алгоритм Proof-of-Work, устойчивый к ASIC, дружественный к обычным GPU и честно добытый."}],"components.usingErg.MineIt.title":[{"type":0,"value":"Майнинг"}],"components.usingErg.StoreIt.text":[{"type":0,"value":"Простые и безопасные некастодиальные кошельки для сохранения ваших ERG."}],"components.usingErg.StoreIt.title":[{"type":0,"value":"Кошельки"}],"components.usingErg.UseIt.title":[{"type":0,"value":"Используйте ERG уже сегодня в нашей развивающейся экосистеме."}],"components.usingErg.description":[{"type":0,"value":"На основе Ergo создается продвинутая эко-система. Независимо от того, являетесь ли вы разработчиком, майнером или инвестором – вы получите все возможности"}],"components.usingErg.subtitle":[{"type":0,"value":"НЕУДЕРЖИМЫЕ РАСПРЕДЕЛЕННЫЕ ФИНАНСЫ (DEFI)"}],"components.usingErg.title":[{"type":0,"value":"ПОЛУЧИТЬ ERG"}],"components.wallets.chooseYours":[{"type":0,"value":"ВЫБЕРИТЕ СВОЙ"}],"components.wallets.coldStorageHeader":[{"type":0,"value":"Холодное хранилище"}],"components.wallets.featureHeader":[{"type":0,"value":"Особенности"}],"components.wallets.hotStorageHeader":[{"type":0,"value":"Горячее хранилище"}],"components.wallets.mobileAppHeader":[{"type":0,"value":"Мобильное приложение"}],"components.wallets.setupGuides":[{"type":0,"value":"ИНСТРУКЦИИ ПО НАСТРОЙКЕ"}],"components.wallets.walletDescription1":[{"type":0,"value":"Цифровые кошельки помогают сохранять вашу цифровую валюту в безопасности, обеспечивая конфиденциальность и контроль."}],"components.wallets.walletDescription2":[{"type":0,"value":"Обратите внимание, что кошельки поддерживаются третьими лицами, мы предоставляем информацию ниже только как вежливость, чтобы упростить общий опыт работы с цифровыми валютами."}],"components.wallets.walletsHeader":[{"type":0,"value":"Кошельки"}],"components.wallets.walletsTitle":[{"type":0,"value":"Кошельки"}],"components.wiki.description":[{"type":0,"value":"ergonaut.space - это наша общинно-обслуживаемая вики! Забитая полезной информацией о технических подробностях блокчейна Ergo на понятном языке для неспециалистов. Есть также множество руководств, учебников и материалов, предоставленных пользователями. Создайте учетную запись, чтобы начать вносить свой вклад!"}],"components.wiki.description.short":[{"type":0,"value":"ergonaut.space - это общинная вики-энциклопедия блокчейна Ergo, переводящая, как использовать и технические подробности Ergo на понятном языке для неспециалистов."}],"components.wiki.heading":[{"type":0,"value":"Wiki"}],"footer.blog.title":[{"type":0,"value":"БЛОГ"}],"footer.community.1":[{"type":0,"value":"Присоединяйтесь к нам"}],"footer.community.2":[{"type":0,"value":"Сигманавты"}],"footer.community.3":[{"type":0,"value":"Сотрудничество с Ergo"}],"footer.community.4":[{"type":0,"value":"Зал СЛавы"}],"footer.community.5":[{"type":0,"value":"Фонд Ergo"}],"footer.community.title":[{"type":0,"value":"СООБЩЕСТВО"}],"footer.discover.1":[{"type":0,"value":"Программное обеспечение"}],"footer.discover.2":[{"type":0,"value":"Гранты & Награды"}],"footer.discover.3":[{"type":0,"value":"Вопросы и ответы"}],"footer.discover.4":[{"type":0,"value":"Исследователь"}],"footer.discover.5":[{"type":0,"value":"Документы"}],"footer.discover.title":[{"type":0,"value":"ИЗУЧИТЬ"}],"footer.ecosystem.1":[{"type":0,"value":"Приложения (DApps)"}],"footer.ecosystem.2":[{"type":0,"value":"Дорожная карта"}],"footer.ecosystem.3":[{"type":0,"value":"База знаний"}],"footer.ecosystem.4":[{"type":0,"value":"Ergo Raffle"}],"footer.ecosystem.5":[{"type":0,"value":"Видео-подкасты"}],"footer.ecosystem.title":[{"type":0,"value":"ЭКО-СИСТЕМА"}],"footer.getErg.1":[{"type":0,"value":"Майнинг"}],"footer.getErg.2":[{"type":0,"value":"Калькулятор майнига"}],"footer.getErg.3":[{"type":0,"value":"Кошельки"}],"footer.getErg.4":[{"type":0,"value":"Биржи"}],"footer.getErg.title":[{"type":0,"value":"ПОЛУЧИТЬ ERG"}],"footer.legal":[{"type":0,"value":"Законность"}],"footer.news.title":[{"type":0,"value":"НОВОСТИ"}],"footer.privacyPolicy":[{"type":0,"value":"Политика конфиденциальности"}],"footer.weGotIt":[{"type":0,"value":"У нас есть!"}],"navigation.discover":[{"type":0,"value":"ИЗУЧИТЬ"}],"navigation.ecosystem":[{"type":0,"value":"ЭКО-СИСТЕМА"}],"navigation.ergoCommunity":[{"type":0,"value":"ERGO СООБЩЕСТВО"}],"navigation.getErg":[{"type":0,"value":"ПОЛУЧИТЬ ERG"}],"navigation.moreContent":[{"type":0,"value":"Больше информации?"}],"pages.404.hero":[{"type":0,"value":"404. Страница не найдена."}],"pages.404.title":[{"type":0,"value":"Не найдено"}],"pages.blog.title":[{"type":0,"value":"Блог"}],"pages.community.title":[{"type":0,"value":"Сообщество"}],"pages.discover.title":[{"type":0,"value":"Изучить"}],"pages.ecosystem.title":[{"type":0,"value":"Эко-система"}],"pages.get-erg.title":[{"type":0,"value":"Получить ERG"}],"pages.home.title":[{"type":0,"value":"Начало"}],"pages.legal.title":[{"type":0,"value":"Законность"}],"pages.mobile-wallets":[{"type":0,"value":"Мобильные кошельки"}],"pages.privacyPolicy.title":[{"type":0,"value":"Политика конфиденциальности"}]}');
;// CONCATENATED MODULE: ./content/compiled-locales/id.json
var id_namespaceObject = JSON.parse('{"components.ContributeForm.company.subTitle":[{"type":0,"value":"INGIN MENJADI MITRA?"}],"components.ContributeForm.company.title":[{"type":0,"value":"saya adalah seorang "},{"children":[{"type":0,"value":"perusahaan"}],"type":8,"value":"b"}],"components.ContributeForm.developer.subTitle":[{"type":0,"value":"BAGAIMANA SAYA DAPAT BERKONTRIBUSI?"}],"components.ContributeForm.developer.title":[{"type":0,"value":"saya adalah seorang "},{"children":[{"type":0,"value":"pengembang"}],"type":8,"value":"b"}],"components.ContributeForm.text":[{"type":0,"value":"Ergo beroperasi pada model terbuka di mana "},{"children":[{"type":0,"value":"siapapun dipersilakan untuk berkontribusi."}],"type":8,"value":"b"}],"components.ContributeForm.title":[{"type":0,"value":"Menyumbang"}],"components.DApps.seeAllProjects":[{"type":0,"value":"LIHAT SEMUA PROYEK"}],"components.Sigmanauts.button":[{"type":0,"value":"BACA SELENGKAPNYA"}],"components.Sigmanauts.button.buttonContribute":[{"type":0,"value":"PEDOMAN KONTRIBUSI"}],"components.Sigmanauts.button.discord":[{"type":0,"value":"BERGABUNGLAH DENGAN KAMI DI DISCORD"}],"components.Sigmanauts.button.grantsAndBounties":[{"type":0,"value":"HIBAH"}],"components.Sigmanauts.button.writeAndReviewCode":[{"type":0,"value":"MENYELAM KE ERGO"}],"components.Sigmanauts.formInput.button":[{"type":0,"value":"MENGIRIM"}],"components.Sigmanauts.formInput.email":[{"type":0,"value":"Surel"}],"components.Sigmanauts.formInput.name":[{"type":0,"value":"Nama / Perusahaan"}],"components.Sigmanauts.formInput.text":[{"type":0,"value":"Tuliskan saran dan ide Anda, mari kita bicara!"}],"components.Sigmanauts.subTitle":[{"type":0,"value":"Program pelatihan"}],"components.Sigmanauts.text":[{"type":0,"value":"Terapkan untuk Program Pelatihan Sigmanaut untuk membantu membentuk dan menumbuhkan Ergo. "}],"components.Sigmanauts.title":[{"type":0,"value":"Sigmanaut"}],"components.Spotlight.button":[{"type":0,"value":"LIHAT SEMUA POSTINGAN"}],"components.Spotlight.title":[{"type":0,"value":"Menyoroti"}],"components.autolykos.button":[{"type":0,"value":"ERG TAMBANG"}],"components.autolykos.header":[{"type":0,"value":"AUTOLYKOS"}],"components.autolykos.text":[{"children":[{"type":0,"value":"Autolykos"}],"type":8,"value":"b"},{"type":0,"value":" adalah algoritme Proof of Work tahan ASIC tahan memori yang berorientasi pada GPU."}],"components.autolykos.title":[{"type":0,"value":"Masa Depan Bukti Kerja"}],"components.communityHero.subtitle":[{"type":0,"value":"KEUANGAN RUMPUT"}],"components.communityHero.title":[{"type":0,"value":"Komunitas"}],"components.communitySection.communityHero.linkText":[{"type":0,"value":"Berkontribusi"}],"components.communitySection.communityHero.text1":[{"type":0,"value":"Ergo adalah platform akar rumput terdesentralisasi yang didukung oleh komunitasnya."}],"components.communitySection.communityHero.text2":[{"type":0,"value":"Bergabunglah dengan kami di sosial untuk terlibat, lihat"}],"components.communitySection.communityHero.text3":[{"type":0,"value":"halaman untuk informasi lebih lanjut"}],"components.dApps.heading":[{"type":0,"value":"DApps"}],"components.discoverErgo.text.1":[{"type":0,"value":"Ergo adalah platform kontrak pintar Proof of Work generasi berikutnya yang memungkinkan model interaksi keuangan baru, didukung oleh bahasa skrip yang aman dan kaya yang dibangun dengan bukti Zero-Knowledge (Σ-protocols) yang fleksibel dan kuat."}],"components.discoverHero.button1":[{"type":0,"value":"BACA DOKUMEN"}],"components.discoverHero.button2":[{"type":0,"value":"BELAJAR DENGAN DECO"}],"components.discoverHero.button3":[{"type":0,"value":"BACA Manifesto"}],"components.discoverHero.button4":[{"type":0,"value":"PERIKSA BLOG"}],"components.discoverHero.button5":[{"type":0,"value":"DAPATKAN PENGATURAN"}],"components.discoverHero.button6":[{"type":0,"value":"KUNJUNGI ERGONAUT.SPACE"}],"components.discoverHero.title":[{"type":0,"value":"Temukan Ergo"}],"components.documents.description":[{"type":0,"value":"Ergo mengambil pendekatan berbasis penelitian dan menggunakan solusi stabil yang telah teruji dengan baik untuk menyediakan platform yang kuat bagi pengembang untuk dibangun di tahun-tahun mendatang. "}],"components.documents.heading":[{"type":0,"value":"Dokumen"}],"components.ecosystemHero.title":[{"type":0,"value":"Ekosistem"}],"components.ergoExplorer.button1":[{"type":0,"value":"PENJELAJAH"}],"components.ergoExplorer.button2":[{"type":0,"value":"ERGO.PERHATIKAN"}],"components.ergoRaffle.description":[{"type":0,"value":"ErgoRaffle adalah layanan crowdfunding yang dibangun di atas Platform Ergo yang memungkinkan siapa saja mengumpulkan uang untuk sebuah proyek. "}],"components.ergoRaffle.heading":[{"type":0,"value":"Ergo Undian"}],"components.ergofoundation.list1":[{"type":0,"value":"Mempromosikan "},{"children":[{"type":0,"value":"pembangunan yang tidak putus-putus "}],"type":8,"value":"b"},{"type":0,"value":" protokol Platform Ergo;"}],"components.ergofoundation.list2":[{"type":0,"value":"Mempublikasikan adopsi dan penggunaan Platform Ergo dan platformnya secara luas "},{"children":[{"type":0,"value":" token asli "}],"type":8,"value":"b"},{"type":0,"value":" (ERG);"}],"components.ergofoundation.list3":[{"type":0,"value":"Mengembangkan "},{"children":[{"type":0,"value":"ekosistem "}],"type":8,"value":"b"},{"type":0,"value":" di sekitar Platform Ergo;"}],"components.ergofoundation.list4":[{"type":0,"value":"Sebarkan penggunaan Platform Ergo dan teknologi blockchain untuk "},{"children":[{"type":0,"value":" kebaikan sosial "}],"type":8,"value":"b"},{"type":0,"value":";"}],"components.ergofoundation.list5":[{"type":0,"value":"Menegakkan "},{"children":[{"type":0,"value":"infrastruktur yang benar-benar terdesentralisasi"}],"type":8,"value":"b"},{"type":0,"value":", Dan;"}],"components.ergofoundation.list6":[{"type":0,"value":"Mendukung "},{"children":[{"type":0,"value":"pribadi "}],"type":8,"value":"b"},{"type":0,"value":" sebagai hak dasar manusia."}],"components.ergofoundation.title":[{"type":0,"value":"Itu "},{"children":[{"type":0,"value":"Yayasan Ergo"}],"type":8,"value":"b"},{"type":0,"value":" adalah entitas berbasis komunitas yang berfokus pada"}],"components.exchanges.available":[{"type":0,"value":"Tersedia di seluruh bursa populer dan bursa terdesentralisasi."}],"components.exchanges.disclaimer":[{"type":0,"value":"Penafian: Pertukaran memberikan tingkat keselamatan, keamanan, privasi, dan kontrol yang sangat bervariasi atas dana dan informasi Anda. "}],"components.exchanges.heading":[{"type":0,"value":"BELI, JUAL, DAN PERDAGANGAN ERGO"}],"components.exchanges.subheading":[{"type":0,"value":"Pertukaran"}],"components.explore.description":[{"type":0,"value":"Ergo Explorer adalah antarmuka Anda dengan blockchain. "}],"components.explore.heading":[{"type":0,"value":"Mengeksplorasi"}],"components.explore.subheading":[{"type":0,"value":"SELAMI LAUT TRANSAKSI ERGO"}],"components.faq.anyQuestions":[{"type":0,"value":"ADA PERTANYAAN?"}],"components.faq.description":[{"type":0,"value":"Kami telah mengumpulkan beberapa pertanyaan yang paling sering diajukan."}],"components.faq.heading":[{"type":0,"value":"FAQ"}],"components.faq.text.2":[{"type":0,"value":"TIDAK BISA MENEMUKAN APA "},{"type":1,"value":"breakingLine"},{"type":0,"value":" YANG ANDA CARI?"}],"components.favorites.button1":[{"type":0,"value":"JELAJAHI UNDIAN ERGO"}],"components.getErg.BuyIt.text":[{"type":0,"value":"Tersedia di seluruh bursa sentralisasi dan desentralisasi yang populer."}],"components.getErg.BuyIt.title":[{"type":0,"value":"Pertukaran"}],"components.getErg.MineIt.text":[{"type":0,"value":"Autolykos, tahan ASIC"}],"components.getErg.MineIt.title":[{"type":0,"value":"Tambang itu"}],"components.getErg.StoreIt.text":[{"type":0,"value":"Dompet non-penahanan yang sederhana dan aman untuk menjaga keamanan ERG Anda."}],"components.getErg.StoreIt.title":[{"type":0,"value":"Dompet"}],"components.getErg.UseIt.text":[{"type":0,"value":"Manfaatkan ERG Anda hari ini di ekosistem kita yang terus berkembang"}],"components.getErg.UseIt.title":[{"type":0,"value":"Ekosistem"}],"components.getErg.description":[{"type":0,"value":"Ada tunas ekosistem yang kaya di atas Ergo. "}],"components.getErg.title":[{"type":0,"value":"Dapatkan ERG"}],"components.grantsAndBounties.button1":[{"type":0,"value":"BERKONTRIBUSI"}],"components.grantsAndBounties.button2":[{"type":0,"value":"MULAI UNDIAN"}],"components.grantsAndBounties.button3":[{"type":0,"value":"BERHUBUNGAN"}],"components.grantsAndBounties.description":[{"type":0,"value":"Secara umum, apa pun yang mendidik bagi Komunitas tunduk pada beberapa karunia meskipun tidak disebutkan secara khusus. "}],"components.grantsAndBounties.heading":[{"type":0,"value":"Hibah"}],"components.hallOfFame.description1":[{"type":0,"value":"Ergo didirikan dengan tim yang memiliki latar belakang yang kuat dalam pengembangan inti dengan cryptocurrency dan kerangka kerja blockchain termasuk NXT, Scorex, Cardano, dan Waves. "}],"components.hallOfFame.description2":[{"type":0,"value":"Ergo adalah akar rumput, dan sebagian besar anggota tim inti (dan bahkan anggota yayasan) dimulai sebagai anggota komunitas. "}],"components.hallOfFame.tab1":[{"type":0,"value":"CORE"}],"components.hallOfFame.tab2":[{"type":0,"value":"KOMUNITAS"}],"components.hallOfFame.tab3":[{"type":0,"value":"DASAR"}],"components.hallOfFame.title":[{"type":0,"value":"Ketenaran"}],"components.highlights.title":[{"type":0,"value":"SOROTAN"}],"components.homeHero.button":[{"type":0,"value":"MENYELAM KE DALAM"}],"components.homeHero.text":[{"type":0,"value":"Ergo adalah platform kontrak cerdas generasi berikutnya yang memastikan kebebasan ekonomi orang biasa melalui alat keuangan yang aman, mudah diakses, dan terdesentralisasi."}],"components.homeHero.title":[{"type":0,"value":"Menggerakkan Masa Depan Keuangan"}],"components.homeInfo.blockReward":[{"type":0,"value":"HADIAH BLOK"}],"components.homeInfo.circulatingSupply":[{"type":0,"value":"PEREDARAN SUPLAI"}],"components.homeInfo.hashRate":[{"type":0,"value":"TINGKAT HASH"}],"components.homeInfo.transactionPerDay":[{"type":0,"value":"TRANSAKSI PER HARI"}],"components.learn.description":[{"type":0,"value":"Mulai dari dasar-dasarnya. "}],"components.learn.heading":[{"type":0,"value":"Mempelajari"}],"components.mining.button1":[{"type":0,"value":"DOKUMENTASI"}],"components.mining.button2":[{"type":0,"value":"STATISTIK KOLAM PERTAMBANGAN"}],"components.mining.button3":[{"type":0,"value":"PERSELISIHAN"}],"components.mining.button4":[{"type":0,"value":"SUBREDDIT"}],"components.mining.button5":[{"type":0,"value":"POSTINGAN BLOG PERTAMBANGAN"}],"components.mining.calculator.currentBlockReward":[{"type":0,"value":"Hadiah blok saat ini"}],"components.mining.calculator.currentPrice":[{"type":0,"value":"Harga sekarang"}],"components.mining.calculator.description":[{"type":0,"value":"Autolykos adalah algoritme Proof of Work (PoW) tahan ASIC tahan memori yang berorientasi pada GPU."}],"components.mining.calculator.hash":[{"type":0,"value":"hashrate Anda"}],"components.mining.calculator.networkHashrate":[{"type":0,"value":"Hash jaringan"}],"components.mining.calculator.rev":[{"type":0,"value":"Pendapatan harian"}],"components.mining.calculator.title":[{"type":0,"value":"Kalkulator Pertambangan"}],"components.mining.minersTitle":[{"type":0,"value":"Penambang"}],"components.mining.miningPoolsTitle":[{"type":0,"value":"Kolam Penambangan"}],"components.mining.text.1":[{"type":0,"value":"Penambangan Ergo didasarkan pada Autolykos, algoritme Proof of Work tahan ASIC yang efisien dan cukup diluncurkan. "}],"components.mining.text.2":[{"type":0,"value":"Selamat datang di masa depan Proof of Work."}],"components.mining.text.3":[{"type":0,"value":"Untuk memulai, lihat Buku Pegangan Penambangan, Dokumentasi, atau bergabunglah dengan ruang diskusi pertambangan."}],"components.mining.title":[{"type":0,"value":"Pertambangan"}],"components.news.blog":[{"type":0,"value":"Blog"}],"components.news.latest":[{"type":0,"value":"berita terbaru"}],"components.news.title":[{"type":0,"value":"Berita"}],"components.ourFavorites.heading":[{"type":0,"value":"FAVORIT KAMI"}],"components.ourmission.description":[{"type":0,"value":"Ergo Foundation berkomitmen untuk pengembangan protokol Platform Ergo yang organik dan tanpa henti."}],"components.ourmission.emissionAndTokenomics":[{"type":0,"value":"EMISI DAN TOKENOMI"}],"components.ourmission.ergofoundation":[{"type":0,"value":"YAYASAN ERGO"}],"components.ourmission.reachus.twitter":[{"type":0,"value":"HUBUNGI KAMI DI TWITTER"}],"components.ourmission.subdescription":[{"type":0,"value":"Ergo Foundation berkomitmen untuk melakukan upaya untuk memaksimalkan jumlah pengembangan ekosistem berharga yang dilakukan dengan cara sumber terbuka dengan izin permisif sesedikit mungkin."}],"components.ourmission.title":[{"type":0,"value":"Misi kita"}],"components.partners.title":[{"type":0,"value":"Mitra"}],"components.roadmap.coinmarketcal":[{"type":0,"value":"LIHAT LEBIH LANJUT DI COINMARKETCAL"}],"components.roadmap.description":[{"type":0,"value":"Harap dicatat bahwa Ergo adalah sebuah platform. "}],"components.roadmap.section1.title":[{"type":0,"value":"SEJAUH INI"}],"components.roadmap.section2.title":[{"type":0,"value":"EKOSISTEM"}],"components.roadmap.section3.title":[{"type":0,"value":"SEGERA"}],"components.roadmap.section4.title":[{"type":0,"value":"2024 & SELESAI"}],"components.roadmap.title":[{"type":0,"value":"Peta jalan"}],"components.software.description":[{"type":0,"value":"Ergo Node adalah titik masuk Anda untuk pengembangan di Ergo dan memungkinkan Anda berkomunikasi dengan blockchain."}],"components.software.heading":[{"type":0,"value":"Perangkat lunak"}],"components.uniqueErgo.card1.button":[{"type":0,"value":"EKSPLORASI"}],"components.uniqueErgo.card1.text":[{"type":0,"value":"Ergo mengacu pada pengembangan blockchain selama sepuluh tahun, melengkapi prinsip-prinsip yang telah dicoba dan diuji dengan penelitian akademik peer-review terbaik ke dalam kriptografi, model konsensus, dan mata uang digital. "}],"components.uniqueErgo.card1.title":[{"type":0,"value":"DIPIMPIN PENELITIAN DAN FOKUS DUNIA NYATA"}],"components.uniqueErgo.card2.button":[{"type":0,"value":"MENGEKSPLORASI"}],"components.uniqueErgo.card2.text":[{"type":0,"value":"Ergo memberikan dukungan unggul untuk perjanjian keuangan dunia nyata. "}],"components.uniqueErgo.card2.title":[{"type":0,"value":"KUAT DAN AMAN"}],"components.uniqueErgo.card3.button":[{"type":0,"value":"MENGEKSPLORASI"}],"components.uniqueErgo.card3.text":[{"type":0,"value":"Sigma Protocols (Σ-Protocols) adalah dasar dari smart contract Ergo. "}],"components.uniqueErgo.card3.title":[{"type":0,"value":"CERDAS DAN LANGSUNG"}],"components.uniqueErgo.card4.button":[{"type":0,"value":"MENGEKSPLORASI"}],"components.uniqueErgo.card4.text":[{"type":0,"value":"Pengguna biasa yang tidak menjalankan node penuh harus menikmati manfaat keamanan yang sama seperti penambang. "}],"components.uniqueErgo.card4.title":[{"type":0,"value":"AMAN DAN DAPAT DIAKSES"}],"components.uniqueErgo.title":[{"type":0,"value":"APA YANG MEMBUAT ERGO UNIK"}],"components.usingErg.description":[{"type":0,"value":"Ada tunas ekosistem yang kaya di atas Ergo. "}],"components.usingErg.subtitle":[{"type":0,"value":"DEFI YANG TAK TERHENTIKAN"}],"components.usingErg.title":[{"type":0,"value":"DAPATKAN ERG"}],"components.wallets.ErgoPay":[{"type":0,"value":"ErgoPay"}],"components.wallets.chooseYours":[{"type":0,"value":"PILIH MILIK ANDA"}],"components.wallets.coldStorageHeader":[{"type":0,"value":"Penyimpanan Dingin"}],"components.wallets.dAppConnectorHeader":[{"type":0,"value":"Konektor dApp"}],"components.wallets.featureHeader":[{"type":0,"value":"Fitur"}],"components.wallets.setupGuides":[{"type":0,"value":"PANDUAN PENGATURAN"}],"components.wallets.walletDescription1":[{"type":0,"value":"Dompet digital dapat membantu menjaga mata uang digital Anda tetap aman, pribadi, dan dalam kendali Anda."}],"components.wallets.walletDescription2":[{"type":0,"value":"Perhatikan bahwa dompet didukung oleh pihak ketiga, kami hanya memberikan informasi di bawah sebagai rasa hormat, untuk menyederhanakan pengalaman mata uang digital secara keseluruhan untuk Anda."}],"components.wallets.walletsHeader":[{"type":0,"value":"Dompet"}],"components.wallets.walletsTitle":[{"type":0,"value":"Dompet"}],"components.wiki.description":[{"type":0,"value":"ergonaut.space adalah wiki yang dikelola komunitas kami! "}],"components.wiki.description.short":[{"type":0,"value":"ergonaut.space adalah komunitas wiki dari blockchain Ergo, panduan yang menerjemahkan cara menggunakan dan detail teknis yang mendasari blockchain Ergo dalam bahasa yang mudah dipahami untuk orang non-teknis."}],"components.wiki.heading":[{"type":0,"value":"wiki"}],"footer.blog.title":[{"type":0,"value":"BLOG"}],"footer.community.1":[{"type":0,"value":"Bergabunglah dengan saluran kami"}],"footer.community.2":[{"type":0,"value":"Sigmanaut"}],"footer.community.3":[{"type":0,"value":"Berkontribusi untuk Ergo"}],"footer.community.4":[{"type":0,"value":"ketenaran"}],"footer.community.5":[{"type":0,"value":"Yayasan Ergo"}],"footer.community.title":[{"type":0,"value":"KOMUNITAS"}],"footer.discover.1":[{"type":0,"value":"Rilis Perangkat Lunak"}],"footer.discover.2":[{"type":0,"value":"Hibah"}],"footer.discover.3":[{"type":0,"value":"FAQ"}],"footer.discover.4":[{"type":0,"value":"Mengeksplorasi"}],"footer.discover.5":[{"type":0,"value":"Dokumen"}],"footer.discover.title":[{"type":0,"value":"MENEMUKAN"}],"footer.ecosystem.1":[{"type":0,"value":"DApps"}],"footer.ecosystem.2":[{"type":0,"value":"Peta jalan"}],"footer.ecosystem.3":[{"type":0,"value":"wiki"}],"footer.ecosystem.4":[{"type":0,"value":"Ergo Undian"}],"footer.ecosystem.5":[{"type":0,"value":"Videocast"}],"footer.ecosystem.title":[{"type":0,"value":"EKOSISTEM"}],"footer.getErg.1":[{"type":0,"value":"Pertambangan"}],"footer.getErg.2":[{"type":0,"value":"Kalkulator Pertambangan"}],"footer.getErg.3":[{"type":0,"value":"Dompet"}],"footer.getErg.4":[{"type":0,"value":"Pertukaran"}],"footer.getErg.title":[{"type":0,"value":"DAPATKAN ERG"}],"footer.legal":[{"type":0,"value":"Hukum"}],"footer.news.title":[{"type":0,"value":"BERITA"}],"footer.privacyPolicy":[{"type":0,"value":"Kebijakan pribadi"}],"footer.weGotIt":[{"type":0,"value":"Kami mengerti!"}],"navigation.discover":[{"type":0,"value":"MENEMUKAN"}],"navigation.ecosystem":[{"type":0,"value":"EKOSISTEM"}],"navigation.ergoCommunity":[{"type":0,"value":"KOMUNITAS ERGO"}],"navigation.getErg":[{"type":0,"value":"DAPATKAN ERG"}],"navigation.moreContent":[{"type":0,"value":"Lebih banyak konten?"}],"pages.404.hero":[{"type":0,"value":"404 halaman tidak ditemukan."}],"pages.404.title":[{"type":0,"value":"Tidak ditemukan"}],"pages.blog.title":[{"type":0,"value":"Blog"}],"pages.community.title":[{"type":0,"value":"Komunitas"}],"pages.discover.title":[{"type":0,"value":"Menemukan"}],"pages.ecosystem.title":[{"type":0,"value":"Ekosistem"}],"pages.get-erg.title":[{"type":0,"value":"GetErg"}],"pages.home.title":[{"type":0,"value":"Rumah"}],"pages.legal.title":[{"type":0,"value":"Hukum"}],"pages.mobile-wallets":[{"type":0,"value":"Dompet Seluler"}],"pages.privacyPolicy.title":[{"type":0,"value":"Kebijakan pribadi"}]}');
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(4806);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/utils.js
var utils = __webpack_require__(680);
// EXTERNAL MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/utils.js
var lib_utils = __webpack_require__(5687);
// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/core.js
var core = __webpack_require__(6284);
// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/error.js
var error = __webpack_require__(8222);
// EXTERNAL MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js + 9 modules
var lib = __webpack_require__(6096);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/message.js





function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function (all, k) {
        all[k] = (0,tslib_es6/* __assign */.pi)({ timeZone: timeZone }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, opts1), opts2));
    return keys.reduce(function (all, k) {
        all[k] = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (opts1[k] || {})), (opts2[k] || {}));
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) {
        return f1;
    }
    var mfFormats = core/* IntlMessageFormat.formats */.C.formats;
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
}
function formatMessage(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0,lib_utils/* invariant */.kG)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = 
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages &&
        Object.prototype.hasOwnProperty.call(messages, id) &&
        messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) &&
        message.length === 1 &&
        message[0].type === lib/* TYPE.literal */.wD.literal) {
        return message[0].value;
    }
    // IMPORTANT: Hot path straight lookup for performance
    if (!values &&
        message &&
        typeof message === 'string' &&
        !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    }
    values = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultRichTextElements), (values || {}));
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') {
            return message;
        }
        if (!defaultMessage ||
            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale.
            onError(new error/* MissingTranslationError */.$6(messageDescriptor, locale));
        }
        if (defaultMessage) {
            try {
                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
                return formatter.format(values);
            }
            catch (e) {
                onError(new error/* MessageFormatError */.X9("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
                return typeof defaultMessage === 'string' ? defaultMessage : id;
            }
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0,tslib_es6/* __assign */.pi)({ formatters: state }, (opts || {})));
        return formatter.format(values);
    }
    catch (e) {
        onError(new error/* MessageFormatError */.X9("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) {
        try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        }
        catch (e) {
            onError(new error/* MessageFormatError */.X9("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
        }
    }
    if (typeof message === 'string') {
        return message;
    }
    if (typeof defaultMessage === 'string') {
        return defaultMessage;
    }
    return id;
}

// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/utils.js
var src_utils = __webpack_require__(2644);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/number.js


var NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = ((format &&
        (0,src_utils/* getNamedFormat */.TB)(formats, 'number', format, onError)) ||
        {});
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/error.js
var src_error = __webpack_require__(1050);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/relativeTime.js



var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function relativeTime_getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (!!format && (0,src_utils/* getNamedFormat */.TB)(formats, 'relative', format, onError)) || {};
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) { options = {}; }
    if (!unit) {
        unit = 'second';
    }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) {
        config.onError(new src_error/* FormatError */.u_("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    try {
        return relativeTime_getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/dateTime.js



var DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
];
function dateTime_getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (timeZone && { timeZone: timeZone })), (format && (0,src_utils/* getNamedFormat */.TB)(formats, type, format, onError)));
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
    }
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/plural.js



var PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    if (!Intl.PluralRules) {
        onError(new src_error/* FormatError */.u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    }
    catch (e) {
        onError(new error/* IntlFormatError */.Qe('Error formatting plural.', locale, e));
    }
    return 'other';
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/list.js




var LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style',
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) { options = {}; }
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
        var val = el.value;
        if (typeof val !== 'string') {
            all.push(val);
        }
        else if (typeof all[all.length - 1] === 'string') {
            all[all.length - 1] += val;
        }
        else {
            all.push(val);
        }
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) {
        onError(new src_error/* FormatError */.u_("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
            if (typeof v === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions)
            .formatToParts(serializedValues)
            .map(function (part) {
            return part.type === 'literal'
                ? part
                : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, part), { value: richValues_1[part.value] || part.value });
        });
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/displayName.js



var DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new src_error/* FormatError */.u_("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/create-intl.js










function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.onWarn &&
        config.defaultRichTextElements &&
        messagesContainString(config.messages || {})) {
        config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
    }
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
function createIntl(config, cache) {
    var formatters = (0,src_utils/* createFormatters */.ax)(cache);
    var resolvedConfig = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, src_utils/* DEFAULT_INTL_CONFIG */.Z0), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) {
            onError(new error/* InvalidConfigError */.OV("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    }
    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
        onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    verifyConfigMessages(resolvedConfig);
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, resolvedConfig), { formatters: formatters, formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), formatMessage: formatMessage.bind(null, resolvedConfig, formatters), $t: formatMessage.bind(null, resolvedConfig, formatters), formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat), formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/formatters.js
var formatters = __webpack_require__(1092);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/provider.js
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */






function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements,
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) {
        return values;
    }
    return Object.keys(values).reduce(function (acc, k) {
        var v = values[k];
        acc[k] = (0,formatters/* isFormatXMLElementFn */.Gt)(v)
            ? (0,utils/* assignUniqueKeysToParts */.dt)(v)
            : v;
        return acc;
    }, {});
}
var provider_formatMessage = function (config, formatters, descriptor, rawValues) {
    var rest = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        rest[_i - 4] = arguments[_i];
    }
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = formatMessage.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([config,
        formatters,
        descriptor,
        values], rest, false));
    if (Array.isArray(chunks)) {
        return react.Children.toArray(chunks);
    }
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
var provider_createIntl = function (_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0,tslib_es6/* __rest */._T)(_a, ["defaultRichTextElements"]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = createIntl((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, utils/* DEFAULT_INTL_CONFIG */.Z0), config), { defaultRichTextElements: defaultRichTextElements }), cache);
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, coreIntl), { formatMessage: provider_formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements,
        }, coreIntl.formatters) });
};
var IntlProvider = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0,src_utils/* createIntlCache */.Sn)();
        _this.state = {
            cache: _this.cache,
            intl: provider_createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props),
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function (props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0,utils/* shallowEqual */.wU)(prevConfig, config)) {
            return {
                intl: provider_createIntl(config, cache),
                prevConfig: config,
            };
        }
        return null;
    };
    IntlProvider.prototype.render = function () {
        (0,utils/* invariantIntlContext */.lq)(this.state.intl);
        return react.createElement(injectIntl/* Provider */.zt, { value: this.state.intl }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = utils/* DEFAULT_INTL_CONFIG */.Z0;
    return IntlProvider;
}(react.PureComponent));
/* harmony default export */ var provider = (IntlProvider);

// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.modern.js
var index_modern = __webpack_require__(425);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./pages/_app.tsx
/* provided dependency */ var process = __webpack_require__(4155);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




 // import French from "../content/compiled-locales/fr.json";
// import Hindi from "../content/compiled-locales/hi.json";






 // import Romanian from "../content/compiled-locales/ro.json";
// import Slovak from "../content/compiled-locales/sk.json";
// import Chinese from "../content/compiled-locales/zh.json";










function MyApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  var router = (0,next_router.useRouter)(); // Env-based switch to skip third-party during local and preview builds

  var isDev = false;
  var isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview';
  var skipThirdParty = isDev || isPreview; // Allow forcing Chatbase in dev/preview by setting NEXT_PUBLIC_ENABLE_CHATBASE=1

  var chatbaseOverride = process.env.NEXT_PUBLIC_ENABLE_CHATBASE === '1'; // Gate loading of third-party scripts until user interaction on mobile or load idle on desktop

  var _useState = (0,react.useState)(false),
      enableThirdParty = _useState[0],
      setEnableThirdParty = _useState[1];

  (0,react.useEffect)(function () {
    if (skipThirdParty) return;
    var isMobileLike =  true && typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;

    var enable = function enable() {
      return setEnableThirdParty(true);
    };

    if (isMobileLike) {
      var onFirstInteract = function onFirstInteract() {
        enable();
        window.removeEventListener('pointerdown', onFirstInteract);
        window.removeEventListener('touchstart', onFirstInteract);
        window.removeEventListener('click', onFirstInteract);
      };

      window.addEventListener('pointerdown', onFirstInteract, {
        once: true,
        passive: true
      });
      window.addEventListener('touchstart', onFirstInteract, {
        once: true,
        passive: true
      });
      window.addEventListener('click', onFirstInteract, {
        once: true,
        passive: true
      });
    } else {
      var onLoad = function onLoad() {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(function () {
            return setEnableThirdParty(true);
          });
        } else {
          setTimeout(function () {
            return setEnableThirdParty(true);
          }, 0);
        }

        window.removeEventListener('load', onLoad);
      };

      window.addEventListener('load', onLoad);
    }
  }, [skipThirdParty]);

  var handleRouteChange = function handleRouteChange(url) {
    if (false) {}
    var w = window;

    if (typeof w.gtag === 'function') {
      w.gtag('config', 'G-1XC1836VXN', {
        page_path: url
      });
    } else {
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push(['config', 'G-1XC1836VXN', {
        page_path: url
      }]);
    }
  };

  (0,react.useEffect)(function () {
    router.events.on('routeChangeComplete', handleRouteChange);
    return function () {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  var _ref2 = router.locale ? router.locale.split('-') : ['en'],
      _ref3 = _slicedToArray(_ref2, 1),
      shortLocale = _ref3[0];

  var messages = (0,react.useMemo)(function () {
    switch (shortLocale) {
      case 'en':
        return en_namespaceObject;
      // case 'es':
      //  return Spanish;

      case 'de':
        return de_namespaceObject;
      // case "fr":
      //   return French
      // case "hi":
      //   return Hindi

      case 'it':
        return it_namespaceObject;

      case 'tr':
        return tr_namespaceObject;
      // case 'pt':
      //  return Portuguese;

      case 'hu':
        return hu_namespaceObject;

      case 'cn':
        return cn_namespaceObject;

      case 'ru':
        return ru_namespaceObject;

      case 'id':
        return id_namespaceObject;
      // case "zh":
      //   return Chinese;

      default:
        return en_namespaceObject;
    }
  }, [shortLocale]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [enableThirdParty && !skipThirdParty && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        id: "gtag-src",
        src: "https://www.googletagmanager.com/gtag/js?id=G-YFEV1NQGXE",
        strategy: "lazyOnload"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        id: "gtag-init",
        strategy: "lazyOnload",
        dangerouslySetInnerHTML: {
          __html: "\n                window.dataLayer = window.dataLayer || [];\n                function gtag(){window.dataLayer.push(arguments);}\n                gtag('js', new Date());\n                gtag('config', 'G-YFEV1NQGXE', { page_path: window.location.pathname });\n              "
        }
      })]
    }), enableThirdParty && (!skipThirdParty || chatbaseOverride) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        id: "chatbase-config",
        strategy: "lazyOnload",
        dangerouslySetInnerHTML: {
          __html: "\n                window.chatbaseConfig = {\n                  chatbotId: \"zxB2uzZfYoHIpA98eTzgM\",\n                };\n              "
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        id: "zxB2uzZfYoHIpA98eTzgM",
        src: "https://www.chatbase.co/embed.min.js",
        strategy: "lazyOnload"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_modern/* ThemeProvider */.f, {
      attribute: "class",
      enableSystem: false,
      defaultTheme: "light",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(provider, {
        locale: shortLocale,
        messages: messages,
        onError: function onError() {
          return null;
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((dist_default()), {
          color: "#e74c3c"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Component, _objectSpread({}, pageProps))]
      })
    })]
  });
}

/* harmony default export */ var _app = (MyApp);

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(7870);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4831:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2717)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9898)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2189)


/***/ }),

/***/ 3457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var T=Object.create;var p=Object.defineProperty;var k=Object.getOwnPropertyDescriptor;var C=Object.getOwnPropertyNames;var N=Object.getPrototypeOf,v=Object.prototype.hasOwnProperty;var c=e=>p(e,"__esModule",{value:!0}),l=(e,r)=>p(e,"name",{value:r,configurable:!0});var $=(e,r)=>{for(var t in r)p(e,t,{get:r[t],enumerable:!0})},P=(e,r,t,a)=>{if(r&&typeof r=="object"||typeof r=="function")for(let s of C(r))!v.call(e,s)&&(t||s!=="default")&&p(e,s,{get:()=>r[s],enumerable:!(a=k(r,s))||a.enumerable});return e},m=(e,r)=>P(c(p(e!=null?T(N(e)):{},"default",!r&&e&&e.__esModule?{get:()=>e.default,enumerable:!0}:{value:e,enumerable:!0})),e),S=(e=>(r,t)=>e&&e.get(r)||(t=P(c({}),r,1),e&&e.set(r,t),t))(typeof WeakMap!="undefined"?new WeakMap:0);var E={};$(E,{default:()=>d});var i=m(__webpack_require__(1163)),n=m(__webpack_require__(4865)),o=m(__webpack_require__(5697)),f=m(__webpack_require__(7294));function d({color:e="#29D",startPosition:r=.3,stopDelayMs:t=200,height:a=3,showOnShallow:s=!0,options:h,nonce:y}){let u=null;f.useEffect(()=>(h&&n.configure(h),i.default.events.on("routeChangeStart",x),i.default.events.on("routeChangeComplete",g),i.default.events.on("routeChangeError",g),()=>{i.default.events.off("routeChangeStart",x),i.default.events.off("routeChangeComplete",g),i.default.events.off("routeChangeError",g)}),[]);let x=l((w,{shallow:b})=>{(!b||s)&&(n.set(r),n.start())},"routeChangeStart"),g=l((w,{shallow:b})=>{(!b||s)&&(u&&clearTimeout(u),u=setTimeout(()=>{n.done(!0)},t))},"routeChangeEnd");return f.createElement("style",{nonce:y},`
      #nprogress {
        pointer-events: none;
      }
      #nprogress .bar {
        background: ${e};
        position: fixed;
        z-index: 9999;
        top: 0;
        left: 0;
        width: 100%;
        height: ${a}px;
      }
      #nprogress .peg {
        display: block;
        position: absolute;
        right: 0px;
        width: 100px;
        height: 100%;
        box-shadow: 0 0 10px ${e}, 0 0 5px ${e};
        opacity: 1;
        -webkit-transform: rotate(3deg) translate(0px, -4px);
        -ms-transform: rotate(3deg) translate(0px, -4px);
        transform: rotate(3deg) translate(0px, -4px);
      }
      #nprogress .spinner {
        display: block;
        position: fixed;
        z-index: 1031;
        top: 15px;
        right: 15px;
      }
      #nprogress .spinner-icon {
        width: 18px;
        height: 18px;
        box-sizing: border-box;
        border: solid 2px transparent;
        border-top-color: ${e};
        border-left-color: ${e};
        border-radius: 50%;
        -webkit-animation: nprogresss-spinner 400ms linear infinite;
        animation: nprogress-spinner 400ms linear infinite;
      }
      .nprogress-custom-parent {
        overflow: hidden;
        position: relative;
      }
      .nprogress-custom-parent #nprogress .spinner,
      .nprogress-custom-parent #nprogress .bar {
        position: absolute;
      }
      @-webkit-keyframes nprogress-spinner {
        0% {
          -webkit-transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
        }
      }
      @keyframes nprogress-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `)}l(d,"NextNProgress");d.propTypes={color:o.string,startPosition:o.number,stopDelayMs:o.number,height:o.number,showOnShallow:o.bool,options:o.object,nonce:o.string};module.exports=S(E);0&&(0);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4865:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),

/***/ 4155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 2703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 4806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_y": function() { return /* binding */ Context; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__);




function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var IntlContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function (props) { return (React.createElement(IntlConsumer, null, function (intl) {
        var _a;
        if (enforceContext) {
            invariantIntlContext(intl);
        }
        var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
        return (React.createElement(WrappedComponent, __assign({}, props, intlProp, { ref: forwardRef ? props.forwardedRef : null })));
    })); };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) {
        return hoistNonReactStatics(React.forwardRef(function (props, ref) { return (React.createElement(WithIntl, __assign({}, props, { forwardedRef: ref }))); }), WrappedComponent);
    }
    return hoistNonReactStatics(WithIntl, WrappedComponent);
}


/***/ }),

/***/ 680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "dt": function() { return /* binding */ assignUniqueKeysToParts; },
/* harmony export */   "lq": function() { return /* binding */ invariantIntlContext; },
/* harmony export */   "wU": function() { return /* binding */ shallowEqual; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5687);
/* harmony import */ var _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2644);




function invariantIntlContext(intl) {
    (0,_formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(intl, '[React Intl] Could not find required `intl` object. ' +
        '<IntlProvider> needs to exist in the component ancestry.');
}
var DEFAULT_INTL_CONFIG = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_INTL_CONFIG */ .Z0), { textComponent: react__WEBPACK_IMPORTED_MODULE_0__.Fragment });
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] ||
            !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}


/***/ }),

/***/ 9921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(9921);
} else {}


/***/ }),

/***/ 655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 2587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 9499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(9898); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);